"use strict";
(self["webpackChunk"] = self["webpackChunk"] || []).push([[555],{

/***/ 99659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(56187);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(38690);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(89228);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(26031);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(84159);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__(35659);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91270);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(66066);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(44901);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(13227);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(89034);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(88646);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(95822);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(48949);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__(81970);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(11908);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.number.is-finite.js
var es_number_is_finite = __webpack_require__(64528);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.number.to-fixed.js
var es_number_to_fixed = __webpack_require__(48914);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(62659);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(39574);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(3127);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(43908);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(81414);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(37666);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(36763);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(59139);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(54134);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(14011);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(81597);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(86651);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.weak-map.js
var es_weak_map = __webpack_require__(84750);
// EXTERNAL MODULE: ../node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(11431);
// EXTERNAL MODULE: ./snippets/original-main-product/gallery/index.js + 2 modules
var gallery = __webpack_require__(60436);
// EXTERNAL MODULE: ./snippets/original-main-product/variants/index.js
var variants = __webpack_require__(29761);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(2663);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(96626);
// EXTERNAL MODULE: ./utils/dayjs.js
var dayjs = __webpack_require__(13931);
// EXTERNAL MODULE: ./utils/event-handler.js
var event_handler = __webpack_require__(25675);
// EXTERNAL MODULE: ./utils/impression-tracking.js
var impression_tracking = __webpack_require__(85097);
;// CONCATENATED MODULE: ./snippets/original-main-product/logistics-aging/index.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

























function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var init = function init() {
  var _LogisticsAging;
  if (customElements.get('logistics-aging')) {
    return;
  }
  customElements.define('logistics-aging', (_LogisticsAging = /*#__PURE__*/function (_HTMLElement) {
    function LogisticsAging() {
      _classCallCheck(this, LogisticsAging);
      return _callSuper(this, LogisticsAging, arguments);
    }
    _inherits(LogisticsAging, _HTMLElement);
    return _createClass(LogisticsAging, [{
      key: "handleShowMore",
      value: function handleShowMore() {
        var modalElement = this.querySelector('.logistics-aging-modal-wrapper');
        modalElement.setAttribute('open', 'true');
      }
    }, {
      key: "handleResetDate",
      value: function handleResetDate() {
        var _this$getAttribute, _this$getAttribute2;
        // 获取当前日期
        var currentDate = (0,dayjs/* default */.ZP)();
        var startDay = Number((_this$getAttribute = this.getAttribute('start-day')) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : 0);
        var endDay = Number((_this$getAttribute2 = this.getAttribute('end-day')) !== null && _this$getAttribute2 !== void 0 ? _this$getAttribute2 : 0);

        // 计算新日期
        var startDate = currentDate;
        var endDate = currentDate;
        var countStartDays = 0;
        var countEndDays = 0;
        while (countStartDays < startDay) {
          startDate = startDate.add(1, 'day');
          if (![0, 6].includes(startDate.day())) {
            countStartDays++;
          }
        }
        while (countEndDays < endDay) {
          endDate = endDate.add(1, 'day');
          if (![0, 6].includes(endDate.day())) {
            countEndDays++;
          }
        }
        this.querySelector('.product-cell-info__value').innerHTML = "".concat(startDate.format('ddd,MMM.DD'), " - ").concat(endDate.format('ddd,MMM.DD'));
      }
    }, {
      key: "handleResetTags",
      value: function handleResetTags() {
        var _this$querySelectorAl;
        var _iterator = _createForOfIteratorHelper((_this$querySelectorAl = this.querySelectorAll('.product-cell-tags')) !== null && _this$querySelectorAl !== void 0 ? _this$querySelectorAl : []),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _tagsElement = _step.value;
            _tagsElement.remove();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var tags = this.getAttribute('tags').split(',').filter(Boolean);
        if (!(tags !== null && tags !== void 0 && tags.length)) {
          return;
        }
        var tagsElement = document.createElement('div');
        tagsElement.classList.add('product-cell-tags');
        tagsElement.innerHTML = tags.map(function (item) {
          return "<div class=\"product-cell-tag\">".concat(item, "</div>");
        }).join('');
        this.querySelector('.product-cell-row__content').append(tagsElement);
      }
    }, {
      key: "getProductId",
      value: function getProductId() {
        var productInfo = document.querySelector('original-product-info');
        return productInfo.getAttribute('product-id');
      }
    }, {
      key: "getProperties",
      value: function getProperties(source) {
        var _window$dataLayer, _window$dataLayer$pus, _window$dataLayer2, _window$dataLayer2$pu;
        var parameters = {
          event: 'uaEvent',
          event_type: source,
          event_label: this.dataset.heading || 'none',
          product_id: this.getProductId()
        };
        (_window$dataLayer = window.dataLayer) === null || _window$dataLayer === void 0 || (_window$dataLayer$pus = _window$dataLayer.push) === null || _window$dataLayer$pus === void 0 || _window$dataLayer$pus.call(_window$dataLayer, {
          ecommerce: null
        });
        (_window$dataLayer2 = window.dataLayer) === null || _window$dataLayer2 === void 0 || (_window$dataLayer2$pu = _window$dataLayer2.push) === null || _window$dataLayer2$pu === void 0 || _window$dataLayer2$pu.call(_window$dataLayer2, parameters);
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this = this;
        if (this.classList.contains('clickable')) {
          (0,event_handler.on)('click', '.product-cell-wrapper', this.handleShowMore, {}, this);
        }
        (0,impression_tracking/* default */.Z)([this], function () {
          _this.getProperties('view_logistics_aging');
        });
        (0,event_handler.on)('click', 'logistics-aging', function () {
          _this.getProperties('click_logistics_aging');
        }, {}, this);
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name, oldValue, newValue) {
        if (['start-day', 'end-day'].includes(name)) {
          this.handleResetDate();
        }
        if (name === 'tags') {
          this.handleResetTags();
        }
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        (0,event_handler/* off */.S1)('click', '.product-cell-wrapper', this.handleShowMore, {}, this);
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement)), _defineProperty(_LogisticsAging, "observedAttributes", ['start-day', 'end-day', 'tags']), _LogisticsAging));
};
init();
;// CONCATENATED MODULE: ./snippets/original-main-product/shopping-security/index.js
function shopping_security_typeof(o) { "@babel/helpers - typeof"; return shopping_security_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, shopping_security_typeof(o); }
















function shopping_security_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function shopping_security_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, shopping_security_toPropertyKey(o.key), o); } }
function shopping_security_createClass(e, r, t) { return r && shopping_security_defineProperties(e.prototype, r), t && shopping_security_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function shopping_security_toPropertyKey(t) { var i = shopping_security_toPrimitive(t, "string"); return "symbol" == shopping_security_typeof(i) ? i : i + ""; }
function shopping_security_toPrimitive(t, r) { if ("object" != shopping_security_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != shopping_security_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function shopping_security_callSuper(t, o, e) { return o = shopping_security_getPrototypeOf(o), shopping_security_possibleConstructorReturn(t, shopping_security_isNativeReflectConstruct() ? Reflect.construct(o, e || [], shopping_security_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function shopping_security_possibleConstructorReturn(t, e) { if (e && ("object" == shopping_security_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return shopping_security_assertThisInitialized(t); }
function shopping_security_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function shopping_security_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && shopping_security_setPrototypeOf(t, e); }
function shopping_security_wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return shopping_security_wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !shopping_security_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return shopping_security_construct(t, arguments, shopping_security_getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), shopping_security_setPrototypeOf(Wrapper, t); }, shopping_security_wrapNativeSuper(t); }
function shopping_security_construct(t, e, r) { if (shopping_security_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && shopping_security_setPrototypeOf(p, r.prototype), p; }
function shopping_security_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (shopping_security_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function shopping_security_isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function shopping_security_setPrototypeOf(t, e) { return shopping_security_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, shopping_security_setPrototypeOf(t, e); }
function shopping_security_getPrototypeOf(t) { return shopping_security_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, shopping_security_getPrototypeOf(t); }



var shopping_security_init = function init() {
  if (customElements.get('shopping-security')) {
    return;
  }
  customElements.define('shopping-security', /*#__PURE__*/function (_HTMLElement) {
    function ShoppingSecurity() {
      shopping_security_classCallCheck(this, ShoppingSecurity);
      return shopping_security_callSuper(this, ShoppingSecurity, arguments);
    }
    shopping_security_inherits(ShoppingSecurity, _HTMLElement);
    return shopping_security_createClass(ShoppingSecurity, [{
      key: "handleShowMore",
      value: function handleShowMore() {
        var modalElement = this.querySelector('.shopping-security-modal-wrapper');
        modalElement.setAttribute('open', 'true');
      }
    }, {
      key: "getProductId",
      value: function getProductId() {
        var productInfo = document.querySelector('original-product-info');
        return productInfo.getAttribute('product-id');
      }
    }, {
      key: "getProperties",
      value: function getProperties(source) {
        var _window$dataLayer, _window$dataLayer$pus, _window$dataLayer2, _window$dataLayer2$pu;
        var parameters = {
          event: 'uaEvent',
          event_type: source,
          event_label: this.dataset.heading || 'none',
          product_id: this.getProductId()
        };
        (_window$dataLayer = window.dataLayer) === null || _window$dataLayer === void 0 || (_window$dataLayer$pus = _window$dataLayer.push) === null || _window$dataLayer$pus === void 0 || _window$dataLayer$pus.call(_window$dataLayer, {
          ecommerce: null
        });
        (_window$dataLayer2 = window.dataLayer) === null || _window$dataLayer2 === void 0 || (_window$dataLayer2$pu = _window$dataLayer2.push) === null || _window$dataLayer2$pu === void 0 || _window$dataLayer2$pu.call(_window$dataLayer2, parameters);
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this = this;
        // 这里用继承做会更好
        if (this.classList.contains('clickable')) {
          (0,event_handler.on)('click', '.product-cell-wrapper', this.handleShowMore, {}, this);
        }
        (0,impression_tracking/* default */.Z)([this], function () {
          _this.getProperties('view_shopping_security');
        });
        (0,event_handler.on)('click', 'shopping-security', function () {
          _this.getProperties('click_shopping_security');
        }, {}, this);
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name, oldValue, newValue) {}
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        (0,event_handler/* off */.S1)('click', '.product-cell-wrapper', this.handleShowMore, {}, this);
      }
    }]);
  }(/*#__PURE__*/shopping_security_wrapNativeSuper(HTMLElement)));
};
shopping_security_init();
// EXTERNAL MODULE: ../node_modules/copy-to-clipboard/index.js
var copy_to_clipboard = __webpack_require__(36012);
var copy_to_clipboard_default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard);
// EXTERNAL MODULE: ./api/discount-addon.js
var discount_addon = __webpack_require__(48849);
// EXTERNAL MODULE: ./snippets/product-label/create.js
var create = __webpack_require__(83050);
// EXTERNAL MODULE: ./snippets/figure-base/index.js
var figure_base = __webpack_require__(87205);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__(48316);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__(21413);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(33370);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(86028);
// EXTERNAL MODULE: ../node_modules/core-js/modules/esnext.string.replace-all.js
var esnext_string_replace_all = __webpack_require__(26956);
// EXTERNAL MODULE: ./utils/lodash.js
var lodash = __webpack_require__(31955);
// EXTERNAL MODULE: ./utils/html.js
var html = __webpack_require__(37750);
// EXTERNAL MODULE: ./utils/number-precision.js
var number_precision = __webpack_require__(69784);
;// CONCATENATED MODULE: ./snippets/product-block/create.js
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || create_unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function create_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = create_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function create_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return create_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? create_arrayLikeToArray(r, a) : void 0; } }
function create_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }






















/* eslint-disable unicorn/consistent-destructuring */




var divide = number_precision/* default */.Z.divide,
  minus = number_precision/* default */.Z.minus,
  times = number_precision/* default */.Z.times;
var DISCOUNTED_PRICE_GROUP_SIZE = 3;
var getAddOnPurchaseConfig = function getAddOnPurchaseConfig() {
  var configString = (0,html/* unescapeHtmlAttribute */.T)("");
  return configString.replaceAll('---', ' ').split('///').filter(Boolean);
};

/**
 * 向上取整到百分位（进一）
 * @param {number} value - 要处理的值
 * @returns {string} 格式化后的字符串，保留两位小数
 */
var ceilToCent = function ceilToCent(value) {
  var num = Number(value) || 0;
  var result = divide(Math.ceil(times(num, 100)), 100);
  return result.toFixed(2);
};
var getDiscountedPriceConfig = function getDiscountedPriceConfig(key) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DISCOUNTED_PRICE_GROUP_SIZE;
  var formatKey = key + 1;
  formatKey = formatKey === size ? 'basics' : "".concat(formatKey);
  switch (formatKey) {
    case 'basics':
      {
        return {
          discountDesignatedProduct: (0,html/* unescapeHtmlAttribute */.T)(""),
          discountThresholdAmountStr: "",
          discountModalCaption: "",
          discountTagIncludeWithoutDetailStr: (0,html/* unescapeHtmlAttribute */.T)(""),
          discountTagExcludeWithDetailStr: (0,html/* unescapeHtmlAttribute */.T)(""),
          discountTagLogic: "include_tag"
        };
      }
    case '1':
      {
        return {
          discountDesignatedProduct: (0,html/* unescapeHtmlAttribute */.T)(""),
          discountThresholdAmountStr: "",
          discountModalCaption: "",
          discountTagIncludeWithoutDetailStr: (0,html/* unescapeHtmlAttribute */.T)(""),
          discountTagExcludeWithDetailStr: (0,html/* unescapeHtmlAttribute */.T)("")
        };
      }
    case '2':
      {
        return {
          discountDesignatedProduct: (0,html/* unescapeHtmlAttribute */.T)(""),
          discountThresholdAmountStr: "",
          discountModalCaption: "",
          discountTagIncludeWithoutDetailStr: (0,html/* unescapeHtmlAttribute */.T)(""),
          discountTagExcludeWithDetailStr: (0,html/* unescapeHtmlAttribute */.T)("")
        };
      }
    default:
  }
};

/**
 * @param {object} props
 * @param {'PRODUCT_CARD' | 'PRODUCT_DETAIL'} [props.type]
 * @returns {[number, number, number]}
 */
var getPrice = function getPrice(props) {
  var _variant$price, _variant$compareAtPri;
  var product = props.product,
    variant = props.variant,
    forceOriginPrice = props.forceOriginPrice,
    _props$type = props.type,
    type = _props$type === void 0 ? 'PRODUCT_CARD' : _props$type;
  var variantPrice = Number(ceilToCent((variant === null || variant === void 0 || (_variant$price = variant.price) === null || _variant$price === void 0 ? void 0 : _variant$price.amount) || 0));
  var compareAtPrice = Number(ceilToCent((variant === null || variant === void 0 || (_variant$compareAtPri = variant.compareAtPrice) === null || _variant$compareAtPri === void 0 ? void 0 : _variant$compareAtPri.amount) || 0));
  if (forceOriginPrice) {
    return [variantPrice, compareAtPrice, 3];
  }

  // FD
  var discountLabelRateStr = (0,html/* unescapeHtmlAttribute */.T)("premaxbob,75%///44dwbob,75%///55DC,85%///long64,80%///---Combo,60%///outlet50,50%///bfhalf,50%///Long-OFF,90%///HB,75%///fv22,78%");
  var discountLabelRateList = discountLabelRateStr.replaceAll('---', ' ').split('///').filter(Boolean).reverse();
  if (discountLabelRateList.length > 0) {
    var _iterator = create_createForOfIteratorHelper(discountLabelRateList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        var _item$split = item.split(','),
          _item$split2 = _slicedToArray(_item$split, 2),
          _item$split2$ = _item$split2[0],
          discountLabel = _item$split2$ === void 0 ? '' : _item$split2$,
          discountRate = _item$split2[1];
        if (product.tags.includes(discountLabel.trim())) {
          var dealPrice = discountRate.includes('%') ? divide(times(variantPrice, discountRate.replace('%', '')), 100) : minus(variantPrice, discountRate);
          return [Math.max(0, Number(ceilToCent(dealPrice))), variantPrice, 1];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  // 加价购价优先级低于 FD
  var _iterator2 = create_createForOfIteratorHelper(getAddOnPurchaseConfig()),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _item2 = _step2.value;
      var _item2$split = _item2.split(','),
        _item2$split2 = _slicedToArray(_item2$split, 3),
        _item2$split2$ = _item2$split2[0],
        addOnLabel = _item2$split2$ === void 0 ? '' : _item2$split2$,
        addOnPrice = _item2$split2[2];
      if (addOnLabel.trim() && addOnPrice !== null && addOnPrice !== void 0 && addOnPrice.trim() && product.tags.includes(addOnLabel.trim())) {
        var formattedAddOnPrice = addOnPrice.trim();
        var formattedAddOnPriceValue = Number(ceilToCent(formattedAddOnPrice));
        if (formattedAddOnPriceValue > variantPrice) {
          continue;
        }
        return [Math.max(0, formattedAddOnPriceValue), variantPrice, 4];
      }
    }

    // 折后价
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  for (var _i = 0, _Object$entries = Object.entries(Array.from({
      length: DISCOUNTED_PRICE_GROUP_SIZE
    }).fill('empty')); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 1),
      groupIndex = _Object$entries$_i[0];
    var _getDiscountedPriceCo = getDiscountedPriceConfig(Number(groupIndex)),
      discountDesignatedProduct = _getDiscountedPriceCo.discountDesignatedProduct,
      discountThresholdAmountStr = _getDiscountedPriceCo.discountThresholdAmountStr,
      discountTagIncludeWithoutDetailStr = _getDiscountedPriceCo.discountTagIncludeWithoutDetailStr,
      discountTagExcludeWithDetailStr = _getDiscountedPriceCo.discountTagExcludeWithDetailStr,
      discountTagLogic = _getDiscountedPriceCo.discountTagLogic;
    var discountThresholdAmountList = discountThresholdAmountStr.replaceAll('---', ' ').split('///').filter(Boolean).reverse();
    var discountTagIncludeWithoutDetailList = discountTagIncludeWithoutDetailStr.split(',').filter(Boolean);
    var discountTagExcludeWithDetailList = discountTagExcludeWithDetailStr.split(',').filter(Boolean);
    var hasDiscountTag = product.tags.includes(discountDesignatedProduct);
    var isThresholdEmpty = discountThresholdAmountList.length === 0;
    if (isThresholdEmpty || discountTagLogic === 'exclude_tag' && hasDiscountTag || discountTagLogic === 'include_tag' && !hasDiscountTag || !discountTagLogic && !hasDiscountTag) {
      continue;
    }
    if (type === 'PRODUCT_CARD' && lodash/* default.intersection */.ZP.intersection(product.tags, discountTagIncludeWithoutDetailList).length === 0) {
      break;
    }
    if (type === 'PRODUCT_DETAIL' && lodash/* default.intersection */.ZP.intersection(product.tags, discountTagExcludeWithDetailList).length > 0) {
      break;
    }
    var _iterator3 = create_createForOfIteratorHelper(discountThresholdAmountList),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _item = _step3.value;
        var _item$split3 = _item.split(','),
          _item$split4 = _slicedToArray(_item$split3, 2),
          discountThreshold = _item$split4[0],
          _discountRate = _item$split4[1];
        if (minus(variantPrice, discountThreshold) > 0) {
          var _dealPrice = _discountRate.includes('%') ? divide(times(variantPrice, minus(100, _discountRate.replace('%', ''))), 100) : minus(variantPrice, _discountRate);
          return [Math.max(0, Number(ceilToCent(_dealPrice))), variantPrice, 2];
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  return [variantPrice, compareAtPrice, 3];
};
// EXTERNAL MODULE: ./ui/image-preview/index.js + 4 modules
var image_preview = __webpack_require__(34720);
// EXTERNAL MODULE: ./ui/modal/index.js + 5 modules
var modal = __webpack_require__(49968);
// EXTERNAL MODULE: ./utils/event-emitter.js
var event_emitter = __webpack_require__(81228);
;// CONCATENATED MODULE: ./sections/original-main-product/utils/add-on-hit.js
function add_on_hit_slicedToArray(r, e) { return add_on_hit_arrayWithHoles(r) || add_on_hit_iterableToArrayLimit(r, e) || add_on_hit_unsupportedIterableToArray(r, e) || add_on_hit_nonIterableRest(); }
function add_on_hit_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function add_on_hit_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return add_on_hit_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? add_on_hit_arrayLikeToArray(r, a) : void 0; } }
function add_on_hit_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function add_on_hit_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function add_on_hit_arrayWithHoles(r) { if (Array.isArray(r)) return r; }
















/**
 * 按 Shopify 后台顺序找到当前商品标签命中的第一条加价购配置。
 *
 * @param {object} properties 商品和配置行
 * @returns {string | undefined} 命中的原始配置行
 * @sideEffects 无
 */
var findMatchedAddOnPurchaseConfig = function findMatchedAddOnPurchaseConfig(_ref) {
  var product = _ref.product,
    configRows = _ref.configRows;
  var tags = Array.isArray(product === null || product === void 0 ? void 0 : product.tags) ? product.tags : [];
  var normalizedRows = Array.isArray(configRows) ? configRows : [];
  return normalizedRows.find(function (row) {
    var _String$split = String(row).split(','),
      _String$split2 = add_on_hit_slicedToArray(_String$split, 1),
      _String$split2$ = _String$split2[0],
      label = _String$split2$ === void 0 ? '' : _String$split2$;
    return tags.includes(label.trim());
  });
};

/**
 * 使用当前生效配置的折扣码匹配接口 hits。
 *
 * @param {object} properties 商品、配置行和接口 hits
 * @returns {object | undefined} 折扣码匹配的 hit
 * @sideEffects 无
 */
var findAddOnHitByMatchedConfig = function findAddOnHitByMatchedConfig(_ref2) {
  var _matchedConfig$split;
  var product = _ref2.product,
    configRows = _ref2.configRows,
    hits = _ref2.hits;
  var matchedConfig = findMatchedAddOnPurchaseConfig({
    product: product,
    configRows: configRows
  });
  var _ref3 = (_matchedConfig$split = matchedConfig === null || matchedConfig === void 0 ? void 0 : matchedConfig.split(',')) !== null && _matchedConfig$split !== void 0 ? _matchedConfig$split : [],
    _ref4 = add_on_hit_slicedToArray(_ref3, 2),
    _ref4$ = _ref4[1],
    discountCode = _ref4$ === void 0 ? '' : _ref4$;
  var normalizedDiscountCode = discountCode.trim().toUpperCase();
  var normalizedHits = Array.isArray(hits) ? hits : [];
  if (!normalizedDiscountCode) {
    return;
  }
  return normalizedHits.find(function (hit) {
    var _hit$discountCode;
    return String((_hit$discountCode = hit === null || hit === void 0 ? void 0 : hit.discountCode) !== null && _hit$discountCode !== void 0 ? _hit$discountCode : '').trim().toUpperCase() === normalizedDiscountCode;
  });
};
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.number.is-integer.js
var es_number_is_integer = __webpack_require__(77216);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(3379);
;// CONCATENATED MODULE: ./sections/original-main-product/utils/get-element-html.js
function get_element_html_slicedToArray(r, e) { return get_element_html_arrayWithHoles(r) || get_element_html_iterableToArrayLimit(r, e) || get_element_html_unsupportedIterableToArray(r, e) || get_element_html_nonIterableRest(); }
function get_element_html_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function get_element_html_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return get_element_html_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? get_element_html_arrayLikeToArray(r, a) : void 0; } }
function get_element_html_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function get_element_html_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function get_element_html_arrayWithHoles(r) { if (Array.isArray(r)) return r; }






























var ADD_ON_DISCOUNT_MODAL_TITLE = 'Add-on Item Deal';
var ADD_ON_REQUIREMENT_SCOPE_ALL = 'ALL';
var ADD_ON_MIN_REQUIREMENTS_QUANTITY = 'MIN_PURCHASE_QUANTITY';
var ADD_ON_MIN_REQUIREMENTS_AMOUNT = 'MIN_PURCHASE_AMOUNT';
var ADD_ON_QUANTITY_SINGULAR = 1;
var highlightAddOnThresholdValue = function highlightAddOnThresholdValue(value) {
  return "<span class=\"discount-modal__threshold-highlight\">".concat(value, "</span>");
};
var highlightAddOnThresholdPrice = function highlightAddOnThresholdPrice(price) {
  return highlightAddOnThresholdValue("R".concat(price));
};
var getAddOnThresholdCopyFallback = function getAddOnThresholdCopyFallback(dealPrice) {
  return "Add this item for ".concat(highlightAddOnThresholdPrice(dealPrice), " when your cart qualifies.");
};
var formatAddOnThresholdAmount = function formatAddOnThresholdAmount(value) {
  var amount = Number(value);
  if (!Number.isFinite(amount) || amount < 0) {
    return '';
  }
  return Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
};

/**
 * 按接口门槛生成折扣码旁英文文案。
 *
 * @description 件数门槛用 minPurchaseQuantity，金额门槛用 minPurchaseAmount；ALL 为任意商品，其它为指定商品。加购价用当前折后价。
 * @param {object} properties - 包含 addOnHit 和 dealPrice。
 * @returns {string} 展示文案
 * @sideEffects 无
 * @example
 * getAddOnThresholdCopy({ addOnHit, dealPrice: '19.80' })
 */
var getAddOnThresholdCopy = function getAddOnThresholdCopy(_ref) {
  var _addOnHit$addonConfig;
  var addOnHit = _ref.addOnHit,
    dealPrice = _ref.dealPrice;
  if (!addOnHit) {
    return getAddOnThresholdCopyFallback(dealPrice);
  }
  var isAnyScope = ((_addOnHit$addonConfig = addOnHit.addonConfig) === null || _addOnHit$addonConfig === void 0 ? void 0 : _addOnHit$addonConfig.requirementScopeType) === ADD_ON_REQUIREMENT_SCOPE_ALL;
  if (addOnHit.minRequirementsType === ADD_ON_MIN_REQUIREMENTS_QUANTITY) {
    var _addOnHit$minPurchase, _addOnHit$addonConfig2;
    var quantity = Number((_addOnHit$minPurchase = addOnHit.minPurchaseQuantity) !== null && _addOnHit$minPurchase !== void 0 ? _addOnHit$minPurchase : (_addOnHit$addonConfig2 = addOnHit.addonConfig) === null || _addOnHit$addonConfig2 === void 0 ? void 0 : _addOnHit$addonConfig2.requirementValue);
    if (quantity === ADD_ON_QUANTITY_SINGULAR) {
      return isAnyScope ? "Buy any item, add this for ".concat(highlightAddOnThresholdPrice(dealPrice)) : "Buy a selected item, add this for ".concat(highlightAddOnThresholdPrice(dealPrice));
    }
    if (quantity > ADD_ON_QUANTITY_SINGULAR) {
      return isAnyScope ? "Buy any ".concat(highlightAddOnThresholdValue(quantity), " items, add this for ").concat(highlightAddOnThresholdPrice(dealPrice)) : "Buy ".concat(highlightAddOnThresholdValue(quantity), " selected items, add this for ").concat(highlightAddOnThresholdPrice(dealPrice));
    }
    return getAddOnThresholdCopyFallback(dealPrice);
  }
  if (addOnHit.minRequirementsType === ADD_ON_MIN_REQUIREMENTS_AMOUNT) {
    var _addOnHit$minPurchase2, _addOnHit$addonConfig3;
    var amount = formatAddOnThresholdAmount((_addOnHit$minPurchase2 = addOnHit.minPurchaseAmount) !== null && _addOnHit$minPurchase2 !== void 0 ? _addOnHit$minPurchase2 : (_addOnHit$addonConfig3 = addOnHit.addonConfig) === null || _addOnHit$addonConfig3 === void 0 ? void 0 : _addOnHit$addonConfig3.requirementValue);
    if (!amount) {
      return getAddOnThresholdCopyFallback(dealPrice);
    }
    return isAnyScope ? "Spend ".concat(highlightAddOnThresholdPrice(amount), ", add this for ").concat(highlightAddOnThresholdPrice(dealPrice)) : "Spend ".concat(highlightAddOnThresholdPrice(amount), " on selected items, add this for ").concat(highlightAddOnThresholdPrice(dealPrice));
  }
  return getAddOnThresholdCopyFallback(dealPrice);
};

/**
 * 生成加价购折扣弹窗 loading 骨架。
 *
 * @description 渲染带标题和关闭按钮的弹窗，内容区仅展示 mec-spin。
 * @returns {string} 弹窗 HTML
 * @sideEffects 无
 * @example
 * getAddOnDiscountModalLoadingHtml()
 */
var getAddOnDiscountModalLoadingHtml = function getAddOnDiscountModalLoadingHtml() {
  return /* html */"\n    <div class=\"discount-modal discount-modal--add-on\">\n      <div class=\"discount-modal__header\">\n        <span class=\"discount-modal__title\">".concat(ADD_ON_DISCOUNT_MODAL_TITLE, "</span>\n        <svg class=\"mec-icon discount-modal__close\" aria-hidden=\"true\">\n          <use xlink:href=\"#mec-guanbi1\"></use>\n        </svg>\n      </div>\n      <div class=\"discount-modal__content discount-modal__content--loading\">\n        <mec-spin spinning=\"true\"></mec-spin>\n      </div>\n    </div>\n  ");
};
var getDicountElementHtml = function getDicountElementHtml(properties) {
  var priceType = properties.priceType,
    dealPrice = properties.dealPrice,
    variantPrice = properties.variantPrice,
    product = properties.product,
    webActivityUrl = properties.webActivityUrl,
    addOnHit = properties.addOnHit;
  var diffPrice = number_precision/* default */.Z.minus(Number(variantPrice), Number(dealPrice));
  var title;
  var fDTipsHtml = '';
  var discountedSelectedHtml = '';
  var discountedMoreHtml = '';
  switch (priceType) {
    // FD
    case 1:
      {
        title = "Special Deal. Don’t Wait!";
        fDTipsHtml = /* html */"\n        <div class=\"discount-modal__tips\">\n          Automatic discount,no code needed! Not combinable with other\n          offers!\n        </div>\n      ";
        break;
      }

    // 折后
    case 2:
      {
        var DISCOUNTED_PRICE_GROUP_SIZE = 3;
        var discountThresholdAmountList = [];
        for (var _i = 0, _Object$entries = Object.entries(Array.from({
            length: DISCOUNTED_PRICE_GROUP_SIZE
          }).fill('empty')); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = get_element_html_slicedToArray(_Object$entries[_i], 1),
            groupIndex = _Object$entries$_i[0];
          var _getDiscountedPriceCo = getDiscountedPriceConfig(+groupIndex),
            discountDesignatedProduct = _getDiscountedPriceCo.discountDesignatedProduct,
            discountThresholdAmountString = _getDiscountedPriceCo.discountThresholdAmountStr,
            discountedPriceTitle = _getDiscountedPriceCo.discountModalCaption,
            discountTagExcludeWithDetailStr = _getDiscountedPriceCo.discountTagExcludeWithDetailStr,
            discountTagLogic = _getDiscountedPriceCo.discountTagLogic;
          var _discountThresholdAmountList = discountThresholdAmountString.replaceAll('---', ' ').split('///').filter(Boolean);
          var discountTagExcludeWithDetailList = discountTagExcludeWithDetailStr.split(',').filter(Boolean);
          var hasDiscountTag = product.tags.includes(discountDesignatedProduct);
          var isThresholdEmpty = _discountThresholdAmountList.length === 0;
          if (isThresholdEmpty || discountTagLogic === 'exclude_tag' && hasDiscountTag || discountTagLogic === 'include_tag' && !hasDiscountTag || !discountTagLogic && !hasDiscountTag) {
            continue;
          }

          // 取商品标签和商详不显示折扣的商品标签，如果不为空，不展示折后价
          if (lodash/* default.intersection */.ZP.intersection(product.tags, discountTagExcludeWithDetailList).length > 0) {
            break;
          }
          title = discountedPriceTitle;
          discountThresholdAmountList = _discountThresholdAmountList;
          break;
        }
        var dicountedRowsHtml = '';
        for (var _i2 = 0, _Object$entries2 = Object.entries(discountThresholdAmountList); _i2 < _Object$entries2.length; _i2++) {
          var _discountThresholdAmo, _discountThresholdAmo2, _discountThresholdAmo3;
          var _Object$entries2$_i = get_element_html_slicedToArray(_Object$entries2[_i2], 2),
            index = _Object$entries2$_i[0],
            item = _Object$entries2$_i[1];
          var _item$split = item.split(','),
            _item$split2 = get_element_html_slicedToArray(_item$split, 3),
            discountThreshold = _item$split2[0],
            discountRate = _item$split2[1],
            discountCode = _item$split2[2];
          var discountPrice = discountRate.includes('%') ? discountRate : "R".concat(discountRate);
          var selected = variantPrice > discountThreshold && (Number(index) === discountThresholdAmountList.length - 1 || variantPrice <= ((_discountThresholdAmo = (_discountThresholdAmo2 = discountThresholdAmountList[Number(index) + 1]) === null || _discountThresholdAmo2 === void 0 || (_discountThresholdAmo3 = _discountThresholdAmo2.split) === null || _discountThresholdAmo3 === void 0 || (_discountThresholdAmo3 = _discountThresholdAmo3.call(_discountThresholdAmo2, ',')) === null || _discountThresholdAmo3 === void 0 ? void 0 : _discountThresholdAmo3[0]) !== null && _discountThresholdAmo !== void 0 ? _discountThresholdAmo : 0));
          if (selected) {
            discountedSelectedHtml = /* html */"\n            <div class=\"discount-modal__discount-wrapper\">\n              <div>\n                <div class=\"discount-modal__discount-info\">\n                  <span>GET</span>\n                  <span class=\"discount-modal--highlight\">".concat(discountPrice, "</span>\n                  <span>OFF</span>\n                </div>\n                <div class=\"discount-modal__discount-desc\">\n                  ").concat(Number(discountThreshold) ? "FOR ORDER OVER R".concat(discountThreshold) : 'FOR ANY ORDER', "\n                </div>\n              </div>\n              ").concat(discountCode ? /* html */"\n                    <div\n                      class=\"discount-modal__discount-code\"\n                      data-discount-code=\"".concat(discountCode, "\"\n                    >\n                      <span>CODE:").concat(discountCode, "</span>\n                      <svg class=\"mec-icon discount-modal__discount-code__icon\" aria-hidden=\"true\">\n                        <use xlink:href=\"#mec-fuzhicode\"></use>\n                      </svg>\n                    </div>\n                  ") : '', "\n            </div>\n          ");
          } else {
            dicountedRowsHtml = dicountedRowsHtml + /* html */"\n            <div class=\"discount-modal__discount-row\">\n              <div>\n                <div class=\"discount-modal__discount-row__info\">GET ".concat(discountPrice, " OFF</div>\n                <div class=\"discount-modal__discount-row__desc\">\n                  ").concat(Number(discountThreshold) ? "FOR ORDER OVER R".concat(discountThreshold) : 'FOR ANY ORDER', "\n                </div>\n              </div>\n              ").concat(discountCode ? /* html */"<div class=\"discount-modal__discount-row__code\">CODE:".concat(discountCode, "</div>") : '', "\n            </div>\n          ");
          }
        }
        discountedMoreHtml = /* html */"\n        ".concat(dicountedRowsHtml ? /* html */"\n              <div\n                more-discount\n                class=\"discount-modal__discount-more-wrapper\"\n              >\n                <div class=\"discount-modal__discount-divider\">\n                  <span class=\"discount-modal__discount-divider__text\"\n                    >MORE DISCOUNT</span\n                  >\n                </div>\n                <div class=\"discount-modal__discount-more\">\n                  ".concat(dicountedRowsHtml, "\n                </div>\n              </div>\n            ") : '', "\n        <div\n          discount-tips\n          class=\"discount-modal__footer\"\n        >\n          <div>\n            1.Estimated price is valid after applying the discount code.\n          </div>\n          <div>\n            2.The final price will be shown on the checkout page.\n          </div>\n        </div>\n      ");
        break;
      }
    case 4:
      {
        var _matchedConfig$split;
        title = ADD_ON_DISCOUNT_MODAL_TITLE;
        var matchedConfig = findMatchedAddOnPurchaseConfig({
          product: product,
          configRows: getAddOnPurchaseConfig()
        });
        var _ref2 = (_matchedConfig$split = matchedConfig === null || matchedConfig === void 0 ? void 0 : matchedConfig.split(',')) !== null && _matchedConfig$split !== void 0 ? _matchedConfig$split : [],
          _ref3 = get_element_html_slicedToArray(_ref2, 2),
          _ref3$ = _ref3[1],
          _discountCode = _ref3$ === void 0 ? '' : _ref3$;
        var addOnThresholdCopy = getAddOnThresholdCopy({
          addOnHit: addOnHit,
          dealPrice: dealPrice
        });
        if (_discountCode.trim()) {
          discountedSelectedHtml = /* html */"\n          <div class=\"discount-modal__discount-wrapper\">\n            <div class=\"discount-modal__discount-info\">\n              <span>".concat(addOnThresholdCopy, "</span>\n            </div>\n            <div\n              class=\"discount-modal__discount-code\"\n              data-discount-code=\"").concat(_discountCode.trim(), "\"\n            >\n              <span>CODE:").concat(_discountCode.trim(), "</span>\n              <svg class=\"mec-icon discount-modal__discount-code__icon\" aria-hidden=\"true\">\n                <use xlink:href=\"#mec-fuzhicode\"></use>\n              </svg>\n            </div>\n          </div>\n        ");
        }
        discountedMoreHtml = /* html */"\n        <div\n          discount-tips\n          class=\"discount-modal__footer\"\n        >\n          <div>\n            1.Estimated price is valid after applying the discount code.\n          </div>\n          <div>\n            2.The final price will be shown on the checkout page.\n          </div>\n        </div>\n      ";
        break;
      }
    default:
      {
        break;
      }
  }
  var resultHtml = /* html */"\n    <div class=\"discount-modal\">\n      <div class=\"discount-modal__header\">\n        <span class=\"discount-modal__title\">".concat(title, "</span>\n        <svg class=\"mec-icon discount-modal__close\" aria-hidden=\"true\">\n          <use xlink:href=\"#mec-guanbi1\"></use>\n        </svg>\n      </div>\n\n      <div class=\"discount-modal__content\">\n        <div\n          current-discount\n        >\n          <div class=\"discount-modal__caption-wrapper\">\n            <div class=\"discount-modal__caption\">CURRENT DISCOUNT</div>\n            ").concat(priceType === 4 && webActivityUrl ? "<a class=\"discount-modal__promotion\" href=\"".concat(webActivityUrl, "\" target=\"_blank\" rel=\"noopener noreferrer\">view promotion&gt;</a>") : '', "\n          </div>\n          <div class=\"discount-modal__group\">\n            <div class=\"discount-modal__col\">\n              <div class=\"discount-modal__col__price discount-modal--highlight\">\n                R").concat(dealPrice, "\n              </div>\n              <div class=\"discount-modal__col__desc\">Price After Discount</div>\n            </div>\n            <div class=\"discount-modal__col\">\n              <div class=\"discount-modal__col__split\">=</div>\n            </div>\n            <div class=\"discount-modal__col\">\n              <div class=\"discount-modal__col__price\">\n                R").concat(variantPrice, "\n              </div>\n              <div class=\"discount-modal__col__desc\">Current Price</div>\n            </div>\n            <div class=\"discount-modal__col\">\n              <div class=\"discount-modal__col__split\">\u2014</div>\n            </div>\n            <div class=\"discount-modal__col\">\n              <div class=\"discount-modal__col__price discount-modal--highlight\">\n                R").concat(diffPrice, "\n              </div>\n              <div class=\"discount-modal__col__desc\">\n                ").concat(priceType === 1 ? 'Automatic Discount' : 'Apply Discount', "\n              </div>\n            </div>\n          </div>\n          <!-- FDtips -->\n          ").concat(fDTipsHtml, "\n           <!-- discountedSelected -->\n          ").concat(discountedSelectedHtml, "\n        </div>\n\n         <!-- discountedMore -->\n        ").concat(discountedMoreHtml, "\n      </div>\n    </div>\n  ");
  return resultHtml;
};
;// CONCATENATED MODULE: ./sections/original-main-product/utils/mutation-observer.js












function mutation_observer_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = mutation_observer_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function mutation_observer_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return mutation_observer_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? mutation_observer_arrayLikeToArray(r, a) : void 0; } }
function mutation_observer_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

var DEFAULT_CONFIG = {
  attributes: true,
  // 监听属性变化
  childList: true,
  // 监听子节点变化
  subtree: true // 监听整个子树中的节点变化
};
var mutationObserver = function mutationObserver(target, callback, config) {
  var _config = config !== null && config !== void 0 ? config : DEFAULT_CONFIG;
  var _debounceFunction = lodash/* default.debounce */.ZP.debounce(function (mutation, observer) {
    callback(mutation, observer);
  }, 33);

  // 创建一个新的 MutationObserver 实例
  var observer = new MutationObserver(function (mutationsList, observer) {
    var _iterator = mutation_observer_createForOfIteratorHelper(mutationsList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var mutation = _step.value;
        _debounceFunction(mutation, observer);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });

  // 开始观察目标节点
  observer.observe(target, _config);
  return observer;
};
;// CONCATENATED MODULE: ./sections/original-main-product/index.js
function original_main_product_typeof(o) { "@babel/helpers - typeof"; return original_main_product_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, original_main_product_typeof(o); }
function original_main_product_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function original_main_product_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, original_main_product_toPropertyKey(o.key), o); } }
function original_main_product_createClass(e, r, t) { return r && original_main_product_defineProperties(e.prototype, r), t && original_main_product_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function original_main_product_callSuper(t, o, e) { return o = original_main_product_getPrototypeOf(o), original_main_product_possibleConstructorReturn(t, original_main_product_isNativeReflectConstruct() ? Reflect.construct(o, e || [], original_main_product_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function original_main_product_possibleConstructorReturn(t, e) { if (e && ("object" == original_main_product_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return original_main_product_assertThisInitialized(t); }
function original_main_product_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function original_main_product_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && original_main_product_setPrototypeOf(t, e); }
function original_main_product_wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return original_main_product_wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !original_main_product_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return original_main_product_construct(t, arguments, original_main_product_getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), original_main_product_setPrototypeOf(Wrapper, t); }, original_main_product_wrapNativeSuper(t); }
function original_main_product_construct(t, e, r) { if (original_main_product_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && original_main_product_setPrototypeOf(p, r.prototype), p; }
function original_main_product_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (original_main_product_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function original_main_product_isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function original_main_product_setPrototypeOf(t, e) { return original_main_product_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, original_main_product_setPrototypeOf(t, e); }
function original_main_product_getPrototypeOf(t) { return original_main_product_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, original_main_product_getPrototypeOf(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function original_main_product_defineProperty(e, r, t) { return (r = original_main_product_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function original_main_product_toPropertyKey(t) { var i = original_main_product_toPrimitive(t, "string"); return "symbol" == original_main_product_typeof(i) ? i : i + ""; }
function original_main_product_toPrimitive(t, r) { if ("object" != original_main_product_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != original_main_product_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function original_main_product_slicedToArray(r, e) { return original_main_product_arrayWithHoles(r) || original_main_product_iterableToArrayLimit(r, e) || original_main_product_unsupportedIterableToArray(r, e) || original_main_product_nonIterableRest(); }
function original_main_product_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function original_main_product_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function original_main_product_arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function original_main_product_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = original_main_product_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function original_main_product_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return original_main_product_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? original_main_product_arrayLikeToArray(r, a) : void 0; } }
function original_main_product_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
















































var PACK_DAY = 1;
var PRICE_TYPE_ADD_ON = 4;
var ADD_ON_DISCOUNT_MODAL_SUBSCRIBE_KEY = 'original-main-product-addon-discount-modal';
var DISCOUNT_TIPS_CLICK_BOUND = Symbol.for('stc-original-main-product-discount-tips-click-bound');
var toFiniteNumber = function toFiniteNumber(value) {
  if (value === undefined || value === null || value === '') {
    return null;
  }
  var number = Number(value);
  return Number.isFinite(number) ? number : null;
};

/**
 * 从折扣入口读取商品详情数据。
 *
 * @description 不依赖 original-product-info 实例方法，兼容旧组件已经注册的页面。
 * @param {HTMLElement} tipsElement - 折扣入口节点
 * @returns {object|null} 商品 JSON 数据
 */
var readProductInfoFromTips = function readProductInfoFromTips(tipsElement) {
  var _host$querySelector, _window$dataObject, _host$querySelector2;
  var host = tipsElement.closest('original-product-info');
  var productId = host === null || host === void 0 ? void 0 : host.getAttribute('product-id');
  if (!productId) {
    return null;
  }
  var productElement = (_host$querySelector = host.querySelector("#ProductJson-".concat(productId))) !== null && _host$querySelector !== void 0 ? _host$querySelector : document.getElementById("ProductJson-".concat(productId));
  var product = null;
  if (productElement !== null && productElement !== void 0 && productElement.textContent) {
    try {
      product = JSON.parse(productElement.textContent);
    } catch (_unused) {
      return null;
    }
  } else if ((_window$dataObject = window.dataObject) !== null && _window$dataObject !== void 0 && _window$dataObject.variants && String(window.dataObject.id) === String(productId)) {
    product = window.dataObject;
  }
  if (!product) {
    return null;
  }
  var inventoryElement = (_host$querySelector2 = host.querySelector("#ProductVariantInventory-".concat(productId))) !== null && _host$querySelector2 !== void 0 ? _host$querySelector2 : document.getElementById("ProductVariantInventory-".concat(productId));
  if (inventoryElement !== null && inventoryElement !== void 0 && inventoryElement.textContent) {
    try {
      var _product$variants;
      var inventoryMap = JSON.parse(inventoryElement.textContent);
      var _iterator = original_main_product_createForOfIteratorHelper((_product$variants = product.variants) !== null && _product$variants !== void 0 ? _product$variants : []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var variant = _step.value;
          var inventoryQuantity = inventoryMap[String(variant.id)];
          if (inventoryQuantity !== undefined) {
            variant.inventory_quantity = inventoryQuantity;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } catch (_unused2) {
      // 库存数据异常不影响折扣弹窗展示。
    }
  }
  return product;
};

/**
 * 等待商品 JSON 可用。
 *
 * @param {HTMLElement} tipsElement - 折扣入口节点
 * @param {number} [timeout=1500] - 最长等待时间（毫秒）
 * @returns {Promise<object|null>} 商品 JSON 数据
 */
var waitForProductInfoFromTips = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(tipsElement) {
    var timeout,
      startedAt,
      product,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          timeout = _args.length > 1 && _args[1] !== undefined ? _args[1] : 1500;
          startedAt = Date.now();
          product = readProductInfoFromTips(tipsElement);
        case 1:
          if (!(!product && Date.now() - startedAt < timeout)) {
            _context.n = 3;
            break;
          }
          _context.n = 2;
          return new Promise(function (resolve) {
            window.setTimeout(resolve, 50);
          });
        case 2:
          product = readProductInfoFromTips(tipsElement);
          _context.n = 1;
          break;
        case 3:
          return _context.a(2, product);
      }
    }, _callee);
  }));
  return function waitForProductInfoFromTips(_x) {
    return _ref.apply(this, arguments);
  };
}();
var bindStandaloneDiscountModalEvents = function bindStandaloneDiscountModalEvents(discountModal) {
  var modalNode = discountModal.node;
  if (!modalNode) {
    return;
  }
  modalNode.addEventListener('click', function (event) {
    var _event$target, _event$target$closest, _event$target2, _event$target2$closes, _window$publicCompone, _window$publicCompone2;
    var codeElement = (_event$target = event.target) === null || _event$target === void 0 || (_event$target$closest = _event$target.closest) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.call(_event$target, '.discount-modal__discount-code');
    var closeElement = (_event$target2 = event.target) === null || _event$target2 === void 0 || (_event$target2$closes = _event$target2.closest) === null || _event$target2$closes === void 0 ? void 0 : _event$target2$closes.call(_event$target2, '.discount-modal__close');
    if (closeElement && modalNode.contains(closeElement)) {
      event.preventDefault();
      event.stopPropagation();
      if (discountModal.modalType === 'CUSTOM_ELEMENTS_MODAL') {
        discountModal.setAttribute('open', 'false');
      } else {
        discountModal.close();
      }
      return;
    }
    if (!codeElement || !modalNode.contains(codeElement)) {
      return;
    }
    var discountCode = codeElement.dataset.discountCode;
    if (!discountCode) {
      return;
    }
    copy_to_clipboard_default()(discountCode);
    (_window$publicCompone = window.publicComponents) === null || _window$publicCompone === void 0 || (_window$publicCompone2 = _window$publicCompone.messageOpen) === null || _window$publicCompone2 === void 0 || _window$publicCompone2.call(_window$publicCompone, {
      type: 'success',
      content: 'Successfully copied'
    });
  });
};

/**
 * 打开商详静态折扣弹窗，并绑定折扣码复制与关闭事件。
 * @param {HTMLElement & { node?: HTMLElement, close: Function }} discountModal
 * @returns {void}
 */
var openNativeDiscountModal = function openNativeDiscountModal(discountModal) {
  discountModal.setAttribute('open', 'true');
  bindStandaloneDiscountModalEvents(discountModal);
};

/**
 * 折扣入口使用文档级事件委托。
 *
 * @description 线上可能已由旧版 original-product-info 注册 custom element，导致新实例方法不可用；FD/折后入口因此不能依赖实例监听。
 * @returns {void}
 */
var bindDiscountTipsClickDelegation = function bindDiscountTipsClickDelegation() {
  if (document[DISCOUNT_TIPS_CLICK_BOUND]) {
    return;
  }
  var discountModalPending = false;
  document.addEventListener('click', /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
      var _event$target3, _event$target3$closes, _tipsElement$dataset$, _tipsElement$closest, _tipsElement$closest$;
      var tipsElement, host, priceType, nativeDiscountModal, _window$dataLayer, _window$dataLayer$pus, _window$dataLayer2, _window$dataLayer2$pu, _window$dataLayer3, _window$dataLayer3$pu, _window$dataLayer4, _window$dataLayer4$pu, dealPrice, variantPrice, product, discountModal;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            tipsElement = (_event$target3 = event.target) === null || _event$target3 === void 0 || (_event$target3$closes = _event$target3.closest) === null || _event$target3$closes === void 0 ? void 0 : _event$target3$closes.call(_event$target3, '.main-product__price-wrapper__price-tips');
            if (tipsElement) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            host = tipsElement.closest('original-product-info');
            priceType = Number((_tipsElement$dataset$ = tipsElement.dataset.priceType) !== null && _tipsElement$dataset$ !== void 0 ? _tipsElement$dataset$ : host === null || host === void 0 ? void 0 : host.priceType); // 加价购仍由组件自身逻辑处理，避免覆盖已验证的加购流程。
            if ([1, 2].includes(priceType)) {
              _context2.n = 2;
              break;
            }
            return _context2.a(2);
          case 2:
            // 商详 section 已渲染乐米同款静态弹窗时直接打开，兼容旧版 business chunk。
            nativeDiscountModal = (_tipsElement$closest = tipsElement.closest('.price-area')) === null || _tipsElement$closest === void 0 || (_tipsElement$closest$ = _tipsElement$closest.querySelector) === null || _tipsElement$closest$ === void 0 ? void 0 : _tipsElement$closest$.call(_tipsElement$closest, '.discount-modal-wrapper');
            if (!nativeDiscountModal) {
              _context2.n = 3;
              break;
            }
            event.preventDefault();
            event.stopImmediatePropagation();
            openNativeDiscountModal(nativeDiscountModal);
            (_window$dataLayer = window.dataLayer) === null || _window$dataLayer === void 0 || (_window$dataLayer$pus = _window$dataLayer.push) === null || _window$dataLayer$pus === void 0 || _window$dataLayer$pus.call(_window$dataLayer, {
              ecommerce: null
            });
            (_window$dataLayer2 = window.dataLayer) === null || _window$dataLayer2 === void 0 || (_window$dataLayer2$pu = _window$dataLayer2.push) === null || _window$dataLayer2$pu === void 0 || _window$dataLayer2$pu.call(_window$dataLayer2, {
              event: 'uaEvent',
              event_type: 'Click_discount_details',
              ecommerce: {
                product_id: host === null || host === void 0 ? void 0 : host.getAttribute('product-id'),
                event_label: host !== null && host !== void 0 && host.closest('.inner') ? 'quick_add' : 'product_detail'
              }
            });
            return _context2.a(2);
          case 3:
            event.preventDefault();
            event.stopImmediatePropagation();
            if (!discountModalPending) {
              _context2.n = 4;
              break;
            }
            return _context2.a(2);
          case 4:
            discountModalPending = true;
            _context2.p = 5;
            dealPrice = toFiniteNumber(tipsElement.dataset.dealPrice);
            variantPrice = toFiniteNumber(tipsElement.dataset.variantPrice);
            if (!((dealPrice === null || variantPrice === null) && typeof (host === null || host === void 0 ? void 0 : host.handleResetPrice) === 'function')) {
              _context2.n = 7;
              break;
            }
            _context2.n = 6;
            return host.handleResetPrice();
          case 6:
            dealPrice = toFiniteNumber(host.dealPrice);
            variantPrice = toFiniteNumber(host.variantPrice);
          case 7:
            if (!(dealPrice === null || variantPrice === null)) {
              _context2.n = 8;
              break;
            }
            return _context2.a(2);
          case 8:
            _context2.n = 9;
            return waitForProductInfoFromTips(tipsElement);
          case 9:
            product = _context2.v;
            if (product) {
              _context2.n = 10;
              break;
            }
            return _context2.a(2);
          case 10:
            discountModal = new modal/* default */.Z({
              duration: 0,
              template: getDicountElementHtml({
                priceType: priceType,
                dealPrice: dealPrice.toFixed(2),
                variantPrice: variantPrice.toFixed(2),
                product: product,
                webActivityUrl: ''
              }),
              mask: 'true',
              'mobile-placement': 'bottom'
            });
            discountModal.create();
            bindStandaloneDiscountModalEvents(discountModal);
            (_window$dataLayer3 = window.dataLayer) === null || _window$dataLayer3 === void 0 || (_window$dataLayer3$pu = _window$dataLayer3.push) === null || _window$dataLayer3$pu === void 0 || _window$dataLayer3$pu.call(_window$dataLayer3, {
              ecommerce: null
            });
            (_window$dataLayer4 = window.dataLayer) === null || _window$dataLayer4 === void 0 || (_window$dataLayer4$pu = _window$dataLayer4.push) === null || _window$dataLayer4$pu === void 0 || _window$dataLayer4$pu.call(_window$dataLayer4, {
              event: 'uaEvent',
              event_type: 'Click_discount_details',
              ecommerce: {
                product_id: host === null || host === void 0 ? void 0 : host.getAttribute('product-id'),
                event_label: host !== null && host !== void 0 && host.closest('.inner') ? 'quick_add' : 'product_detail'
              }
            });
          case 11:
            _context2.p = 11;
            discountModalPending = false;
            return _context2.f(11);
          case 12:
            return _context2.a(2);
        }
      }, _callee2, null, [[5,, 11, 12]]);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), true);
  document[DISCOUNT_TIPS_CLICK_BOUND] = true;
};

/**
 * @description 从 variant title 解析定制工期天数
 * @param {string} string_ - variant title
 * @returns {number[]} 工期天数数组
 */
var shipsFlagDayFunction = function shipsFlagDayFunction(string_) {
  var match = string_.match(/(\d+)-day crafting|(\d+)-(\d+) days crafting/i);
  if (!match) return [];
  if (match[1]) {
    return [Number(match[1])];
  }
  if (match[2] && match[3]) {
    return [Number(match[2]), Number(match[3])];
  }
  return [];
};

/**
 * @description 根据变体配置，把变体选项渲染成图片卡片（与乐米一致）
 * @param {HTMLElement} rootEle - original-product-info 根节点
 * @param {Array} variantList - 变体信息（heteinfometa.variant_description）
 */
var _setupVariantImage = function setupVariantImage(rootEle, variantList) {
  if (!rootEle || !variantList || variantList.length === 0) return;
  var optionNameMap = new Map();
  var _iterator2 = original_main_product_createForOfIteratorHelper(variantList),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _optionNameMap$get;
      var variant = _step2.value;
      var optionValueMap = (_optionNameMap$get = optionNameMap.get(variant.optionName)) !== null && _optionNameMap$get !== void 0 ? _optionNameMap$get : new Map();
      optionValueMap.set(variant.value, variant);
      optionNameMap.set(variant.optionName, optionValueMap);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var variantImage = 'https://shop.luvmehair.com/cdn/shop/files/product-variant-option-name.png';
  var _iterator3 = original_main_product_createForOfIteratorHelper(optionNameMap),
    _step3;
  try {
    var _loop = function _loop() {
      var _step3$value = original_main_product_slicedToArray(_step3.value, 2),
        optionName = _step3$value[0],
        optionValueMap = _step3$value[1];
      var hasImage = false;
      var _iterator5 = original_main_product_createForOfIteratorHelper(optionValueMap.values()),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var optionInfo = _step5.value;
          if (optionInfo.image) {
            hasImage = true;
            break;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      if (hasImage) {
        var valueEleList = rootEle.querySelectorAll(".opt-label__text[data-option-name=\"".concat(optionName, "\"]"));
        var _iterator6 = original_main_product_createForOfIteratorHelper(valueEleList),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var valueEle = _step6.value;
            var option = optionValueMap.get(valueEle.dataset.optionValue);
            valueEle.innerHTML = "\n          <div class=\"variant-option\">\n            <div class=\"variant-option__image\">\n              ".concat((0,figure_base/* createFigureBase */.k)({
              source: option === null || option === void 0 ? void 0 : option.image,
              placeholder: variantImage
            }), "\n              <div class=\"variant-option__image__enlarge\">\n                <svg class=\"icon\" aria-hidden=\"true\">\n                  <use xlink:href=\"#mec-fangda\"></use>\n                </svg>\n              </div>\n            </div>\n            <div class=\"variant-option__info\">\n              <div class=\"variant-option__info__content\">\n                ").concat(valueEle.dataset.promotionImage ? "<span class=\"variant-option__promote-icon\"><img loading=\"lazy\" src=\"".concat(valueEle.dataset.promotionImage, "\" /></span>") : '', "\n                <span class=\"variant-option__value\">").concat(valueEle.dataset.optionValue, "</span>\n                ").concat(valueEle.dataset.promotionText ? "<span class=\"variant-option__promote-text\">(".concat(valueEle.dataset.promotionText, ")</span>") : '', "\n              </div>\n            </div>\n          </div>").trim();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
        if (valueEleList.length > 3) {
          var optionFieldsetEle = rootEle.querySelector(".option-selector-fieldset:has([data-option-name=\"".concat(optionName, "\"])"));
          if (!optionFieldsetEle) return 1; // continue
          var indicatorHtml = "<div class=\"scroll-indicator-left\"></div><div class=\"scroll-indicator-right\"></div>";
          optionFieldsetEle.insertAdjacentHTML('beforeend', indicatorHtml);
          var labelEle = optionFieldsetEle.querySelector('.opt-label');
          var leftIndicatorEle = optionFieldsetEle.querySelector('.scroll-indicator-left');
          var rightIndicatorEle = optionFieldsetEle.querySelector('.scroll-indicator-right');
          if (labelEle && leftIndicatorEle && rightIndicatorEle) {
            leftIndicatorEle.style.height = labelEle.clientHeight + 2 + 'px';
            rightIndicatorEle.style.height = labelEle.clientHeight + 2 + 'px';
          }
          var optionEle = optionFieldsetEle.querySelector('.option-selector__btns');
          if (optionEle && leftIndicatorEle && rightIndicatorEle) {
            optionEle.addEventListener('scroll', function () {
              if (optionEle.scrollLeft === 0) {
                if (leftIndicatorEle.style.visibility !== 'hidden') {
                  leftIndicatorEle.style.visibility = 'hidden';
                }
              } else if (leftIndicatorEle.style.visibility !== 'visible') {
                leftIndicatorEle.style.visibility = 'visible';
              }
              if (optionEle.scrollLeft + optionEle.clientWidth === optionEle.scrollWidth) {
                if (rightIndicatorEle.style.visibility !== 'hidden') {
                  rightIndicatorEle.style.visibility = 'hidden';
                }
              } else if (rightIndicatorEle.style.visibility !== 'visible') {
                rightIndicatorEle.style.visibility = 'visible';
              }
            });
          }
        }
      }
      var optionRowEle = rootEle.querySelector("fieldset.option-selector-fieldset .option-selector__btns:has([data-option-name=\"".concat(optionName, "\"])"));
      if (optionRowEle) {
        optionRowEle.insertAdjacentHTML('afterend', "<div class=\"variant-option-desc\" data-option-name=\"".concat(optionName, "\"></div>"));
      }
    };
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      if (_loop()) continue;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  (0,event_handler.on)('click', '.opt-label .variant-option__image', function (event) {
    var ele = event.currentTarget;
    if (!event.target.classList.contains('variant-option__image__enlarge')) {
      var labelEle = ele.closest('.opt-label');
      var inputEle = labelEle ? rootEle.querySelector("#".concat(labelEle.getAttribute('for'))) : null;
      if (!inputEle || !inputEle.checked) {
        return;
      }
    }
    var imgEle = ele.classList.contains('variant-option__image__enlarge') ? ele.parentElement.querySelector('img.mec-figure') : ele.querySelector('img.mec-figure');
    if (imgEle !== null && imgEle !== void 0 && imgEle.src) {
      (0,image_preview/* showImagePreview */.V)({
        images: [imgEle.src]
      });
    }
  }, {
    capture: true
  }, rootEle);
  var _iterator4 = original_main_product_createForOfIteratorHelper(rootEle.querySelectorAll('.variant-option__image__enlarge')),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var ele = _step4.value;
      ele.addEventListener('click', function (event) {
        event.stopPropagation();
        event.preventDefault();
      });
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
};

/**
 * @description 变体切换时同步变体描述
 * @param {HTMLElement} rootEle - original-product-info 根节点
 * @param {Array} infoList - 变体信息（heteinfometa.variant_description）
 */
var onVariantChange = function onVariantChange(rootEle, infoList) {
  if (!rootEle || !infoList || infoList.length === 0) return;
  var checkedEleList = rootEle.querySelectorAll('.opt-btn:checked + .opt-label  .opt-label__text');
  var _iterator7 = original_main_product_createForOfIteratorHelper(checkedEleList),
    _step7;
  try {
    var _loop2 = function _loop2() {
      var checkedEle = _step7.value;
      var optionName = checkedEle.dataset.optionName;
      var optionValue = checkedEle.dataset.optionValue;
      var info = infoList.find(function (it) {
        return it.optionName === optionName && it.value === optionValue;
      });
      var descEle = rootEle.querySelector(".variant-option-desc[data-option-name=\"".concat(optionName, "\"]"));
      if (!descEle) return 1; // continue
      if (info && info.description) {
        descEle.innerHTML = info.description;
        descEle.style.display = 'block';
      } else {
        descEle.style.display = 'none';
      }
    };
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      if (_loop2()) continue;
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }
};
var original_main_product_init = function init() {
  var _OriginalProductInfo, _customVariantInfo;
  if (customElements.get('original-product-info')) {
    return;
  }
  customElements.define('original-product-info', (_customVariantInfo = /*#__PURE__*/new WeakMap(), _OriginalProductInfo = /*#__PURE__*/function (_HTMLElement) {
    function OriginalProductInfo() {
      var _this;
      original_main_product_classCallCheck(this, OriginalProductInfo);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = original_main_product_callSuper(this, OriginalProductInfo, [].concat(args));
      _classPrivateFieldInitSpec(_this, _customVariantInfo, []);
      return _this;
    }
    original_main_product_inherits(OriginalProductInfo, _HTMLElement);
    return original_main_product_createClass(OriginalProductInfo, [{
      key: "getProductInfo",
      value: (
      /**
       * @description 获取商品 JSON 数据，并合并 Liquid 注入的库存字段
       * @param {boolean} [refresh=false] - 是否强制刷新缓存
       * @returns {Promise<object|null>} 商品数据
       */
      function () {
        var _getProductInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
          var refresh,
            _this$querySelector,
            _window$dataObject2,
            productId,
            productElement,
            inventoryElement,
            _this$productInfo$var,
            inventoryMap,
            _iterator8,
            _step8,
            variant,
            inventoryQuantity,
            _args3 = arguments,
            _t;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.p = _context3.n) {
              case 0:
                refresh = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;
                if (!(refresh || !this.productInfo)) {
                  _context3.n = 7;
                  break;
                }
                productId = this.getAttribute('product-id');
                productElement = (_this$querySelector = this.querySelector("#ProductJson-".concat(productId))) !== null && _this$querySelector !== void 0 ? _this$querySelector : document.querySelector("#ProductJson-".concat(productId));
                if (!(productElement !== null && productElement !== void 0 && productElement.textContent)) {
                  _context3.n = 4;
                  break;
                }
                _context3.p = 1;
                this.productInfo = JSON.parse(productElement.textContent);
                _context3.n = 3;
                break;
              case 2:
                _context3.p = 2;
                _t = _context3.v;
                return _context3.a(2, null);
              case 3:
                _context3.n = 6;
                break;
              case 4:
                if (!((_window$dataObject2 = window.dataObject) !== null && _window$dataObject2 !== void 0 && _window$dataObject2.variants && String(window.dataObject.id) === String(productId))) {
                  _context3.n = 5;
                  break;
                }
                // ProductJson 尚未解析完成时，兼容主题内联脚本已经暴露的商品数据。
                this.productInfo = window.dataObject;
                _context3.n = 6;
                break;
              case 5:
                return _context3.a(2, null);
              case 6:
                inventoryElement = this.querySelector("#ProductVariantInventory-".concat(productId));
                if (inventoryElement !== null && inventoryElement !== void 0 && inventoryElement.textContent) {
                  inventoryMap = JSON.parse(inventoryElement.textContent);
                  _iterator8 = original_main_product_createForOfIteratorHelper((_this$productInfo$var = this.productInfo.variants) !== null && _this$productInfo$var !== void 0 ? _this$productInfo$var : []);
                  try {
                    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                      variant = _step8.value;
                      inventoryQuantity = inventoryMap[String(variant.id)];
                      if (inventoryQuantity !== undefined) {
                        variant.inventory_quantity = inventoryQuantity;
                      }
                    }
                  } catch (err) {
                    _iterator8.e(err);
                  } finally {
                    _iterator8.f();
                  }
                }
              case 7:
                return _context3.a(2, this.productInfo);
            }
          }, _callee3, this, [[1, 2]]);
        }));
        function getProductInfo() {
          return _getProductInfo.apply(this, arguments);
        }
        return getProductInfo;
      }()
      /**
       * @description 等待 ProductJson 完成解析，避免首次点击时拿不到折扣状态
       * @param {number} [timeout=1500] - 最长等待时间（毫秒）
       * @returns {Promise<object|null>} 商品数据
       */
      )
    }, {
      key: "waitForProductInfo",
      value: (function () {
        var _waitForProductInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
          var timeout,
            startedAt,
            product,
            _args4 = arguments;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                timeout = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : 1500;
                startedAt = Date.now();
                _context4.n = 1;
                return this.getProductInfo();
              case 1:
                product = _context4.v;
              case 2:
                if (!(!product && Date.now() - startedAt < timeout)) {
                  _context4.n = 5;
                  break;
                }
                _context4.n = 3;
                return new Promise(function (resolve) {
                  window.setTimeout(resolve, 50);
                });
              case 3:
                _context4.n = 4;
                return this.getProductInfo();
              case 4:
                product = _context4.v;
                _context4.n = 2;
                break;
              case 5:
                return _context4.a(2, product);
            }
          }, _callee4, this);
        }));
        function waitForProductInfo() {
          return _waitForProductInfo.apply(this, arguments);
        }
        return waitForProductInfo;
      }()
      /**
       * @description 根据 variant 与主题配置更新物流时效
       * @returns {Promise<void>}
       */
      )
    }, {
      key: "handleResetLogisticsAging",
      value: (function () {
        var _handleResetLogisticsAging = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
          var _this2 = this;
          var logisticsAgingElement, product, currentVariant, startDay, endDay, logisticsAgingTags, content1, shipsFlagDay, _shipsFlagDay, previous, next, content2;
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                logisticsAgingElement = this.querySelector('logistics-aging');
                if (logisticsAgingElement) {
                  _context5.n = 1;
                  break;
                }
                return _context5.a(2);
              case 1:
                _context5.n = 2;
                return this.waitForProductInfo();
              case 2:
                product = _context5.v;
                if (product) {
                  _context5.n = 3;
                  break;
                }
                return _context5.a(2);
              case 3:
                currentVariant = product.variants.find(function (item) {
                  return item.id === Number(_this2.getAttribute('variant-id'));
                });
                if (!(currentVariant !== null && currentVariant !== void 0 && currentVariant.inventory_quantity)) {
                  _context5.n = 4;
                  break;
                }
                logisticsAgingElement.style.display = 'block';
                _context5.n = 5;
                break;
              case 4:
                logisticsAgingElement.style.display = 'none';
                return _context5.a(2);
              case 5:
                startDay = Number(logisticsAgingElement.getAttribute('default-start-day'));
                endDay = Number(logisticsAgingElement.getAttribute('default-end-day'));
                logisticsAgingTags = [];
                if (currentVariant.price / 100 >= 50) {
                  content1 = logisticsAgingElement.dataset['content-1'];
                  if (content1) {
                    logisticsAgingTags.push(content1);
                  }
                }
                shipsFlagDay = shipsFlagDayFunction(currentVariant.title);
                if (shipsFlagDay.length > 0) {
                  _shipsFlagDay = original_main_product_slicedToArray(shipsFlagDay, 2), previous = _shipsFlagDay[0], next = _shipsFlagDay[1];
                  if (next) {
                    startDay = startDay + previous - PACK_DAY;
                    endDay = endDay + next - PACK_DAY;
                  } else {
                    startDay = startDay + previous - PACK_DAY;
                    endDay = endDay + previous - PACK_DAY;
                  }
                } else {
                  content2 = logisticsAgingElement.dataset['content-2'];
                  if (content2) {
                    logisticsAgingTags.push(content2);
                  }
                }
                logisticsAgingElement.setAttribute('start-day', startDay);
                logisticsAgingElement.setAttribute('end-day', endDay);
                logisticsAgingElement.setAttribute('tags', logisticsAgingTags.join(','));
              case 6:
                return _context5.a(2);
            }
          }, _callee5, this);
        }));
        function handleResetLogisticsAging() {
          return _handleResetLogisticsAging.apply(this, arguments);
        }
        return handleResetLogisticsAging;
      }()
      /**
       * @description 根据当前 variant 与乐米价格配置更新商详价格状态
       * @returns {Promise<void>}
       */
      )
    }, {
      key: "handleResetPrice",
      value: (function () {
        var _handleResetPrice = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
          var _product$variants2;
          var product, variantId, currentVariant, _getPrice, _getPrice2, dealPrice, variantPrice, priceType, _priceArea$querySelec, priceArea, formatPrice, _iterator9, _step9, priceElement, originalPriceElement;
          return _regenerator().w(function (_context6) {
            while (1) switch (_context6.n) {
              case 0:
                _context6.n = 1;
                return this.waitForProductInfo();
              case 1:
                product = _context6.v;
                if (product) {
                  _context6.n = 2;
                  break;
                }
                return _context6.a(2);
              case 2:
                variantId = this.getCurrentVariantId(product);
                currentVariant = ((_product$variants2 = product === null || product === void 0 ? void 0 : product.variants) !== null && _product$variants2 !== void 0 ? _product$variants2 : []).find(function (item) {
                  return String(item.id) === String(variantId);
                });
                if (currentVariant) {
                  _context6.n = 3;
                  break;
                }
                this.dealPrice = undefined;
                this.variantPrice = undefined;
                this.priceType = undefined;
                return _context6.a(2, false);
              case 3:
                currentVariant = Object.assign({}, currentVariant, {
                  price: {
                    amount: currentVariant.price / 100
                  },
                  compareAtPrice: {
                    amount: currentVariant.compare_at_price / 100
                  }
                });
                _getPrice = getPrice({
                  product: product,
                  variant: currentVariant,
                  type: 'PRODUCT_DETAIL'
                }), _getPrice2 = original_main_product_slicedToArray(_getPrice, 3), dealPrice = _getPrice2[0], variantPrice = _getPrice2[1], priceType = _getPrice2[2];
                this.dealPrice = Number(dealPrice);
                this.variantPrice = Number(variantPrice);
                this.priceType = Number(priceType);
                this.setAttribute('current-price', this.dealPrice);
                this.setAttribute('original-price', this.variantPrice);
                this.setAttribute('price-type', this.priceType);
                if ([1, 2, 4].includes(this.priceType)) {
                  priceArea = this.querySelector('.variant-visibility-area .price-area');
                  formatPrice = function formatPrice(value) {
                    var _window$theme;
                    var formatter = (_window$theme = window.theme) === null || _window$theme === void 0 || (_window$theme = _window$theme.Shopify) === null || _window$theme === void 0 ? void 0 : _window$theme.formatMoney;
                    return typeof formatter === 'function' ? formatter(Math.round(Number(value) * 100), window.theme.money_format) : Number(value).toFixed(2);
                  };
                  _iterator9 = original_main_product_createForOfIteratorHelper((_priceArea$querySelec = priceArea === null || priceArea === void 0 ? void 0 : priceArea.querySelectorAll('.main-product__price-wrapper__price')) !== null && _priceArea$querySelec !== void 0 ? _priceArea$querySelec : []);
                  try {
                    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                      priceElement = _step9.value;
                      priceElement.textContent = formatPrice(this.dealPrice);
                    }
                  } catch (err) {
                    _iterator9.e(err);
                  } finally {
                    _iterator9.f();
                  }
                  originalPriceElement = priceArea === null || priceArea === void 0 ? void 0 : priceArea.querySelector('.main-product__price-wrapper__sub-price');
                  if (originalPriceElement) {
                    originalPriceElement.textContent = formatPrice(this.variantPrice);
                  }
                }
                this.ensureDiscountTipsVisible(variantId);
                if (String(this.getAttribute('variant-id')) !== String(variantId)) {
                  this.setAttribute('variant-id', variantId);
                }
                return _context6.a(2, true);
            }
          }, _callee6, this);
        }));
        function handleResetPrice() {
          return _handleResetPrice.apply(this, arguments);
        }
        return handleResetPrice;
      }()
      /**
       * @description 获取当前变体 ID，兼容商详初始化时 variant-id 为空的情况
       * @param {object} product - 商品 JSON 数据
       * @returns {string} 当前变体 ID
       */
      )
    }, {
      key: "getCurrentVariantId",
      value: function getCurrentVariantId(product) {
        var _this$querySelector2, _product$selected_or_, _product$variants3;
        var variantId = [(_this$querySelector2 = this.querySelector('[name="id"]')) === null || _this$querySelector2 === void 0 ? void 0 : _this$querySelector2.value, this.getAttribute('variant-id'), product === null || product === void 0 || (_product$selected_or_ = product.selected_or_first_available_variant) === null || _product$selected_or_ === void 0 ? void 0 : _product$selected_or_.id, product === null || product === void 0 || (_product$variants3 = product.variants) === null || _product$variants3 === void 0 || (_product$variants3 = _product$variants3[0]) === null || _product$variants3 === void 0 ? void 0 : _product$variants3.id].find(function (item) {
          return item !== null && item !== undefined && item !== '';
        });
        return variantId === undefined ? '' : String(variantId);
      }

      /**
       * @description 保证命中的折扣入口在当前价格区可见
       * @param {string} variantId - 当前变体 ID
       * @returns {void}
       */
    }, {
      key: "ensureDiscountTipsVisible",
      value: function ensureDiscountTipsVisible(variantId) {
        var _existingTips$dataset;
        var priceArea = this.querySelector('.variant-visibility-area .price-area');
        if (!priceArea) {
          return;
        }
        var existingTips = priceArea.querySelector('.main-product__price-wrapper__price-tips');
        var renderedPriceType = Number(existingTips === null || existingTips === void 0 || (_existingTips$dataset = existingTips.dataset) === null || _existingTips$dataset === void 0 ? void 0 : _existingTips$dataset.priceType);
        var currentPriceType = Number(this.priceType);
        var priceType = [1, 2, PRICE_TYPE_ADD_ON].includes(currentPriceType) ? currentPriceType : renderedPriceType;
        var shouldShowTips = [1, 2, PRICE_TYPE_ADD_ON].includes(priceType);
        if (!shouldShowTips) {
          existingTips === null || existingTips === void 0 || existingTips.remove();
          return;
        }
        if (existingTips) {
          var _tipsText$textContent;
          var tipsText = existingTips.querySelector('.price-tips-text');
          existingTips.dataset.priceType = String(priceType);
          existingTips.style.display = '';
          if ([1, 2, PRICE_TYPE_ADD_ON].includes(currentPriceType)) {
            if (Number.isFinite(Number(this.dealPrice))) {
              existingTips.dataset.dealPrice = String(this.dealPrice);
            }
            if (Number.isFinite(Number(this.variantPrice))) {
              existingTips.dataset.variantPrice = String(this.variantPrice);
            }
          }
          if (priceType === 1 && !(tipsText !== null && tipsText !== void 0 && (_tipsText$textContent = tipsText.textContent) !== null && _tipsText$textContent !== void 0 && _tipsText$textContent.trim())) {
            tipsText.textContent = 'Special Deal';
          }
          return;
        }
        var variantTemplate = this.querySelector("script[type=\"text/template\"][data-variant-id=\"".concat(CSS.escape(String(variantId)), "\"]"));
        var templateTips;
        if (variantTemplate !== null && variantTemplate !== void 0 && variantTemplate.innerHTML) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = variantTemplate.innerHTML;
          templateTips = wrapper.querySelector('.main-product__price-wrapper__price-tips');
        }
        if (!templateTips) {
          var _iterator0 = original_main_product_createForOfIteratorHelper(this.querySelectorAll('script[type="text/template"][data-variant-id]')),
            _step0;
          try {
            for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
              var _candidate$querySelec;
              var template = _step0.value;
              if (!template.innerHTML) {
                continue;
              }
              var _wrapper = document.createElement('div');
              _wrapper.innerHTML = template.innerHTML;
              var candidate = _wrapper.querySelector('.main-product__price-wrapper__price-tips');
              if (candidate !== null && candidate !== void 0 && (_candidate$querySelec = candidate.querySelector('.price-tips-text')) !== null && _candidate$querySelec !== void 0 && _candidate$querySelec.textContent) {
                templateTips = candidate;
                break;
              }
            }
          } catch (err) {
            _iterator0.e(err);
          } finally {
            _iterator0.f();
          }
        }
        if (!templateTips) {
          if (priceType !== 1) {
            return;
          }
          templateTips = document.createElement('div');
          templateTips.dataset.priceType = String(priceType);
          templateTips.className = 'main-product__price-wrapper__price-tips';
          templateTips.innerHTML = "\n            <span class=\"price-tips-text\">Special Deal</span>\n            <span class=\"main-product__price-wrapper__price-tips__divider\">\n              <svg class=\"icon\" aria-hidden=\"true\">\n                <use xlink:href=\"#mec-tishi\"></use>\n              </svg>\n            </span>\n          ".trim();
        }
        templateTips.dataset.priceType = String(priceType);
        if (Number.isFinite(Number(this.dealPrice))) {
          templateTips.dataset.dealPrice = String(this.dealPrice);
        }
        if (Number.isFinite(Number(this.variantPrice))) {
          templateTips.dataset.variantPrice = String(this.variantPrice);
        }
        templateTips.style.display = '';
        priceArea.append(templateTips);
      }

      /**
       * @description 根据当前 variant 更新商品左上角标签
       * @returns {Promise<void>}
       */
    }, {
      key: "handleResetTag",
      value: (function () {
        var _handleResetTag = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
          var _this3 = this;
          var product, currentVariant, tagHtml;
          return _regenerator().w(function (_context7) {
            while (1) switch (_context7.n) {
              case 0:
                if (this.querySelector('.product-gallery__tag')) {
                  _context7.n = 1;
                  break;
                }
                return _context7.a(2);
              case 1:
                _context7.n = 2;
                return this.waitForProductInfo();
              case 2:
                product = _context7.v;
                if (product) {
                  _context7.n = 3;
                  break;
                }
                return _context7.a(2);
              case 3:
                currentVariant = product.variants.find(function (item) {
                  return item.id === Number(_this3.getAttribute('variant-id'));
                });
                if (currentVariant) {
                  _context7.n = 4;
                  break;
                }
                return _context7.a(2);
              case 4:
                tagHtml = (0,create/* default */.Z)(product, this.variantPrice, [1, 3, 4].includes(this.priceType) ? this.dealPrice : undefined);
                this.querySelector('.product-gallery__tag').innerHTML = tagHtml;
              case 5:
                return _context7.a(2);
            }
          }, _callee7, this);
        }));
        function handleResetTag() {
          return _handleResetTag.apply(this, arguments);
        }
        return handleResetTag;
      }()
      /**
       * @description variant 切换时同步标签与物流时效
       * @returns {Promise<void>}
       */
      )
    }, {
      key: "handleVariantSelected",
      value: (function () {
        var _handleVariantSelected = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
          var isReady;
          return _regenerator().w(function (_context8) {
            while (1) switch (_context8.n) {
              case 0:
                _context8.n = 1;
                return this.handleResetPrice();
              case 1:
                isReady = _context8.v;
                if (isReady) {
                  _context8.n = 2;
                  break;
                }
                return _context8.a(2);
              case 2:
                _context8.n = 3;
                return this.handleResetTag();
              case 3:
                _context8.n = 4;
                return this.handleResetLogisticsAging();
              case 4:
                return _context8.a(2);
            }
          }, _callee8, this);
        }));
        function handleVariantSelected() {
          return _handleVariantSelected.apply(this, arguments);
        }
        return handleVariantSelected;
      }())
    }, {
      key: "bindDiscountModalEvents",
      value: function bindDiscountModalEvents(discountModal) {
        (0,event_handler.on)('click', '.discount-modal__discount-code', function (event) {
          var currentTarget = event.currentTarget;
          copy_to_clipboard_default()(currentTarget.dataset.discountCode);
          window.publicComponents.messageOpen({
            type: 'success',
            content: 'Successfully copied'
          });
        }, {}, discountModal.node);
        (0,event_handler.on)('click', '.discount-modal__close', function () {
          discountModal.close();
        }, {}, discountModal.node);
      }
    }, {
      key: "trackDiscountModalClick",
      value: function trackDiscountModalClick() {
        var _window$dataLayer5, _window$dataLayer5$pu, _window$dataLayer6, _window$dataLayer6$pu;
        (_window$dataLayer5 = window.dataLayer) === null || _window$dataLayer5 === void 0 || (_window$dataLayer5$pu = _window$dataLayer5.push) === null || _window$dataLayer5$pu === void 0 || _window$dataLayer5$pu.call(_window$dataLayer5, {
          ecommerce: null
        });
        (_window$dataLayer6 = window.dataLayer) === null || _window$dataLayer6 === void 0 || (_window$dataLayer6$pu = _window$dataLayer6.push) === null || _window$dataLayer6$pu === void 0 || _window$dataLayer6$pu.call(_window$dataLayer6, {
          event: 'uaEvent',
          event_type: 'Click_discount_details',
          ecommerce: {
            product_id: this.getAttribute('product-id'),
            event_label: this.closest('.inner') ? 'quick_add' : 'product_detail'
          }
        });
      }

      /**
       * 查询加价购命中结果。
       * @returns {Promise<{ hits: object[] }>}
       */
    }, {
      key: "fetchAddOnDiscountMatch",
      value: (function () {
        var _fetchAddOnDiscountMatch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
          var _result$items$, _result$items, _result$data, result, item, _t2;
          return _regenerator().w(function (_context9) {
            while (1) switch (_context9.p = _context9.n) {
              case 0:
                _context9.p = 0;
                _context9.n = 1;
                return (0,discount_addon/* requestDiscountAddonMatch */.c)({
                  items: [{
                    frontSkuCode: this.getAttribute('variant-id'),
                    frontSpuCode: this.getAttribute('product-id')
                  }]
                });
              case 1:
                result = _context9.v;
                item = Array.isArray(result) ? result[0] : (_result$items$ = result === null || result === void 0 || (_result$items = result.items) === null || _result$items === void 0 ? void 0 : _result$items[0]) !== null && _result$items$ !== void 0 ? _result$items$ : result === null || result === void 0 || (_result$data = result.data) === null || _result$data === void 0 || (_result$data = _result$data.items) === null || _result$data === void 0 ? void 0 : _result$data[0];
                return _context9.a(2, {
                  hits: Array.isArray(item === null || item === void 0 ? void 0 : item.hits) ? item.hits : []
                });
              case 2:
                _context9.p = 2;
                _t2 = _context9.v;
                return _context9.a(2, {
                  hits: []
                });
            }
          }, _callee9, this, [[0, 2]]);
        }));
        function fetchAddOnDiscountMatch() {
          return _fetchAddOnDiscountMatch.apply(this, arguments);
        }
        return fetchAddOnDiscountMatch;
      }()
      /**
       * 用完整折扣内容替换加价购弹窗内容区。
       * @param {InstanceType<typeof StaticModal>} discountModal
       * @param {object} payload - 包含 product、webActivityUrl 和可选 addOnHit。
       * @returns {void}
       */
      )
    }, {
      key: "fillAddOnDiscountModalContent",
      value: function fillAddOnDiscountModalContent(discountModal, _ref3) {
        var _discountModal$node, _discountModal$node$q;
        var product = _ref3.product,
          webActivityUrl = _ref3.webActivityUrl,
          addOnHit = _ref3.addOnHit;
        var contentElement = (_discountModal$node = discountModal.node) === null || _discountModal$node === void 0 || (_discountModal$node$q = _discountModal$node.querySelector) === null || _discountModal$node$q === void 0 ? void 0 : _discountModal$node$q.call(_discountModal$node, '.discount-modal__content');
        if (!contentElement) {
          return;
        }
        var wrapper = document.createElement('div');
        wrapper.innerHTML = getDicountElementHtml({
          priceType: this.priceType,
          dealPrice: this.dealPrice.toFixed(2),
          variantPrice: this.variantPrice.toFixed(2),
          product: product,
          webActivityUrl: webActivityUrl,
          addOnHit: addOnHit
        });
        var nextContent = wrapper.querySelector('.discount-modal__content');
        if (nextContent) {
          contentElement.replaceWith(nextContent);
        }
      }
    }, {
      key: "listenAddOnDiscountModalClose",
      value: function listenAddOnDiscountModalClose(subscribeKey, onClose) {
        var _handleOpenChange = function handleOpenChange(isOpen) {
          if (isOpen) {
            return;
          }
          event_emitter/* default */.Z.off("".concat(subscribeKey, "-open-change"), _handleOpenChange);
          onClose();
        };
        event_emitter/* default */.Z.on("".concat(subscribeKey, "-open-change"), _handleOpenChange);
      }
    }, {
      key: "createAddOnDiscountLoadingModal",
      value: function createAddOnDiscountLoadingModal(subscribeKey) {
        var discountModal = new modal/* default */.Z({
          duration: 0,
          template: getAddOnDiscountModalLoadingHtml(),
          mask: 'true',
          'mobile-placement': 'bottom',
          subscribeKey: subscribeKey
        });
        discountModal.create();
        this.bindDiscountModalEvents(discountModal);
        this.trackDiscountModalClick();
        return discountModal;
      }

      /**
       * 打开加价购折扣弹窗：先展示 loading，请求结束后再填充内容。
       * @returns {Promise<void>}
       */
    }, {
      key: "openAddOnDiscountModal",
      value: (function () {
        var _openAddOnDiscountModal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
          var _this4 = this;
          var subscribeKey, closed, discountModal, _discountModal$node2, _addOnHit$addonConfig, _yield$Promise$all, _yield$Promise$all2, product, addOnMatch, addOnHit;
          return _regenerator().w(function (_context0) {
            while (1) switch (_context0.p = _context0.n) {
              case 0:
                if (!this.addOnDiscountModalLoading) {
                  _context0.n = 1;
                  break;
                }
                return _context0.a(2);
              case 1:
                this.addOnDiscountModalLoading = true;
                this.addOnDiscountModalSession = (this.addOnDiscountModalSession || 0) + 1;
                subscribeKey = "".concat(ADD_ON_DISCOUNT_MODAL_SUBSCRIBE_KEY, "-").concat(this.getAttribute('product-id'), "-").concat(this.addOnDiscountModalSession);
                closed = false;
                this.listenAddOnDiscountModalClose(subscribeKey, function () {
                  closed = true;
                  _this4.addOnDiscountModalLoading = false;
                });
                discountModal = this.createAddOnDiscountLoadingModal(subscribeKey);
                _context0.p = 2;
                _context0.n = 3;
                return Promise.all([this.getProductInfo(), this.fetchAddOnDiscountMatch()]);
              case 3:
                _yield$Promise$all = _context0.v;
                _yield$Promise$all2 = original_main_product_slicedToArray(_yield$Promise$all, 2);
                product = _yield$Promise$all2[0];
                addOnMatch = _yield$Promise$all2[1];
                if (!(!product || closed || !((_discountModal$node2 = discountModal.node) !== null && _discountModal$node2 !== void 0 && _discountModal$node2.isConnected))) {
                  _context0.n = 4;
                  break;
                }
                return _context0.a(2);
              case 4:
                addOnHit = findAddOnHitByMatchedConfig({
                  product: product,
                  configRows: getAddOnPurchaseConfig(),
                  hits: addOnMatch.hits
                });
                this.fillAddOnDiscountModalContent(discountModal, {
                  product: product,
                  webActivityUrl: (addOnHit === null || addOnHit === void 0 || (_addOnHit$addonConfig = addOnHit.addonConfig) === null || _addOnHit$addonConfig === void 0 ? void 0 : _addOnHit$addonConfig.webActivityUrl) || '',
                  addOnHit: addOnHit
                });
              case 5:
                _context0.p = 5;
                if (!closed) {
                  this.addOnDiscountModalLoading = false;
                }
                return _context0.f(5);
              case 6:
                return _context0.a(2);
            }
          }, _callee0, this, [[2,, 5, 6]]);
        }));
        function openAddOnDiscountModal() {
          return _openAddOnDiscountModal.apply(this, arguments);
        }
        return openAddOnDiscountModal;
      }())
    }, {
      key: "openDiscountModal",
      value: function () {
        var _openDiscountModal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
          var _properties$priceType, _properties$dealPrice, _properties$variantPr;
          var properties,
            priceType,
            dealPrice,
            variantPrice,
            isReady,
            product,
            discountModal,
            _args1 = arguments;
          return _regenerator().w(function (_context1) {
            while (1) switch (_context1.n) {
              case 0:
                properties = _args1.length > 0 && _args1[0] !== undefined ? _args1[0] : {};
                priceType = Number((_properties$priceType = properties.priceType) !== null && _properties$priceType !== void 0 ? _properties$priceType : this.priceType);
                dealPrice = Number((_properties$dealPrice = properties.dealPrice) !== null && _properties$dealPrice !== void 0 ? _properties$dealPrice : this.dealPrice);
                variantPrice = Number((_properties$variantPr = properties.variantPrice) !== null && _properties$variantPr !== void 0 ? _properties$variantPr : this.variantPrice);
                if (!(![1, 2].includes(priceType) || !Number.isFinite(dealPrice) || !Number.isFinite(variantPrice))) {
                  _context1.n = 3;
                  break;
                }
                _context1.n = 1;
                return this.handleResetPrice();
              case 1:
                isReady = _context1.v;
                if (isReady) {
                  _context1.n = 2;
                  break;
                }
                return _context1.a(2);
              case 2:
                priceType = Number(this.priceType);
                dealPrice = Number(this.dealPrice);
                variantPrice = Number(this.variantPrice);
              case 3:
                if (!(![1, 2].includes(priceType) || !Number.isFinite(dealPrice) || !Number.isFinite(variantPrice))) {
                  _context1.n = 4;
                  break;
                }
                return _context1.a(2);
              case 4:
                _context1.n = 5;
                return this.waitForProductInfo();
              case 5:
                product = _context1.v;
                if (product) {
                  _context1.n = 6;
                  break;
                }
                return _context1.a(2);
              case 6:
                discountModal = new modal/* default */.Z({
                  duration: 0,
                  template: getDicountElementHtml({
                    priceType: priceType,
                    dealPrice: dealPrice.toFixed(2),
                    variantPrice: variantPrice.toFixed(2),
                    product: product,
                    webActivityUrl: ''
                  }),
                  mask: 'true',
                  'mobile-placement': 'bottom'
                });
                discountModal.create();
                this.bindDiscountModalEvents(discountModal);
                this.trackDiscountModalClick();
              case 7:
                return _context1.a(2);
            }
          }, _callee1, this);
        }));
        function openDiscountModal() {
          return _openDiscountModal.apply(this, arguments);
        }
        return openDiscountModal;
      }()
    }, {
      key: "handleDiscountModalObserver",
      value: function handleDiscountModalObserver() {
        var _this5 = this;
        if (this.discountTipsClickHandler) {
          this.removeEventListener('click', this.discountTipsClickHandler, true);
        }
        this.discountTipsClickHandler = function (event) {
          var _event$target4, _event$target4$closes, _dataset$priceType, _tipsElement$closest2, _tipsElement$closest3;
          var tipsElement = (_event$target4 = event.target) === null || _event$target4 === void 0 || (_event$target4$closes = _event$target4.closest) === null || _event$target4$closes === void 0 ? void 0 : _event$target4$closes.call(_event$target4, '.main-product__price-wrapper__price-tips');
          if (!tipsElement || !_this5.contains(tipsElement)) {
            return;
          }
          var _tipsElement$dataset = tipsElement.dataset,
            dataset = _tipsElement$dataset === void 0 ? {} : _tipsElement$dataset;
          var priceType = Number((_dataset$priceType = dataset.priceType) !== null && _dataset$priceType !== void 0 ? _dataset$priceType : _this5.priceType);
          if (priceType === PRICE_TYPE_ADD_ON) {
            _this5.openAddOnDiscountModal();
            return;
          }
          var nativeDiscountModal = (_tipsElement$closest2 = tipsElement.closest('.price-area')) === null || _tipsElement$closest2 === void 0 || (_tipsElement$closest3 = _tipsElement$closest2.querySelector) === null || _tipsElement$closest3 === void 0 ? void 0 : _tipsElement$closest3.call(_tipsElement$closest2, '.discount-modal-wrapper');
          if (nativeDiscountModal) {
            openNativeDiscountModal(nativeDiscountModal);
            return;
          }
          _this5.openDiscountModal({
            priceType: priceType,
            dealPrice: dataset.dealPrice,
            variantPrice: dataset.variantPrice
          });
        };
        this.addEventListener('click', this.discountTipsClickHandler, true);
      }

      /**
       * @description 监听 variant 切换并同步 variant-id
       */
    }, {
      key: "handleVariantSelectedObserver",
      value: function handleVariantSelectedObserver() {
        var _this$variantObserver,
          _this$variantObserver2,
          _this6 = this;
        var priceDescriptorsElement = this.querySelector('.price-descriptors');
        if (!priceDescriptorsElement) {
          return;
        }
        (_this$variantObserver = this.variantObserver) === null || _this$variantObserver === void 0 || (_this$variantObserver2 = _this$variantObserver.disconnect) === null || _this$variantObserver2 === void 0 || _this$variantObserver2.call(_this$variantObserver);
        this.variantObserver = mutationObserver(priceDescriptorsElement, function (mutation) {
          if (mutation.type === 'attributes') {
            var _priceDescriptorsElem;
            var variantId = priceDescriptorsElement === null || priceDescriptorsElement === void 0 || (_priceDescriptorsElem = priceDescriptorsElement.querySelector) === null || _priceDescriptorsElem === void 0 || (_priceDescriptorsElem = _priceDescriptorsElem.call(priceDescriptorsElement, '[name="id"]')) === null || _priceDescriptorsElem === void 0 ? void 0 : _priceDescriptorsElem.value;
            if (variantId) {
              _this6.setAttribute('variant-id', variantId);
            }
          }
        });
        var variantVisibilityArea = this.querySelector('.variant-visibility-area');
        if (variantVisibilityArea) {
          var _this$variantVisibili, _this$variantVisibili2;
          (_this$variantVisibili = this.variantVisibilityObserver) === null || _this$variantVisibili === void 0 || (_this$variantVisibili2 = _this$variantVisibili.disconnect) === null || _this$variantVisibili2 === void 0 || _this$variantVisibili2.call(_this$variantVisibili);
          this.variantVisibilityObserver = mutationObserver(variantVisibilityArea, function () {
            _this6.handleResetPrice();
          }, {
            childList: true
          });
        }

        /**
         * 变体脚本更新的是 input/select 的 value，不会触发父节点 attributes 变化，
         * 因此还要监听 [name="id"] 的 change 事件，保证价格状态同步更新。
         */
        (0,event_handler.on)('change', '[name="id"]', function (event) {
          var _event$target5;
          var variantId = (_event$target5 = event.target) === null || _event$target5 === void 0 ? void 0 : _event$target5.value;
          if (variantId && String(variantId) !== String(_this6.getAttribute('variant-id'))) {
            _this6.setAttribute('variant-id', variantId);
          }
        }, {}, this);
      }

      /**
       * @description 读取商品变体配置并初始化图片卡片与变体说明
       */
    }, {
      key: "setupVariantImage",
      value: (function () {
        var _setupVariantImage2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
          var _heteInfoMeta$variant;
          var element, heteInfoMeta;
          return _regenerator().w(function (_context10) {
            while (1) switch (_context10.n) {
              case 0:
                element = this.querySelector("#metafileds-heteinfometa-".concat(this.getAttribute('product-id')));
                heteInfoMeta = element !== null && element !== void 0 && element.textContent ? JSON.parse(element.textContent) : {};
                _classPrivateFieldSet(_customVariantInfo, this, (_heteInfoMeta$variant = heteInfoMeta === null || heteInfoMeta === void 0 ? void 0 : heteInfoMeta.variant_description) !== null && _heteInfoMeta$variant !== void 0 ? _heteInfoMeta$variant : []);
                _setupVariantImage(this, _classPrivateFieldGet(_customVariantInfo, this));
                onVariantChange(this, _classPrivateFieldGet(_customVariantInfo, this));
              case 1:
                return _context10.a(2);
            }
          }, _callee10, this);
        }));
        function setupVariantImage() {
          return _setupVariantImage2.apply(this, arguments);
        }
        return setupVariantImage;
      }()
      /**
       * @description 等商品详情 DOM 渲染完成后再初始化价格、标签和变体监听
       * @returns {void}
       */
      )
    }, {
      key: "setupProductDetail",
      value: function setupProductDetail() {
        var _window$dataObject3,
          _this$productContentO,
          _this$productContentO2,
          _this7 = this;
        var productId = this.getAttribute('product-id');
        if (!productId) {
          return;
        }
        var productJsonElement = this.querySelector("#ProductJson-".concat(productId));
        if (productJsonElement || (_window$dataObject3 = window.dataObject) !== null && _window$dataObject3 !== void 0 && _window$dataObject3.variants && String(window.dataObject.id) === String(productId)) {
          this.setupVariantImage();
          this.handleVariantSelectedObserver();
          this.handleVariantSelected();
          return;
        }
        (_this$productContentO = this.productContentObserver) === null || _this$productContentO === void 0 || (_this$productContentO2 = _this$productContentO.disconnect) === null || _this$productContentO2 === void 0 || _this$productContentO2.call(_this$productContentO);
        this.productContentObserver = mutationObserver(this, function () {
          var _this7$productContent, _this7$productContent2;
          if (!_this7.querySelector("#ProductJson-".concat(productId))) {
            return;
          }
          (_this7$productContent = _this7.productContentObserver) === null || _this7$productContent === void 0 || (_this7$productContent2 = _this7$productContent.disconnect) === null || _this7$productContent2 === void 0 || _this7$productContent2.call(_this7$productContent);
          _this7.productContentObserver = undefined;
          _this7.setupVariantImage();
          _this7.handleVariantSelectedObserver();
          _this7.handleVariantSelected();
        }, {
          childList: true,
          subtree: true
        });
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        this.handleDiscountModalObserver();
        this.setupProductDetail();
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'variant-id' && oldValue !== newValue) {
          this.handleVariantSelected();
          onVariantChange(this, _classPrivateFieldGet(_customVariantInfo, this));
        }
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        var _this$productContentO3, _this$productContentO4, _this$variantObserver3, _this$variantObserver4, _this$variantVisibili3, _this$variantVisibili4;
        if (this.discountTipsClickHandler) {
          this.removeEventListener('click', this.discountTipsClickHandler, true);
          this.discountTipsClickHandler = undefined;
        }
        (_this$productContentO3 = this.productContentObserver) === null || _this$productContentO3 === void 0 || (_this$productContentO4 = _this$productContentO3.disconnect) === null || _this$productContentO4 === void 0 || _this$productContentO4.call(_this$productContentO3);
        this.productContentObserver = undefined;
        (_this$variantObserver3 = this.variantObserver) === null || _this$variantObserver3 === void 0 || (_this$variantObserver4 = _this$variantObserver3.disconnect) === null || _this$variantObserver4 === void 0 || _this$variantObserver4.call(_this$variantObserver3);
        this.variantObserver = undefined;
        (_this$variantVisibili3 = this.variantVisibilityObserver) === null || _this$variantVisibili3 === void 0 || (_this$variantVisibili4 = _this$variantVisibili3.disconnect) === null || _this$variantVisibili4 === void 0 || _this$variantVisibili4.call(_this$variantVisibili3);
        this.variantVisibilityObserver = undefined;
        (0,event_handler/* offByContainer */.g4)(this);
      }
    }]);
  }(/*#__PURE__*/original_main_product_wrapNativeSuper(HTMLElement)), original_main_product_defineProperty(_OriginalProductInfo, "observedAttributes", ['variant-id']), _OriginalProductInfo));
};
bindDiscountTipsClickDelegation();
original_main_product_init();

/***/ }),

/***/ 18335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56187);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38690);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89228);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26031);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91270);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44901);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95822);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48949);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81970);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39574);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43908);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36763);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59139);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(54134);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2663);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(66066);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(13227);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(92815);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(88646);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(11908);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(21413);
/* harmony import */ var core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(37666);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(33373);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(33370);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(14011);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_es_weak_map_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(84750);
/* harmony import */ var core_js_modules_es_weak_map_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_weak_map_js__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_es_weak_set_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(77991);
/* harmony import */ var core_js_modules_es_weak_set_js__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_weak_set_js__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(11431);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_web_queue_microtask_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(55279);
/* harmony import */ var core_js_modules_web_queue_microtask_js__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_queue_microtask_js__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(5188);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(31955);
/* harmony import */ var _utils_mutation_observer__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(39735);
/* harmony import */ var _utils_rIC__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(24681);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }














var _BaseCustomElements;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
















function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }




(0,immer__WEBPACK_IMPORTED_MODULE_33__/* .enablePatches */ .vI)();
var _state = /*#__PURE__*/new WeakMap();
var _history = /*#__PURE__*/new WeakMap();
var _redoStack = /*#__PURE__*/new WeakMap();
var _maxHistory = /*#__PURE__*/new WeakMap();
var _enableHistory = /*#__PURE__*/new WeakMap();
var _observer = /*#__PURE__*/new WeakMap();
var _childrenChecked = /*#__PURE__*/new WeakMap();
var _isBatching = /*#__PURE__*/new WeakMap();
var _batchedUpdaters = /*#__PURE__*/new WeakMap();
var _pendingChanges = /*#__PURE__*/new WeakMap();
var _hasMounted = /*#__PURE__*/new WeakMap();
var _pendingChildMounts = /*#__PURE__*/new WeakMap();
var _mountedChildren = /*#__PURE__*/new WeakMap();
var _BaseCustomElements_brand = /*#__PURE__*/new WeakSet();
var _registerDynamicChild = /*#__PURE__*/new WeakMap();
var _scheduleUpdate = /*#__PURE__*/new WeakMap();
var BaseCustomElements = /*#__PURE__*/function (_HTMLElement) {
  function BaseCustomElements() {
    var _options$enableHistor;
    var _this;
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, BaseCustomElements);
    _this = _callSuper(this, BaseCustomElements);
    _classPrivateMethodInitSpec(_this, _BaseCustomElements_brand);
    // === 状态管理 ===
    _classPrivateFieldInitSpec(_this, _state, {});
    _classPrivateFieldInitSpec(_this, _history, []);
    _classPrivateFieldInitSpec(_this, _redoStack, []);
    _classPrivateFieldInitSpec(_this, _maxHistory, 100);
    _classPrivateFieldInitSpec(_this, _enableHistory, false);
    _classPrivateFieldInitSpec(_this, _observer, null);
    _classPrivateFieldInitSpec(_this, _childrenChecked, false);
    // === 更新队列 ===
    _classPrivateFieldInitSpec(_this, _isBatching, false);
    _classPrivateFieldInitSpec(_this, _batchedUpdaters, []);
    _classPrivateFieldInitSpec(_this, _pendingChanges, []);
    // === 生命周期 ===
    _classPrivateFieldInitSpec(_this, _hasMounted, false);
    _classPrivateFieldInitSpec(_this, _pendingChildMounts, 0);
    _classPrivateFieldInitSpec(_this, _mountedChildren, new Set());
    _classPrivateFieldInitSpec(_this, _registerDynamicChild, function (child) {
      var markMounted = function markMounted() {
        var _this$pendingChildMou3, _this$pendingChildMou4;
        if (_classPrivateFieldGet(_mountedChildren, _this).has(child)) return;
        _classPrivateFieldGet(_mountedChildren, _this).add(child);
        _classPrivateFieldSet(_pendingChildMounts, _this, (_this$pendingChildMou3 = _classPrivateFieldGet(_pendingChildMounts, _this), _this$pendingChildMou4 = _this$pendingChildMou3--, _this$pendingChildMou3)), _this$pendingChildMou4;
        if (_classPrivateFieldGet(_pendingChildMounts, _this) <= 0) {
          // 推荐通过微任务触发，降低同步栈内重入带来的不确定性
          queueMicrotask(function () {
            _assertClassBrand(_BaseCustomElements_brand, _this, _triggerMount).call(_this);
          });
        }
      };

      // 如果子组件已经挂载：同步处理（避免先注册监听再补救导致竞态）
      if (child.isMounted()) {
        markMounted();
        return;
      }

      // 否则监听事件（保底）
      var onChildMounted = function onChildMounted() {
        markMounted();
      };
      child.addEventListener('child-mounted', onChildMounted, {
        once: true
      });

      // 双保险：立即二次检查（防止子在极短时间内变为 mounted）
      if (child.isMounted()) {
        markMounted();
        child.removeEventListener('child-mounted', onChildMounted);
      }
    });
    _classPrivateFieldInitSpec(_this, _scheduleUpdate, (0,lodash_es__WEBPACK_IMPORTED_MODULE_30__/* .debounce */ .Ds)(function () {
      if (_classPrivateFieldGet(_pendingChanges, _this).length === 0) return;
      var changes = _classPrivateFieldGet(_pendingChanges, _this);
      _classPrivateFieldSet(_pendingChanges, _this, []);
      var previous = {};
      var current = {};
      var patchList = [];
      var _iterator = _createForOfIteratorHelper(changes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _step.value,
            patches = _step$value.patches,
            inversePatches = _step$value.inversePatches;
          patchList.push.apply(patchList, _toConsumableArray(patches));
          for (var _i = 0, _Object$entries = Object.entries(patches); _i < _Object$entries.length; _i++) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              index = _Object$entries$_i[0],
              patch = _Object$entries$_i[1];
            var currentInversePatch = inversePatches[Number(index)];
            if (patch.op === 'replace' || patch.op === 'add') {
              _assertClassBrand(_BaseCustomElements_brand, _this, _setPath).call(_this, current, patch.path, patch.value);
              _assertClassBrand(_BaseCustomElements_brand, _this, _setPath).call(_this, previous, currentInversePatch.path, currentInversePatch.value);
            } else if (patch.op === 'remove') {
              _assertClassBrand(_BaseCustomElements_brand, _this, _setPath).call(_this, previous, currentInversePatch.path, currentInversePatch.value);
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      (0,_utils_rIC__WEBPACK_IMPORTED_MODULE_32__/* .rIC */ .$)(function () {
        _this.componentDidUpdate(previous, current, patchList);
      });
    }, 0));
    _classPrivateFieldSet(_state, _this, initialState);
    _classPrivateFieldSet(_enableHistory, _this, (_options$enableHistor = options.enableHistory) !== null && _options$enableHistor !== void 0 ? _options$enableHistor : false);
    return _this;
  }
  _inherits(BaseCustomElements, _HTMLElement);
  return _createClass(BaseCustomElements, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.isMounted()) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.n = 2;
              return _assertClassBrand(_BaseCustomElements_brand, this, _initChildren).call(this);
            case 2:
              _classPrivateFieldSet(_childrenChecked, this, true);
              if (_classPrivateFieldGet(_pendingChildMounts, this) <= 0) {
                _assertClassBrand(_BaseCustomElements_brand, this, _triggerMount).call(this);
              }

              // 开启 MutationObserver 监听运行时新增的子组件
              _classPrivateFieldSet(_observer, this, (0,_utils_mutation_observer__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(this, function (mutation) {
                var _iterator2 = _createForOfIteratorHelper(mutation.addedNodes),
                  _step2;
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var node = _step2.value;
                    if (node instanceof BaseCustomElements && !_classPrivateFieldGet(_mountedChildren, _this2).has(node)) {
                      var _this$pendingChildMou, _this$pendingChildMou2;
                      _classPrivateFieldSet(_pendingChildMounts, _this2, (_this$pendingChildMou = _classPrivateFieldGet(_pendingChildMounts, _this2), _this$pendingChildMou2 = _this$pendingChildMou++, _this$pendingChildMou)), _this$pendingChildMou2;
                      _classPrivateFieldGet(_registerDynamicChild, _this2).call(_this2, node);
                    }
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
                if (_classPrivateFieldGet(_pendingChildMounts, _this2) <= 0) {
                  _assertClassBrand(_BaseCustomElements_brand, _this2, _triggerMount).call(_this2);
                }
              }, {
                childList: true,
                subtree: false,
                attributes: false
              }));
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this$componentWillUn;
      // 清理 observer
      if (_classPrivateFieldGet(_observer, this)) {
        _classPrivateFieldGet(_observer, this).disconnect();
        _classPrivateFieldSet(_observer, this, null);
      }
      (_this$componentWillUn = this.componentWillUnmount) === null || _this$componentWillUn === void 0 || _this$componentWillUn.call(this);
      _classPrivateFieldGet(_mountedChildren, this).clear();
    }

    // 子类重写
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}

    // 子类重写
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {}

    // 子类重写
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(previous, current, changes) {}
  }, {
    key: "state",
    get: function get() {
      return _classPrivateFieldGet(_state, this);
    }
  }, {
    key: "setState",
    value: function setState(updater) {
      if (_classPrivateFieldGet(_isBatching, this)) {
        _classPrivateFieldGet(_batchedUpdaters, this).push(updater);
        return;
      }
      var _produceWithPatches = (0,immer__WEBPACK_IMPORTED_MODULE_33__/* .produceWithPatches */ .aS)(_classPrivateFieldGet(_state, this), updater),
        _produceWithPatches2 = _slicedToArray(_produceWithPatches, 3),
        nextState = _produceWithPatches2[0],
        patches = _produceWithPatches2[1],
        inversePatches = _produceWithPatches2[2];
      if (patches.length === 0) return;
      _assertClassBrand(_BaseCustomElements_brand, this, _commitState).call(this, nextState, patches, inversePatches);
    }
  }, {
    key: "batchSetState",
    value: function batchSetState(batchFunction) {
      var _this3 = this;
      _classPrivateFieldSet(_isBatching, this, true);
      batchFunction(this.setState.bind(this));
      _classPrivateFieldSet(_isBatching, this, false);
      if (_classPrivateFieldGet(_batchedUpdaters, this).length === 0) return;
      var _produceWithPatches3 = (0,immer__WEBPACK_IMPORTED_MODULE_33__/* .produceWithPatches */ .aS)(_classPrivateFieldGet(_state, this), function (draft) {
          var _iterator3 = _createForOfIteratorHelper(_classPrivateFieldGet(_batchedUpdaters, _this3)),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var updater = _step3.value;
              updater(draft);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }),
        _produceWithPatches4 = _slicedToArray(_produceWithPatches3, 3),
        nextState = _produceWithPatches4[0],
        patches = _produceWithPatches4[1],
        inversePatches = _produceWithPatches4[2];
      _classPrivateFieldSet(_batchedUpdaters, this, []);
      if (patches.length > 0) {
        _assertClassBrand(_BaseCustomElements_brand, this, _commitState).call(this, nextState, patches, inversePatches);
      }
    }
  }, {
    key: "undo",
    value: function undo() {
      var _this4 = this;
      if (!_classPrivateFieldGet(_enableHistory, this)) return;
      var last = _classPrivateFieldGet(_history, this).pop();
      if (!last) return;
      var inversePatches = last.inversePatches,
        patches = last.patches;
      _classPrivateFieldGet(_redoStack, this).push({
        patches: patches,
        inversePatches: inversePatches,
        snapshot: _classPrivateFieldGet(_state, this)
      });
      _classPrivateFieldSet(_state, this, (0,immer__WEBPACK_IMPORTED_MODULE_33__/* .applyPatches */ .QE)(_classPrivateFieldGet(_state, this), inversePatches));
      (0,_utils_rIC__WEBPACK_IMPORTED_MODULE_32__/* .rIC */ .$)(function () {
        _this4.componentDidUpdate({}, {}, inversePatches);
      });
    }
  }, {
    key: "redo",
    value: function redo() {
      var _this5 = this;
      if (!_classPrivateFieldGet(_enableHistory, this)) return;
      var next = _classPrivateFieldGet(_redoStack, this).pop();
      if (!next) return;
      var patches = next.patches,
        inversePatches = next.inversePatches;
      _classPrivateFieldGet(_history, this).push({
        patches: patches,
        inversePatches: inversePatches,
        snapshot: _classPrivateFieldGet(_state, this)
      });
      _classPrivateFieldSet(_state, this, (0,immer__WEBPACK_IMPORTED_MODULE_33__/* .applyPatches */ .QE)(_classPrivateFieldGet(_state, this), patches));
      (0,_utils_rIC__WEBPACK_IMPORTED_MODULE_32__/* .rIC */ .$)(function () {
        _this5.componentDidUpdate({}, {}, patches);
      });
    }
  }, {
    key: "registerChildMounted",
    value: function registerChildMounted(child) {
      var _this$pendingChildMou5, _this$pendingChildMou6;
      if (_classPrivateFieldGet(_mountedChildren, this).has(child) || !_classPrivateFieldGet(_childrenChecked, this)) return;
      _classPrivateFieldGet(_mountedChildren, this).add(child);
      _classPrivateFieldSet(_pendingChildMounts, this, (_this$pendingChildMou5 = _classPrivateFieldGet(_pendingChildMounts, this), _this$pendingChildMou6 = _this$pendingChildMou5--, _this$pendingChildMou5)), _this$pendingChildMou6;
      if (_classPrivateFieldGet(_pendingChildMounts, this) <= 0) {
        _assertClassBrand(_BaseCustomElements_brand, this, _triggerMount).call(this);
      }
    }
  }, {
    key: "isMounted",
    value: function isMounted() {
      return _classPrivateFieldGet(_hasMounted, this);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
_BaseCustomElements = BaseCustomElements;
function _triggerMount() {
  if (this.isMounted()) return;
  _classPrivateFieldSet(_hasMounted, this, true);
  this.componentDidMount();
  var parent = this.parentElement;
  while (parent) {
    if (parent instanceof _BaseCustomElements) {
      try {
        var _parent$registerChild, _parent;
        (_parent$registerChild = (_parent = parent).registerChildMounted) === null || _parent$registerChild === void 0 || _parent$registerChild.call(_parent, this);
      } catch (error) {
        // 防御性捕获，避免同步调用抛错阻断流程
        console.warn('parent.registerChildMounted threw', error);
      }
      break;
    }
    parent = parent.parentElement;
  }

  // 触发事件（无论是否有父组件）
  this.dispatchEvent(new CustomEvent('child-mounted', {
    bubbles: true,
    detail: this
  }));
}
function _initChildren() {
  return _initChildren2.apply(this, arguments);
}
function _initChildren2() {
  _initChildren2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var _this6 = this;
    var children, unregistered, _iterator4, _step4, child;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return _assertClassBrand(_BaseCustomElements_brand, this, _getChildCustomElements).call(this);
        case 1:
          children = _context2.v;
          // 过滤已注册的子组件
          unregistered = children.filter(function (child) {
            return !_classPrivateFieldGet(_mountedChildren, _this6).has(child) && _this6.contains(child);
          });
          _classPrivateFieldSet(_pendingChildMounts, this, unregistered.length);

          // 注册每个子组件
          _iterator4 = _createForOfIteratorHelper(unregistered);
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              child = _step4.value;
              _classPrivateFieldGet(_registerDynamicChild, this).call(this, child);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        case 2:
          return _context2.a(2);
      }
    }, _callee2, this);
  }));
  return _initChildren2.apply(this, arguments);
}
function _getChildCustomElements() {
  return _getChildCustomElements2.apply(this, arguments);
}
function _getChildCustomElements2() {
  _getChildCustomElements2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
    var result, all, _iterator5, _step5, element, localName, _t, _t2;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          result = []; // 获取所有子节点（包括嵌套）
          all = _toConsumableArray(this.querySelectorAll('*')).filter(function (element) {
            return element instanceof HTMLElement && element.tagName.includes('-');
          });
          _iterator5 = _createForOfIteratorHelper(all);
          _context3.p = 1;
          _iterator5.s();
        case 2:
          if ((_step5 = _iterator5.n()).done) {
            _context3.n = 7;
            break;
          }
          element = _step5.value;
          localName = element.localName; // 如果已注册，并且是 BaseCustomElements 实例
          if (!customElements.get(localName)) {
            _context3.n = 3;
            break;
          }
          if (element instanceof _BaseCustomElements) {
            result.push(element);
          }
          _context3.n = 6;
          break;
        case 3:
          _context3.p = 3;
          _context3.n = 4;
          return Promise.race([customElements.whenDefined(localName), new Promise(function (_, reject) {
            (0,_utils_rIC__WEBPACK_IMPORTED_MODULE_32__/* .rIC */ .$)(function () {
              setTimeout(reject, 500);
            });
          })]);
        case 4:
          // 注册完成后再次检查是否为 BaseCustomElements 实例
          if (element instanceof _BaseCustomElements) {
            result.push(element);
          }
          _context3.n = 6;
          break;
        case 5:
          _context3.p = 5;
          _t = _context3.v;
          console.warn("Component <".concat(localName, "> not defined in time"), _t);
        case 6:
          _context3.n = 2;
          break;
        case 7:
          _context3.n = 9;
          break;
        case 8:
          _context3.p = 8;
          _t2 = _context3.v;
          _iterator5.e(_t2);
        case 9:
          _context3.p = 9;
          _iterator5.f();
          return _context3.f(9);
        case 10:
          return _context3.a(2, result);
      }
    }, _callee3, this, [[3, 5], [1, 8, 9, 10]]);
  }));
  return _getChildCustomElements2.apply(this, arguments);
}
function _commitState(nextState, patches, inversePatches) {
  _classPrivateFieldSet(_state, this, nextState);
  if (_classPrivateFieldGet(_enableHistory, this)) {
    _classPrivateFieldGet(_history, this).push({
      patches: patches,
      inversePatches: inversePatches
    });
    if (_classPrivateFieldGet(_history, this).length > _classPrivateFieldGet(_maxHistory, this)) {
      _classPrivateFieldGet(_history, this).shift();
    }
    _classPrivateFieldSet(_redoStack, this, []);
  }
  _classPrivateFieldGet(_pendingChanges, this).push({
    patches: patches,
    inversePatches: inversePatches
  });
  _classPrivateFieldGet(_scheduleUpdate, this).call(this);
}
function _setPath(target, path, value) {
  path.slice(0, -1).reduce(function (accumulator, key) {
    var _accumulator$key;
    return (_accumulator$key = accumulator[key]) !== null && _accumulator$key !== void 0 ? _accumulator$key : accumulator[key] = {};
  }, target)[path.at(-1)] = value;
}
/* harmony default export */ __webpack_exports__.Z = (BaseCustomElements);

/***/ }),

/***/ 87205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   k: function() { return /* binding */ createFigureBase; }
/* harmony export */ });
/* unused harmony export getImageScale */
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56187);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38690);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89228);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26031);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84159);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91270);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66066);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44901);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13227);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89034);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_last_index_of_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45608);
/* harmony import */ var core_js_modules_es_array_last_index_of_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_last_index_of_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(92815);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88646);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(95822);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(48949);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(81970);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(11908);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(39574);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(43908);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_object_values_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(78305);
/* harmony import */ var core_js_modules_es_object_values_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(37666);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(36763);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(59139);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(54134);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(33370);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(14011);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(81597);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(11431);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var number_precision__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(17887);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }





























function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

var init = function init() {
  if (customElements.get('figure-base')) {
    return;
  }
  customElements.define('figure-base', /*#__PURE__*/function (_HTMLElement) {
    function FigureBase() {
      var _this;
      _classCallCheck(this, FigureBase);
      _this = _callSuper(this, FigureBase);
      _this.render();
      return _this;
    }
    _inherits(FigureBase, _HTMLElement);
    return _createClass(FigureBase, [{
      key: "loadErrorImage",
      value: function loadErrorImage(url) {
        return new Promise(function (resolve) {
          var image = new Image();
          image.src = url;
          image.addEventListener('load', resolve);
          image.addEventListener('error', resolve);
        });
      }
    }, {
      key: "setAttributes",
      value: function setAttributes(attributes) {
        if (!this.img) {
          return;
        }
        var _iterator = _createForOfIteratorHelper(attributes),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            switch (item.name) {
              case 'root-margin':
                {
                  this['root-margin'] = item.value;
                  break;
                }
              case 'threshold':
                {
                  this.threshold = Number(item.value);
                  break;
                }
              case 'error-image':
                {
                  this['error-image'] = item.value;
                  break;
                }
              default:
                {
                  this.img.setAttribute(item.name, item.value);
                  break;
                }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, {
      key: "render",
      value: function render() {
        this.img = this.querySelector('.mec-figure');
        var attributes = Object.values(this.attributes);
        this.setAttributes(attributes);
        this.append(this.img);
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this2 = this;
        setTimeout(function () {
          _this2.intersectionObserver = new IntersectionObserver(/*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(entries) {
              var _iterator2, _step2, entry, target, isIntersecting, srcset, source, result, _t;
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.p = _context3.n) {
                  case 0:
                    _iterator2 = _createForOfIteratorHelper(entries);
                    _context3.p = 1;
                    _iterator2.s();
                  case 2:
                    if ((_step2 = _iterator2.n()).done) {
                      _context3.n = 6;
                      break;
                    }
                    entry = _step2.value;
                    target = entry.target, isIntersecting = entry.isIntersecting;
                    if (isIntersecting) {
                      _context3.n = 3;
                      break;
                    }
                    return _context3.a(3, 5);
                  case 3:
                    _this2.intersectionObserver.unobserve(target);
                    srcset = _this2.img.dataset.mecSrcset;
                    source = _this2.img.dataset.mecSrc;
                    /**
                     * 判断是否支持 srcset
                     */
                    if (srcset && 'srcset' in HTMLImageElement.prototype) {
                      delete _this2.img.dataset.mecSrcset;
                      _this2.img.setAttribute('srcset', srcset);
                    }
                    if (source) {
                      delete _this2.img.dataset.mecSrc;
                      _this2.img.setAttribute('src', source);
                    }

                    // 传参为空且有错误image时
                    if (!srcset && !source && _this2['error-image']) {
                      _this2.img.setAttribute('src', _this2['error-image']);
                    }

                    /**
                     * 创建图片，加载成功后再替换
                     */
                    _context3.n = 4;
                    return new Promise(/*#__PURE__*/function () {
                      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(resolve) {
                        var _handleLoad;
                        return _regenerator().w(function (_context2) {
                          while (1) switch (_context2.n) {
                            case 0:
                              _handleLoad = /*#__PURE__*/function () {
                                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
                                  var errorResult;
                                  return _regenerator().w(function (_context) {
                                    while (1) switch (_context.n) {
                                      case 0:
                                        _this2.img.removeEventListener('load', _handleLoad);
                                        _this2.img.removeEventListener('error', _handleLoad);
                                        if (!(event.type === 'error' && _this2['error-image'])) {
                                          _context.n = 2;
                                          break;
                                        }
                                        _context.n = 1;
                                        return _this2.loadErrorImage(_this2['error-image']);
                                      case 1:
                                        errorResult = _context.v;
                                        _this2.img.src = _this2['error-image'];
                                        return _context.a(2, resolve(errorResult));
                                      case 2:
                                        return _context.a(2, resolve(event));
                                    }
                                  }, _callee);
                                }));
                                return function handleLoad(_x3) {
                                  return _ref3.apply(this, arguments);
                                };
                              }();
                              _this2.img.addEventListener('load', _handleLoad);
                              _this2.img.addEventListener('error', _handleLoad);
                            case 1:
                              return _context2.a(2);
                          }
                        }, _callee2);
                      }));
                      return function (_x2) {
                        return _ref2.apply(this, arguments);
                      };
                    }());
                  case 4:
                    result = _context3.v;
                    if (result.type === 'load') {
                      _this2.querySelector('.mec-figure-empty').style.display = 'none';
                    }
                  case 5:
                    _context3.n = 2;
                    break;
                  case 6:
                    _context3.n = 8;
                    break;
                  case 7:
                    _context3.p = 7;
                    _t = _context3.v;
                    _iterator2.e(_t);
                  case 8:
                    _context3.p = 8;
                    _iterator2.f();
                    return _context3.f(8);
                  case 9:
                    return _context3.a(2);
                }
              }, _callee3, null, [[1, 7, 8, 9]]);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }(), {
            rootMargin: _this2['root-margin'],
            threshold: _this2.threshold
          });
          _this2.intersectionObserver.observe(_this2.img);
        }, 0);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        var _this$intersectionObs, _this$intersectionObs2;
        (_this$intersectionObs = this.intersectionObserver) === null || _this$intersectionObs === void 0 || (_this$intersectionObs2 = _this$intersectionObs.disconnect) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.call(_this$intersectionObs);
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name, oldValue, newValue) {
        this.setAttributes([{
          name: name,
          value: newValue
        }]);
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement)));
};
var getSrcset = function getSrcset(_ref4) {
  var url = _ref4.url,
    _ref4$widthList = _ref4.widthList,
    widthList = _ref4$widthList === void 0 ? [180, 320, 480, 640, 768, 1024, 1280, 1600, 1920, 2560] : _ref4$widthList,
    width = _ref4.width;
  if (!url.includes('shop.luvmehair.com') && !url.includes('cdn.shopify.com')) {
    return url;
  }
  var dotIndex = url.lastIndexOf('.');
  if (!~dotIndex || !url) {
    return url;
  }
  var post = url.slice(dotIndex);
  var pre = url.slice(0, dotIndex);

  // 外面已经压缩过了，不压缩
  var regex = /_\d+x$/;
  if (regex.test(pre)) {
    return url;
  }
  return widthList.reduce(function (r, item) {
    if (!width || Number(width) >= item) {
      r.push("".concat(pre, "_").concat(item, "x").concat(post, " ").concat(item, "w"));
    }
    return r;
  }, []).join(',');
};
var createFigureBase = function createFigureBase(_ref5) {
  var _ref5$source = _ref5.source,
    source = _ref5$source === void 0 ? '' : _ref5$source,
    _ref5$errorImage = _ref5.errorImage,
    errorImage = _ref5$errorImage === void 0 ? '' : _ref5$errorImage,
    _ref5$width = _ref5.width,
    width = _ref5$width === void 0 ? '' : _ref5$width,
    _ref5$height = _ref5.height,
    height = _ref5$height === void 0 ? '' : _ref5$height,
    _ref5$alt = _ref5.alt,
    altByProperties = _ref5$alt === void 0 ? '' : _ref5$alt,
    _ref5$altFormatByLink = _ref5.altFormatByLink,
    altFormatByLink = _ref5$altFormatByLink === void 0 ? false : _ref5$altFormatByLink,
    _ref5$style = _ref5.style,
    style = _ref5$style === void 0 ? '' : _ref5$style,
    _ref5$title = _ref5.title,
    title = _ref5$title === void 0 ? '' : _ref5$title,
    _ref5$className = _ref5.className,
    className = _ref5$className === void 0 ? '' : _ref5$className,
    _ref5$emptyClass = _ref5.emptyClass,
    emptyClass = _ref5$emptyClass === void 0 ? '' : _ref5$emptyClass,
    _ref5$sizes = _ref5.sizes,
    sizes = _ref5$sizes === void 0 ? '' : _ref5$sizes,
    _ref5$rootMarginAttri = _ref5.rootMarginAttribute,
    rootMarginAttribute = _ref5$rootMarginAttri === void 0 ? '0px 0px 0px 0px' : _ref5$rootMarginAttri,
    _ref5$thresholdAttrib = _ref5.thresholdAttribute,
    thresholdAttribute = _ref5$thresholdAttrib === void 0 ? '0.1' : _ref5$thresholdAttrib,
    placeholder = _ref5.placeholder,
    _ref5$emptyImageVisib = _ref5.emptyImageVisible,
    emptyImageVisible = _ref5$emptyImageVisib === void 0 ? true : _ref5$emptyImageVisib;
  var regex = /\/([^/?]+)\.([^/?]+)(\?|$)/;
  var match = source.match(regex);
  var alt = altFormatByLink ? match === null || match === void 0 ? void 0 : match[1] : altByProperties;
  var figure = /* html */"\n    <figure-base\n      root-margin=\"".concat(rootMarginAttribute, "\"\n      threshold=\"").concat(thresholdAttribute, "\"\n      error-image=\"").concat(errorImage, "\"\n    >\n      <img\n        class=\"mec-figure ").concat(className, "\"\n        data-mec-src=\"").concat(source, "\"\n        data-mec-srcset=\"").concat(getSrcset({
    url: source,
    width: width
  }), "\"\n        fetchpriority=\"high\"\n        alt=\"").concat(alt, "\"\n        data-original-alt=\"").concat(altByProperties, "\"\n        width=\"").concat(width !== null && width !== void 0 ? width : '', "\"\n        height=\"").concat(height !== null && height !== void 0 ? height : '', "\"\n        style=\"").concat(style, "\"\n        title=\"").concat(title, "\"\n        ").concat(sizes ? "sizes=\"".concat(sizes, "\"") : '', "\n      >\n      <div class=\"mec-figure-empty ").concat(emptyClass, "\">\n        ").concat(emptyImageVisible ? /* html */"\n            <img\n              alt=\"".concat(alt, "\"\n              data-original-alt=\"").concat(altByProperties, "\"\n              src=\"").concat(placeholder !== null && placeholder !== void 0 ? placeholder : 'https://lmhhair.myshopify.com/cdn/shop/files/LUVME_FOR_YOU.svg', "\"\n            >\n          ") : '', "\n\n      </div>\n    </figure-base>");
  return figure;
};
var getImageScale = function getImageScale(_ref6) {
  var width = _ref6.width,
    height = _ref6.height;
  return "".concat(NP.divide(height, width) * 100, "%");
};
init();

/***/ }),

/***/ 62509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   g: function() { return /* binding */ createGiveawayDialog; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56187);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38690);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89228);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26031);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84159);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2663);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35659);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91270);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13227);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88646);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95822);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48949);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11908);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86225);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(44567);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(3127);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(59139);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(54134);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(14011);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(67887);
/* harmony import */ var core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(47134);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(11431);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(31955);
/* harmony import */ var _snippets_figure_base__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(87205);
/* harmony import */ var _utils_dayjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(13931);
/* harmony import */ var _utils_event_handler__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(25675);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(36792);
/* harmony import */ var _utils_price__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(7448);
/* harmony import */ var _ui_image_preview__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(34720);
/* harmony import */ var _ui_modal__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(49968);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }























/* eslint-disable unicorn/prefer-ternary */
/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable unicorn/no-negated-condition */









var createTabContent = function createTabContent(_ref) {
  var _product$id, _giveaway$jumpLink;
  var giveaway = _ref.giveaway,
    product = _ref.product,
    currentSku = _ref.currentSku,
    tabType = _ref.tabType,
    currentTab = _ref.currentTab,
    tips = _ref.tips,
    selectedGiftSku = _ref.selectedGiftSku,
    fixHeight = _ref.fixHeight,
    disableOrderGiftSelection = _ref.disableOrderGiftSelection,
    sourceType = _ref.sourceType,
    cartTotalPrice = _ref.cartTotalPrice;
  if ((0,lodash_es__WEBPACK_IMPORTED_MODULE_23__/* .isEmpty */ .xb)(giveaway)) {
    return;
  }
  var startTime = (0,_utils_dayjs__WEBPACK_IMPORTED_MODULE_25__/* .formatTime */ .mr)(giveaway.startsTime, 'MMM. D, YYYY, hh:mm A');
  var endTime = (0,_utils_dayjs__WEBPACK_IMPORTED_MODULE_25__/* .formatTime */ .mr)(giveaway.endsTime, 'MMM. D, YYYY, hh:mm A');
  var dateInfo = "".concat(startTime, " - ").concat(endTime);
  if (!giveaway.endsTime || giveaway.endsTime === '0') {
    dateInfo = "Starting at ".concat((0,_utils_dayjs__WEBPACK_IMPORTED_MODULE_25__/* .formatTime */ .mr)(giveaway.startsTime, 'MMM. D, YYYY, hh:mm A'), ", Free Gifts Limited");
  }
  var spec = '';
  if (product) {
    for (var i = 0; i < currentSku.options.length; i++) {
      spec += "".concat(product.options[i], ": ").concat(currentSku.options[i]);
      if (i < currentSku.options.length - 1) {
        spec += '<br>';
      }
    }
  }
  var giftContent = '';
  if (tabType === 'product') {
    giftContent = buildProductGiftTemplate(giveaway, selectedGiftSku, tabType, sourceType);
  } else if (tabType === 'order') {
    giftContent = buildOrderGiftTemplate(giveaway, selectedGiftSku, tabType, disableOrderGiftSelection, sourceType, cartTotalPrice);
  }
  var abTestImage = getAbTestMainImage((_product$id = product === null || product === void 0 ? void 0 : product.id) !== null && _product$id !== void 0 ? _product$id : '');
  return "\n    <div class=\"giveaway ".concat(tabType, "-giveaway ").concat(tabType !== currentTab ? 'hide' : '', " ").concat(fixHeight ? 'fix-height' : '', "\">\n      ").concat(giveaway.displayTimeFlag === 'TRUE' ? "<div\n        class=\"giveaway__date ".concat(tabType, "\n        ").concat(giveaway.startsTime || giveaway.endsTime ? '' : 'hide', "\"\n        data-link=\"").concat((_giveaway$jumpLink = giveaway.jumpLink) !== null && _giveaway$jumpLink !== void 0 ? _giveaway$jumpLink : '', "\"\n      >\n        <div class=\"giveaway__date__range\">").concat(dateInfo, "</div>\n        ").concat(giveaway.jumpLink ? '<div class="giveaway__date__link">More Events &gt;</div>' : '', "\n      </div>") : '', "\n      ").concat(tabType === 'product' ? "<p class=\"giveaway__description\">Purchase the specified item to get  free gift</p>" : '', "\n\n      ").concat(product && tabType === 'product' ? "\n            <div class=\"giveaway__product\">\n              <div class=\"giveaway__product__image\">\n                ".concat((0,_snippets_figure_base__WEBPACK_IMPORTED_MODULE_24__/* .createFigureBase */ .k)({
    source: abTestImage || (product === null || product === void 0 ? void 0 : product.featured_image) || '',
    errorImage: 'https://shop.luvmehair.com/cdn/shop/files/product_image_placeholder.png',
    className: 'product-image',
    emptyClass: 'product-image-placeholder'
  }), "\n              </div>\n              <p class=\"giveaway__product__variants\">").concat(spec, "</p>\n            </div>\n            ") : '', "\n\n      ").concat(giftContent, "\n      <div class=\"giveaway__tips\">").concat(tips !== null && tips !== void 0 ? tips : '', "</div>\n    </div>");
};
var buildProductGiftTemplate = function buildProductGiftTemplate(giveaway, selectedGiftSku, tabType, sourceType) {
  var _giveaway$frontActivi;
  if ((0,lodash_es__WEBPACK_IMPORTED_MODULE_23__/* .isEmpty */ .xb)(giveaway)) {
    return;
  }
  var giftContent = '';
  var groupList = (_giveaway$frontActivi = giveaway.frontActivityGiftGroupVoList) !== null && _giveaway$frontActivi !== void 0 ? _giveaway$frontActivi : [];
  var isFirstItem = true;
  var _iterator = _createForOfIteratorHelper(groupList),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var group = _step.value;
      var _iterator2 = _createForOfIteratorHelper(group.frontActivityGiftList),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var gift = _step2.value;
          var selectable = giveaway.giftOptional === 'OPTIONAL';
          var selected = selectable && ((selectedGiftSku === null || selectedGiftSku === void 0 ? void 0 : selectedGiftSku.skuCode) === gift.skuCode && (selectedGiftSku === null || selectedGiftSku === void 0 ? void 0 : selectedGiftSku.groupId) === group.activityGiftGroupId || !selectedGiftSku && isFirstItem);
          giftContent += giftTemplate({
            gift: gift,
            selected: selected,
            selectable: selectable,
            giftType: tabType,
            groupId: group.activityGiftGroupId,
            activityInfoCode: giveaway.activityInfoCode,
            showActivityName: giveaway.showActivityName,
            frontSkuCode: giveaway.frontSkuCode,
            frontSpuCode: giveaway.frontSpuCode,
            giftSpuCode: gift.frontSpuCode,
            sourceType: sourceType
          });
          isFirstItem = false;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return giftContent;
};
var buildOrderGiftTemplate = function buildOrderGiftTemplate(giveaway, selectedGiftSku, tabType, disableSelect, sourceType, cartTotalPrice) {
  if ((0,lodash_es__WEBPACK_IMPORTED_MODULE_23__/* .isEmpty */ .xb)(giveaway)) {
    return;
  }
  var giftContent = '';
  var isFirstItem = true;
  var _iterator3 = _createForOfIteratorHelper(giveaway === null || giveaway === void 0 ? void 0 : giveaway.frontActivityGiftGroupMapVoList),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var giftGroup = _step3.value;
      if (giftGroup.priceLevel > 0) {
        giftContent += "<div class=\"giveaway__group-title\">Order over <span class=\"highlight\">".concat(window.__UWINS_GIVEAWAY_CURRENCY__ || 'R').concat((0,_utils_price__WEBPACK_IMPORTED_MODULE_28__/* .formatPrice */ .T)(giftGroup.priceLevel), "</span> get free gift</div>");
      } else {
        giftContent += "<div class=\"giveaway__group-title\">Get free gift with an order</div>";
      }
      var _iterator4 = _createForOfIteratorHelper(giftGroup.giftGroupList),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var group = _step4.value;
          var _iterator5 = _createForOfIteratorHelper(group.frontActivityGiftList),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var gift = _step5.value;
              var selectable = !disableSelect && giveaway.giftOptional === 'OPTIONAL';
              var selected = (selectedGiftSku === null || selectedGiftSku === void 0 ? void 0 : selectedGiftSku.skuCode) === gift.skuCode && (selectedGiftSku === null || selectedGiftSku === void 0 ? void 0 : selectedGiftSku.groupId) === group.activityGiftGroupId || !selectedGiftSku && isFirstItem;
              giftContent += giftTemplate({
                gift: gift,
                selected: selected,
                selectable: selectable,
                giftType: tabType,
                groupId: group.activityGiftGroupId,
                activityInfoCode: giveaway.activityInfoCode,
                showActivityName: giveaway.showActivityName,
                frontSkuCode: '',
                frontSpuCode: '',
                giftSpuCode: gift.frontSpuCode,
                sourceType: sourceType,
                disableSelect: disableSelect,
                optimalPriceLevel: giveaway.optimalPriceLevel,
                cartTotalPrice: cartTotalPrice
              });
              isFirstItem = false;
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return giftContent;
};
var getAbTestMainImage = function getAbTestMainImage(spuId) {
  try {
    var s = localStorage.getItem('IMG_AB_TEST');
    if (s) {
      var array = JSON.parse(s);
      var item = array.find(function (item) {
        return item.mainParam === "".concat(spuId);
      });
      return item === null || item === void 0 ? void 0 : item.groupContent;
    }
  } catch (_unused) {
    return undefined;
  }
};
var priceToString = function priceToString(price) {
  if (price !== null && price !== undefined) {
    return "".concat(window.__UWINS_GIVEAWAY_CURRENCY__ || 'R').concat((0,_utils_price__WEBPACK_IMPORTED_MODULE_28__/* .formatPrice */ .T)(price));
  }
  return '';
};
var giftTemplate = function giftTemplate(_ref2) {
  var _ref3, _gift$spuTitle, _gift$image, _gift$spuTitle2, _gift$skuTitle;
  var gift = _ref2.gift,
    selected = _ref2.selected,
    selectable = _ref2.selectable,
    giftType = _ref2.giftType,
    groupId = _ref2.groupId,
    activityInfoCode = _ref2.activityInfoCode,
    showActivityName = _ref2.showActivityName,
    frontSkuCode = _ref2.frontSkuCode,
    frontSpuCode = _ref2.frontSpuCode,
    giftSpuCode = _ref2.giftSpuCode,
    sourceType = _ref2.sourceType,
    disableSelect = _ref2.disableSelect,
    optimalPriceLevel = _ref2.optimalPriceLevel,
    cartTotalPrice = _ref2.cartTotalPrice;
  return "\n      <div\n        class=\"giveaway__gift\" gift-selected=\"".concat((_ref3 = selectable && selected) !== null && _ref3 !== void 0 ? _ref3 : '', "\"\n        gift-selectable=\"").concat(selectable ? 'true' : 'false', "\"\n        gift-type=\"").concat(giftType, "\"\n        gift-sku-code=\"").concat(gift.skuCode, "\"\n        gift-group-id=\"").concat(groupId, "\"\n        gift-activity-info-code=\"").concat(activityInfoCode, "\"\n        gift-show-activity-name=\"").concat(showActivityName, "\"\n        gift-front-sku-code=\"").concat(frontSkuCode, "\"\n        gift-front-spu-code=\"").concat(frontSpuCode, "\"\n        gift-gift-spu-code=\"").concat(giftSpuCode, "\"\n        gift-source-type=\"").concat(sourceType, "\"\n        gift-gift-title=\"").concat((_gift$spuTitle = gift.spuTitle) !== null && _gift$spuTitle !== void 0 ? _gift$spuTitle : '', "\"\n        gift-disable-select=\"").concat(disableSelect ? 'true' : 'false', "\"\n        gift-optimal-price-level=\"").concat(optimalPriceLevel !== null && optimalPriceLevel !== void 0 ? optimalPriceLevel : '', "\"\n        gift-cart-total-price=\"").concat(cartTotalPrice !== null && cartTotalPrice !== void 0 ? cartTotalPrice : '', "\"\n      >\n        <div class=\"giveaway__gift__image\">\n          ").concat((0,_snippets_figure_base__WEBPACK_IMPORTED_MODULE_24__/* .createFigureBase */ .k)({
    source: (_gift$image = gift.image) !== null && _gift$image !== void 0 ? _gift$image : '',
    errorImage: 'https://shop.luvmehair.com/cdn/shop/files/product_image_placeholder.png',
    className: 'gift-image',
    emptyClass: 'gift-image-placeholder'
  }), "\n        </div>\n        <div class=\"giveaway__gift__info\">\n          <div class=\"titles-row\">\n            <div class=\"titles-box\">\n              <p class=\"giveaway__gift__title\"><span class=\"free-gift\">FREE GIFT</span> ").concat((_gift$spuTitle2 = gift.spuTitle) !== null && _gift$spuTitle2 !== void 0 ? _gift$spuTitle2 : '', "</p>\n              <p class=\"giveaway__gift__variants\">").concat((_gift$skuTitle = gift.skuTitle) !== null && _gift$skuTitle !== void 0 ? _gift$skuTitle : '', "</p>\n            </div>\n                  ").concat(selectable ? "<svg class=\"mec-icon giveaway__gift__checkbox checked\" aria-hidden=\"true\">\n                          <use xlink:href=\"#mec-a-xuanzhongyuan\"></use>\n                        </svg>\n                        <svg class=\"mec-icon giveaway__gift__checkbox unckecked\" aria-hidden=\"true\">\n                          <use xlink:href=\"#mec-a-weixuanzhongyuan\"></use>\n                        </svg>" : '', "\n          </div>\n          <div class=\"giveaway__gift__price-row\">\n            <p class=\"giveaway__gift__price\">\n            <span class=\"giveaway__gift__price--highlight\">").concat(priceToString(gift.giftPrice), "</span>\n              <span class=\"giveaway__gift__price--disabled\">").concat(priceToString(gift.originalPrice), "</span>\n            </p>\n            <div class=\"giveaway__gift__quantity\">x").concat(gift.totalQuantity, "</div>\n          </div>\n        </div>\n      </div>");
};
var getGiveawayTemplate = function getGiveawayTemplate(_ref4) {
  var productGiveaway = _ref4.productGiveaway,
    orderGiveaway = _ref4.orderGiveaway,
    product = _ref4.product,
    currentSku = _ref4.currentSku,
    currentTab = _ref4.currentTab,
    selectedProductGiftSku = _ref4.selectedProductGiftSku,
    selectedOrderGiftSku = _ref4.selectedOrderGiftSku,
    disableOrderGiftSelection = _ref4.disableOrderGiftSelection,
    sourceType = _ref4.sourceType,
    cartTotalPrice = _ref4.cartTotalPrice;
  var fixHeight = productGiveaway && orderGiveaway;
  return "\n      ".concat(!(0,lodash_es__WEBPACK_IMPORTED_MODULE_23__/* .isEmpty */ .xb)(productGiveaway) ? createTabContent({
    giveaway: productGiveaway,
    product: product,
    currentSku: currentSku,
    currentTab: currentTab,
    selectedGiftSku: selectedProductGiftSku,
    tabType: 'product',
    tips: productGiveaway === null || productGiveaway === void 0 ? void 0 : productGiveaway.activityRule,
    fixHeight: fixHeight,
    sourceType: sourceType
  }) : '', "\n      ").concat(!(0,lodash_es__WEBPACK_IMPORTED_MODULE_23__/* .isEmpty */ .xb)(orderGiveaway) ? createTabContent({
    giveaway: orderGiveaway,
    product: product,
    currentSku: currentSku,
    currentTab: currentTab,
    selectedGiftSku: selectedOrderGiftSku,
    tabType: 'order',
    tips: orderGiveaway === null || orderGiveaway === void 0 ? void 0 : orderGiveaway.activityRule,
    fixHeight: fixHeight,
    disableOrderGiftSelection: disableOrderGiftSelection,
    sourceType: sourceType,
    cartTotalPrice: cartTotalPrice
  }) : '', "\n     ");
};
var getGiveawayTitle = function getGiveawayTitle(_ref5) {
  var productGiveaway = _ref5.productGiveaway,
    orderGiveaway = _ref5.orderGiveaway,
    currentTab = _ref5.currentTab;
  if ((0,lodash_es__WEBPACK_IMPORTED_MODULE_23__/* .isEmpty */ .xb)(productGiveaway) && (0,lodash_es__WEBPACK_IMPORTED_MODULE_23__/* .isEmpty */ .xb)(orderGiveaway)) {
    return '';
  } else if (!(0,lodash_es__WEBPACK_IMPORTED_MODULE_23__/* .isEmpty */ .xb)(productGiveaway) && (0,lodash_es__WEBPACK_IMPORTED_MODULE_23__/* .isEmpty */ .xb)(orderGiveaway)) {
    var _productGiveaway$show;
    return (_productGiveaway$show = productGiveaway.showActivityName) !== null && _productGiveaway$show !== void 0 ? _productGiveaway$show : '';
  } else if (!(0,lodash_es__WEBPACK_IMPORTED_MODULE_23__/* .isEmpty */ .xb)(orderGiveaway) && (0,lodash_es__WEBPACK_IMPORTED_MODULE_23__/* .isEmpty */ .xb)(productGiveaway)) {
    var _orderGiveaway$showAc;
    return (_orderGiveaway$showAc = orderGiveaway.showActivityName) !== null && _orderGiveaway$showAc !== void 0 ? _orderGiveaway$showAc : '';
  }
  return "\n    <div class=\"giveaway-tab\">\n      <label class=\"giveaway-tab__item\">\n        <input type=\"radio\" name=\"giveaway-type\" value=\"product\" index=\"0\" ".concat(currentTab === 'product' ? 'checked' : '', " >\n        <span class=\"giveaway-tab__item__text\">PRODUCT FREEBIES</span>\n      </label>\n      <label class=\"giveaway-tab__item\">\n        <input type=\"radio\" name=\"giveaway-type\" value=\"order\" index=\"1\" ").concat(currentTab === 'order' ? 'checked' : '', " >\n        <span class=\"giveaway-tab__item__text\">ORDER FREEBIES</span>\n      </label>\n    </div>");
};
var getGiftDataReport = function getGiftDataReport(preview, eventType) {
  if (preview) {
    var _window$dataLayer, _window$dataLayer$pus;
    var productName = preview.getAttribute('gift-type') === 'product' ? 'Goods_gift' : 'Order_gift';
    var promotionId = productName + '_' + preview.getAttribute('gift-activity-info-code') + '_' + preview.getAttribute('gift-group-id');
    var promotionName = preview.getAttribute('gift-show-activity-name');
    var eventLabel = preview.getAttribute('gift-type') === 'order' ? 'none' : preview.getAttribute('gift-front-spu-code') + '_' + preview.getAttribute('gift-front-sku-code');
    var promotion = {
      event_label: eventLabel,
      promotion_id: promotionId,
      promotion_name: promotionName
    };
    if (eventType === 'window_map_click') {
      promotion.event_label = 'freegift_' + preview.getAttribute('gift-activity-info-code');
      promotion.product_name = preview.getAttribute('gift-gift-title');
      promotion.product_id = preview.getAttribute('gift-gift-spu-code');
    }
    if (eventType === 'change_freegift' && preview.getAttribute('gift-type') === 'order') {
      promotion.event_label = 'none';
    }
    if ((eventType === 'more_freegift_pro' || eventType === 'view_freegift') && preview.getAttribute('gift-type') === 'order') {
      promotion.event_label = 'none';
      if (preview.getAttribute('gift-source-type') === 'product') {
        promotion.event_label = 'ProductPage';
      }
      if (preview.getAttribute('gift-source-type') === 'cart') {
        var optimalPrice = preview.getAttribute('gift-optimal-price-level');
        var totalPrice = preview.getAttribute('gift-cart-total-price');
        if (Number(optimalPrice) === 0 || Number(totalPrice) <= Number(optimalPrice)) {
          promotion.event_label = 'cart_recommended_OrderGift';
        } else {
          promotion.event_label = 'none';
        }
      }
    }
    (_window$dataLayer = window.dataLayer) === null || _window$dataLayer === void 0 || (_window$dataLayer$pus = _window$dataLayer.push) === null || _window$dataLayer$pus === void 0 || _window$dataLayer$pus.call(_window$dataLayer, {
      ecommerce: null
    });
    window.dataLayer.push(_objectSpread({
      event: 'uaEvent',
      event_type: eventType
    }, promotion));
  }
};
var createGiveawayDialog = function createGiveawayDialog(_ref6) {
  var productGiveaway = _ref6.productGiveaway,
    orderGiveaway = _ref6.orderGiveaway,
    product = _ref6.product,
    currentSku = _ref6.currentSku,
    currentTab = _ref6.currentTab,
    giftChangeCallback = _ref6.giftChangeCallback,
    subscribeKey = _ref6.subscribeKey,
    selectedProductGiftSku = _ref6.selectedProductGiftSku,
    selectedOrderGiftSku = _ref6.selectedOrderGiftSku,
    disableOrderGiftSelection = _ref6.disableOrderGiftSelection,
    sourceType = _ref6.sourceType,
    cartTotalPrice = _ref6.cartTotalPrice;
  var dialog = new _ui_modal__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z({
    duration: 0,
    template: getGiveawayTemplate({
      productGiveaway: productGiveaway,
      orderGiveaway: orderGiveaway,
      product: product,
      currentSku: currentSku,
      currentTab: currentTab,
      selectedProductGiftSku: selectedProductGiftSku,
      selectedOrderGiftSku: selectedOrderGiftSku,
      disableOrderGiftSelection: disableOrderGiftSelection,
      sourceType: sourceType,
      cartTotalPrice: cartTotalPrice
    }),
    mask: 'true',
    'mobile-placement': 'bottom',
    subscribeKey: subscribeKey
  });
  dialog.create({
    useDefaultTemplate: true,
    title: getGiveawayTitle({
      productGiveaway: productGiveaway,
      orderGiveaway: orderGiveaway,
      currentTab: currentTab
    }),
    className: 'giveaway-dialog'
  });
  var giveawayTabFn = function giveawayTabFn(sourceType) {
    var giveawayTab = dialog.node.querySelector('.giveaway-tab');
    var dialogView = '';
    if (giveawayTab) {
      // 获取被选中的单选按钮的值
      var checkTab = giveawayTab.querySelector('input[type="radio"]:checked').value;
      // 根据单选按钮的值来选择不同的dom
      if (checkTab === 'product') {
        var _dialog$node$querySel;
        dialogView = (_dialog$node$querySel = dialog.node.querySelector('.product-giveaway [gift-selected="true"].giveaway__gift')) !== null && _dialog$node$querySel !== void 0 ? _dialog$node$querySel : dialog.node.querySelector('.product-giveaway .giveaway__gift');
      } else {
        dialogView = dialog.node.querySelector('.order-giveaway .giveaway__gift');
      }
    } else {
      if (currentTab === 'product') {
        var _dialog$node$querySel2;
        dialogView = (_dialog$node$querySel2 = dialog.node.querySelector('.mec-modal-default-content [gift-selected="true"].giveaway__gift')) !== null && _dialog$node$querySel2 !== void 0 ? _dialog$node$querySel2 : dialog.node.querySelector('.mec-modal-default-content .giveaway__gift');
      } else {
        if (disableOrderGiftSelection) {
          dialogView = dialog.node.querySelector('.order-giveaway .giveaway__gift');
        } else {
          dialogView = dialog.node.querySelector('.mec-modal-default-content [gift-selected="true"].giveaway__gift');
        }
      }
    }
    getGiftDataReport(dialogView, sourceType);
  };
  giveawayTabFn('view_freegift');
  if (!(0,lodash_es__WEBPACK_IMPORTED_MODULE_23__/* .isEmpty */ .xb)(productGiveaway) && !(0,lodash_es__WEBPACK_IMPORTED_MODULE_23__/* .isEmpty */ .xb)(orderGiveaway)) {
    (0,_utils_event_handler__WEBPACK_IMPORTED_MODULE_26__.on)('change', '.giveaway-tab__item input', function (e) {
      var productTabContent = dialog.node.querySelector('.giveaway.product-giveaway');
      var orderTabContent = dialog.node.querySelector('.giveaway.order-giveaway');
      if (e.currentTarget.value === 'product') {
        productTabContent.classList.remove('hide');
        orderTabContent.classList.add('hide');
      } else {
        productTabContent.classList.add('hide');
        orderTabContent.classList.remove('hide');
      }
      var dialogView = '';
      if (e.currentTarget.value === 'product') {
        var _dialog$node$querySel3;
        dialogView = (_dialog$node$querySel3 = dialog.node.querySelector('.mec-modal-default-content [gift-selected="true"].giveaway__gift')) !== null && _dialog$node$querySel3 !== void 0 ? _dialog$node$querySel3 : dialog.node.querySelector('.mec-modal-default-content .giveaway__gift');
      } else {
        if (disableOrderGiftSelection) {
          dialogView = dialog.node.querySelector('.order-giveaway .giveaway__gift');
        } else {
          dialogView = dialog.node.querySelector('.mec-modal-default-content [gift-selected="true"].giveaway__gift');
        }
      }
      getGiftDataReport(dialogView, 'view_freegift');
    }, {}, dialog.node);
  }
  (0,_utils_event_handler__WEBPACK_IMPORTED_MODULE_26__.on)('click', '.giveaway__date', function (e) {
    var link = e.currentTarget.dataset.link;
    if (link) {
      location.href = link;
      giveawayTabFn('more_freegift_pro');
    }
  }, {}, dialog.node);
  (0,_utils_event_handler__WEBPACK_IMPORTED_MODULE_26__.on)('click', 'div[gift-selectable="true"].giveaway__gift', function (e) {
    var ele = e.currentTarget;
    if (ele.dataset.giftSelected === 'true') {
      return;
    }
    var preview = ele.parentNode.querySelector('[gift-selected="true"].giveaway__gift');
    preview.setAttribute('gift-selected', 'false');
    ele.setAttribute('gift-selected', 'true');
    if (giftChangeCallback) {
      giftChangeCallback({
        giftType: ele.getAttribute('gift-type'),
        previewSkuCode: preview.getAttribute('gift-sku-code'),
        previewGroupId: preview.getAttribute('gift-group-id'),
        currentSkuCode: ele.getAttribute('gift-sku-code'),
        currentGroupId: ele.getAttribute('gift-group-id')
      });
      getGiftDataReport(ele, 'change_freegift');
    }
  }, {}, dialog.node);
  (0,_utils_event_handler__WEBPACK_IMPORTED_MODULE_26__.on)('click', '.gift-image', function (e) {
    var image = e.currentTarget.src;
    if (_utils_misc__WEBPACK_IMPORTED_MODULE_27__/* .isMobile */ .tq && !(0,lodash_es__WEBPACK_IMPORTED_MODULE_23__/* .isEmpty */ .xb)(image)) {
      (0,_ui_image_preview__WEBPACK_IMPORTED_MODULE_29__/* .showImagePreview */ .V)({
        images: [image]
      });
      var dialogView = e.target.closest('.giveaway__gift');
      getGiftDataReport(dialogView, 'window_map_click');
      e.stopImmediatePropagation();
    }
  }, {}, dialog.node);
  return dialog;
};


/***/ }),

/***/ 95974:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _ui_iconfont_iconfont__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46786);
/* harmony import */ var _ui_iconfont_iconfont__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ui_iconfont_iconfont__WEBPACK_IMPORTED_MODULE_0__);


/***/ }),

/***/ 34606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  y: function() { return /* reexport */ createLazyPicture; }
});

// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(56187);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(38690);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(89228);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(26031);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(84159);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91270);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(44901);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(13227);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(88646);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(95822);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(48949);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__(81970);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(11908);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(39574);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(43908);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(81414);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(36763);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(59139);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(54134);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(14011);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.weak-map.js
var es_weak_map = __webpack_require__(84750);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.weak-set.js
var es_weak_set = __webpack_require__(77991);
// EXTERNAL MODULE: ../node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(11431);
// EXTERNAL MODULE: ./utils/lodash.js
var lodash = __webpack_require__(31955);
// EXTERNAL MODULE: ./utils/rIC.js
var rIC = __webpack_require__(24681);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(66066);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(89034);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.last-index-of.js
var es_array_last_index_of = __webpack_require__(45608);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__(92815);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.number.parse-int.js
var es_number_parse_int = __webpack_require__(11101);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__(21413);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(33370);
// EXTERNAL MODULE: ../node_modules/number-precision/build/index.es.js
var index_es = __webpack_require__(17887);
;// CONCATENATED MODULE: ./snippets/lazy-picture/src/utils.js
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }























var filterObject = function filterObject(properties) {
  return Object.entries(properties).reduce(function (r, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (value) {
      r = "".concat(r, " ").concat(key, "=\"").concat(value, "\"");
    }
    return r;
  }, '');
};

/**
 * 移动端 srcset 宽度配置（保持不变 - 已是最佳配置）
 * 覆盖 1x-3x 像素密度的移动设备
 */
var mobileImageWidths = [640, 1024, 1536];

/**
 * PC 端 srcset 宽度配置
 * 关键断点：1024w, 1536w, 1920w
 */
var imageWidths = [1024, 1536, 1920];

/**
 * srcset 结果缓存（性能优化：避免重复计算）
 * 800个实例 × 多次调用 = 大量重复计算
 * 使用 Map 缓存后，相同参数直接返回缓存结果
 */
var srcsetCache = new Map();
var getSrcset = function getSrcset(_ref3) {
  var url = _ref3.url,
    widthList = _ref3.widthList,
    width = _ref3.width,
    mobile = _ref3.mobile;
  if (!url) {
    return url;
  }
  if (!url.includes('shop.luvmehair.com') && !url.includes('cdn.shopify.com')) {
    return url;
  }

  // 生成缓存key
  var cacheKey = "".concat(url, "-").concat(width, "-").concat(mobile ? '1' : '0');

  // 检查缓存
  if (srcsetCache.has(cacheKey)) {
    return srcsetCache.get(cacheKey);
  }
  var dotIndex = url.lastIndexOf('.');
  if (!~dotIndex) {
    return url;
  }
  var post = url.slice(dotIndex);
  var pre = url.slice(0, dotIndex);

  // 外面已经压缩过了，不压缩
  var regex = /_\d+x$/;
  if (regex.test(pre)) {
    return url;
  }
  var formatWidthList = widthList || (mobile ? mobileImageWidths : imageWidths);

  /**
   * 生成 srcset 字符串
   * @description 
   * - 移动端和 PC 端都使用 1.5 倍率压缩（与 Liquid 模板保持一致）
   * - 实际图片宽度 = srcset 宽度 / 1.5
   * - 例如：1024w 对应实际图片宽度 683px (1024/1.5≈683)
   */
  var result = formatWidthList.reduce(function (r, item) {
    if (!width || Number(width) >= item) {
      // 除以 1.5 倍率，与 Liquid 模板中的逻辑保持一致
      r.push("".concat(pre, "_").concat(Number.parseInt(item / 1.3), "x").concat(post, " ").concat(item, "w"));
    }
    return r;
  }, []).join(',');

  // 缓存结果（限制缓存大小，避免内存泄漏）
  if (srcsetCache.size < 1000) {
    srcsetCache.set(cacheKey, result);
  }
  return result;
};
var getImageScale = function getImageScale(_ref4) {
  var width = _ref4.width,
    height = _ref4.height;
  return "".concat(NP.divide(height, width) * 100, "%");
};

;// CONCATENATED MODULE: ./snippets/lazy-picture/src/core.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = core_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function core_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return core_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? core_arrayLikeToArray(r, a) : void 0; } }
function core_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }























/**
 * @file lazy-picture 懒加载图片组件
 * @description 响应式图片懒加载自定义元素，支持三种加载模式
 * @author Luvme Team
 * @created 2024
 *
 * @features
 * - 三种加载模式：eager(立即), idle(空闲), lazy(懒加载)
 * - 响应式图片：支持 PC/Mobile 不同图源
 * - 自动生成 srcset 适配不同分辨率
 * - 骨架屏占位
 * - 错误降级处理
 * - 属性动态更新
 */




var ERROR_IMAGE_SOURCE = 'https://shop.luvmehair.com/cdn/shop/files/LUVME_FOR_YOU.svg';
var LOADING_STATE = {
  NOT_LOADED: 'NOT_LOADED',
  LOADING: 'LOADING',
  LOADED: 'LOADED'
};
var sharedLazyObserver;
var observerTargets = new WeakMap();

/**
 * 获取或创建共享的 IntersectionObserver
 * @description 全局仅一个 Observer 实例，所有 lazy-picture 共享
 * @returns {IntersectionObserver}
 */
function getSharedObserver() {
  if (!sharedLazyObserver) {
    sharedLazyObserver = new IntersectionObserver(function (entries) {
      var _iterator = _createForOfIteratorHelper(entries),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          if (!entry.isIntersecting) continue;
          var callback = observerTargets.get(entry.target);
          if (callback) {
            callback();
            sharedLazyObserver.unobserve(entry.target);
            observerTargets.delete(entry.target);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }, {
      rootMargin: '0px 0px 200px 0px',
      threshold: 0
    });
  }
  return sharedLazyObserver;
}
var pendingObserve = [];
var observeScheduled = false;

/**
 * 批量注册 Observer
 * @description 将多个元素的注册合并到同一帧，减少主线程阻塞
 * @param {HTMLElement} element - 待观察的元素
 * @param {Function} callback - 回调函数
 */
function scheduleObserve(element, callback) {
  observerTargets.set(element, callback);
  pendingObserve.push(element);
  if (!observeScheduled) {
    observeScheduled = true;
    setTimeout(function () {
      var observer = getSharedObserver();
      for (var _i = 0, _pendingObserve = pendingObserve; _i < _pendingObserve.length; _i++) {
        var _element = _pendingObserve[_i];
        try {
          observer.observe(_element);
        } catch (_unused) {
          // swallow
        }
      }
      pendingObserve.length = 0;
      observeScheduled = false;
    }, 0);
  }
}
var pendingDOMUpdates = [];
var rafScheduled = false;

/**
 * 批量DOM更新
 * @description 将多个DOM操作合并到同一个requestAnimationFrame中执行
 * @param {Function} updateFunction - DOM更新函数
 */
function batchDOMUpdate(updateFunction) {
  pendingDOMUpdates.push(updateFunction);
  if (!rafScheduled) {
    rafScheduled = true;
    requestAnimationFrame(function () {
      // 在同一帧中执行所有待更新的DOM操作
      for (var _i2 = 0, _pendingDOMUpdates = pendingDOMUpdates; _i2 < _pendingDOMUpdates.length; _i2++) {
        var _updateFunction = _pendingDOMUpdates[_i2];
        _updateFunction();
      }
      pendingDOMUpdates.length = 0;
      rafScheduled = false;
    });
  }
}
var _picture = /*#__PURE__*/new WeakMap();
var _image = /*#__PURE__*/new WeakMap();
var _mobileImage = /*#__PURE__*/new WeakMap();
var _mask = /*#__PURE__*/new WeakMap();
var _mounted = /*#__PURE__*/new WeakMap();
var _state = /*#__PURE__*/new WeakMap();
var _LazyPicture_brand = /*#__PURE__*/new WeakSet();
var _handleLoad = /*#__PURE__*/new WeakMap();
var _handleAttributeChange = /*#__PURE__*/new WeakMap();
var LazyPicture = /*#__PURE__*/function (_HTMLElement) {
  function LazyPicture() {
    var _this;
    _classCallCheck(this, LazyPicture);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LazyPicture, [].concat(args));
    /**
     * 初始化组件
     * @description 根据 mode 属性决定加载策略
     * @side-effects
     *   - eager: 立即加载图片
     *   - idle: requestIdleCallback 空闲时加载
     *   - lazy: 启动 IntersectionObserver 懒加载
     */
    _classPrivateMethodInitSpec(_this, _LazyPicture_brand);
    _classPrivateFieldInitSpec(_this, _picture, void 0);
    _classPrivateFieldInitSpec(_this, _image, void 0);
    _classPrivateFieldInitSpec(_this, _mobileImage, void 0);
    _classPrivateFieldInitSpec(_this, _mask, void 0);
    _classPrivateFieldInitSpec(_this, _mounted, false);
    _classPrivateFieldInitSpec(_this, _state, {
      /**
       * eager 立刻加载
       * idle 空闲时加载
       * lazy 懒加载
       */
      mode: 'lazy',
      loadingState: LOADING_STATE.NOT_LOADED,
      errorImageSource: ERROR_IMAGE_SOURCE
    });
    /**
     * 图片加载完成/错误回调
     * @param {Event} event - load 或 error 事件
     * @description 处理图片加载结果，隐藏骨架屏或显示错误图
     * @side-effects
     *   - 隐藏骨架屏（添加 --hidden 类）
     *   - 错误时：设置降级图片，清除 srcset
     *   - 移除事件监听器
     *   - 通知加载队列（释放并发槽位）
     */
    _classPrivateFieldInitSpec(_this, _handleLoad, function (event) {
      var _classPrivateFieldGet2, _classPrivateFieldGet3, _classPrivateFieldGet4;
      _classPrivateFieldGet(_state, _this).loadingState = LOADING_STATE.LOADED;
      if (event.type === 'error') {
        if (!_classPrivateFieldGet(_state, _this).errorImageSource) return;

        // 设置错误图，清除 srcset 避免冲突
        _classPrivateFieldGet(_image, _this).setAttribute('src', _classPrivateFieldGet(_state, _this).errorImageSource);
        _classPrivateFieldGet(_image, _this).removeAttribute('srcset');
        if (_classPrivateFieldGet(_mobileImage, _this)) {
          _classPrivateFieldGet(_mobileImage, _this).setAttribute('src', _classPrivateFieldGet(_state, _this).errorImageSource);
          _classPrivateFieldGet(_mobileImage, _this).removeAttribute('srcset');
        }
      }
      (_classPrivateFieldGet2 = _classPrivateFieldGet(_mask, _this)) === null || _classPrivateFieldGet2 === void 0 || _classPrivateFieldGet2.classList.add('mec-lazy-picture__mask--hidden');

      // 清理监听器
      (_classPrivateFieldGet3 = _classPrivateFieldGet(_image, _this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.removeEventListener('load', _classPrivateFieldGet(_handleLoad, _this));
      (_classPrivateFieldGet4 = _classPrivateFieldGet(_image, _this)) === null || _classPrivateFieldGet4 === void 0 || _classPrivateFieldGet4.removeEventListener('error', _classPrivateFieldGet(_handleLoad, _this));
    });
    /**
     * 处理属性变化（防抖）
     * @description 监听 src/alt/mobile-src/mobile-alt 变化，根据加载状态决定更新策略
     * @debounce 80ms
     * @side-effects
     *   - 未加载状态：更新 data-* 属性
     *   - 已加载状态：重新加载图片并显示骨架屏
     */
    _classPrivateFieldInitSpec(_this, _handleAttributeChange, (0,lodash/* debounce */.Ds)(function () {
      var _classPrivateFieldGet7, _classPrivateFieldGet8;
      var newSource = _this.getAttribute('src');
      var newMobileSource = _this.getAttribute('mobile-src');
      var newAlt = _this.getAttribute('alt');
      var newMobileAlt = _this.getAttribute('mobile-alt');
      if (newAlt) {
        var _classPrivateFieldGet5;
        (_classPrivateFieldGet5 = _classPrivateFieldGet(_image, _this)) === null || _classPrivateFieldGet5 === void 0 || _classPrivateFieldGet5.setAttribute('alt', newAlt);
      }
      if (newMobileAlt) {
        var _classPrivateFieldGet6;
        (_classPrivateFieldGet6 = _classPrivateFieldGet(_mobileImage, _this)) === null || _classPrivateFieldGet6 === void 0 || _classPrivateFieldGet6.setAttribute('alt', newMobileAlt);
      }

      /**
       * 生成 PC 端 srcset
       * @description getSrcset 函数会自动将宽度除以 1.5 倍率（与 Liquid 模板保持一致）
       * @see utils.js getSrcset 函数
       */
      var newSrcset = getSrcset({
        url: newSource,
        width: (_classPrivateFieldGet7 = _classPrivateFieldGet(_image, _this)) === null || _classPrivateFieldGet7 === void 0 ? void 0 : _classPrivateFieldGet7.getAttribute('width'),
        mobile: false
      });

      /**
       * 生成移动端 srcset
       * @description getSrcset 函数会自动将宽度除以 1.5 倍率（与 Liquid 模板保持一致）
       * @see utils.js getSrcset 函数
       */
      var newMobileSrcset = getSrcset({
        url: newMobileSource,
        width: (_classPrivateFieldGet8 = _classPrivateFieldGet(_mobileImage, _this)) === null || _classPrivateFieldGet8 === void 0 ? void 0 : _classPrivateFieldGet8.getAttribute('width'),
        mobile: true
      });
      if (!newMobileSrcset && !newMobileSource && !newSource && !newSrcset) {
        return;
      }
      switch (_classPrivateFieldGet(_state, _this).loadingState) {
        case LOADING_STATE.NOT_LOADED:
          {
            // 尚未加载，更新 data-* 属性
            if (newMobileSrcset) {
              _classPrivateFieldGet(_mobileImage, _this).dataset.srcset = newMobileSrcset;
            }
            if (newMobileSource) {
              _classPrivateFieldGet(_mobileImage, _this).dataset.src = newMobileSource;
            }
            if (newSrcset) {
              _classPrivateFieldGet(_image, _this).dataset.srcset = newSrcset;
            }
            if (newSource) {
              _classPrivateFieldGet(_image, _this).dataset.src = newSource;
            }
            break;
          }
        case LOADING_STATE.LOADING:
        case LOADING_STATE.LOADED:
          {
            var _classPrivateFieldGet9;
            // 重置状态，准备重新加载
            _classPrivateFieldGet(_state, _this).loadingState = LOADING_STATE.LOADING;
            (_classPrivateFieldGet9 = _classPrivateFieldGet(_mask, _this)) === null || _classPrivateFieldGet9 === void 0 || _classPrivateFieldGet9.classList.remove('mec-lazy-picture__mask--hidden');

            // 已加载或正在加载：直接替换并重新监听
            _classPrivateFieldGet(_image, _this).removeEventListener('load', _classPrivateFieldGet(_handleLoad, _this));
            _classPrivateFieldGet(_image, _this).removeEventListener('error', _classPrivateFieldGet(_handleLoad, _this));

            // 性能优化：使用 RAF 批量更新
            batchDOMUpdate(function () {
              // 优化：移除 isMobile 判断，同时设置所有图片源
              if (newMobileSrcset) {
                var _classPrivateFieldGet0;
                (_classPrivateFieldGet0 = _classPrivateFieldGet(_mobileImage, _this)) === null || _classPrivateFieldGet0 === void 0 || _classPrivateFieldGet0.setAttribute('srcset', newMobileSrcset);
              }
              if (newMobileSource) {
                var _classPrivateFieldGet1;
                (_classPrivateFieldGet1 = _classPrivateFieldGet(_mobileImage, _this)) === null || _classPrivateFieldGet1 === void 0 || _classPrivateFieldGet1.setAttribute('src', newMobileSource);
              }
              if (newSrcset) {
                _classPrivateFieldGet(_image, _this).setAttribute('srcset', newSrcset);
              }
              if (newSource) {
                _classPrivateFieldGet(_image, _this).setAttribute('src', newSource);
              }

              // 重新监听
              _classPrivateFieldGet(_image, _this).addEventListener('load', _classPrivateFieldGet(_handleLoad, _this), {
                once: true
              });
              _classPrivateFieldGet(_image, _this).addEventListener('error', _classPrivateFieldGet(_handleLoad, _this), {
                once: true
              });
              if (_classPrivateFieldGet(_image, _this).complete) {
                _classPrivateFieldGet(_handleLoad, _this).call(_this, {
                  type: 'success'
                });
              }
            });
            break;
          }
      }
    }, 80));
    return _this;
  }
  _inherits(LazyPicture, _HTMLElement);
  return _createClass(LazyPicture, [{
    key: "attributeChangedCallback",
    value:
    /**
     * 属性变化回调（原生生命周期）
     * @param {string} name - 属性名
     * @param {string} oldValue - 旧值
     * @param {string} newValue - 新值
     */
    function attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue !== newValue) {
        _classPrivateFieldGet(_handleAttributeChange, this).call(this);
      }
    }

    /**
     * 组件挂载回调（原生生命周期）
     * @description 替代 BaseCustomElements 的 componentDidMount
     */
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      if (_classPrivateFieldGet(_mounted, this)) return; // 防止重复初始化
      _classPrivateFieldSet(_mounted, this, true);
      _assertClassBrand(_LazyPicture_brand, this, _setup).call(this);
    }

    /**
     * 组件卸载回调（原生生命周期）
     * @description 替代 BaseCustomElements 的 componentWillUnmount
     */
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _classPrivateFieldGet10, _classPrivateFieldGet11;
      _classPrivateFieldSet(_mounted, this, false);

      // 清理共享 Observer
      if (sharedLazyObserver) {
        sharedLazyObserver.unobserve(this);
        observerTargets.delete(this);
      }

      // 清理事件监听器
      (_classPrivateFieldGet10 = _classPrivateFieldGet(_image, this)) === null || _classPrivateFieldGet10 === void 0 || _classPrivateFieldGet10.removeEventListener('load', _classPrivateFieldGet(_handleLoad, this));
      (_classPrivateFieldGet11 = _classPrivateFieldGet(_image, this)) === null || _classPrivateFieldGet11 === void 0 || _classPrivateFieldGet11.removeEventListener('error', _classPrivateFieldGet(_handleLoad, this));
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
function _setup() {
  var _this2 = this;
  _classPrivateFieldGet(_state, this).errorImageSource = this.getAttribute('error-image') || ERROR_IMAGE_SOURCE;
  _classPrivateFieldGet(_state, this).mode = this.getAttribute('mode') || 'lazy';

  // 性能优化：一次性查询所有元素，减少 DOM 遍历
  _classPrivateFieldSet(_picture, this, this.querySelector('picture'));
  if (_classPrivateFieldGet(_picture, this)) {
    _classPrivateFieldSet(_image, this, _classPrivateFieldGet(_picture, this).querySelector('img'));
    _classPrivateFieldSet(_mobileImage, this, _classPrivateFieldGet(_picture, this).querySelector('source'));
  }
  _classPrivateFieldSet(_mask, this, this.querySelector('.mec-lazy-picture__mask'));

  // 性能优化：设置 decoding="async"，避免图片解码阻塞主线程
  if (_classPrivateFieldGet(_image, this)) {
    _classPrivateFieldGet(_image, this).setAttribute('decoding', 'async');
  }
  if (_classPrivateFieldGet(_mobileImage, this)) {
    _classPrivateFieldGet(_mobileImage, this).setAttribute('decoding', 'async');
  }
  switch (_classPrivateFieldGet(_state, this).mode) {
    case 'eager':
      {
        // 直接显示缺省图
        _classPrivateFieldGet(_handleLoad, this).call(this, {
          type: 'success'
        });
        _assertClassBrand(_LazyPicture_brand, this, _loadImage).call(this);
        break;
      }
    case 'idle':
      {
        (0,rIC/* rIC */.$)(function () {
          return _assertClassBrand(_LazyPicture_brand, _this2, _loadImage).call(_this2);
        });
        break;
      }
    default:
      {
        _assertClassBrand(_LazyPicture_brand, this, _initIntersectionObserver).call(this);
        break;
      }
  }
}
/**
 * 初始化懒加载监听
 * @description 使用共享的全局 IntersectionObserver
 * @side-effects 注册当前元素到全局 Observer
 */
function _initIntersectionObserver() {
  var _this3 = this;
  // 性能优化：批量注册 Observer，减少主线程阻塞
  scheduleObserve(this, function () {
    return _assertClassBrand(_LazyPicture_brand, _this3, _loadImage).call(_this3);
  });
}
/**
 * 加载真实图片
 * @description 将 data-src/data-srcset 移动到 src/srcset，触发浏览器加载
 * @side-effects
 *   - 修改 DOM 属性（src, srcset）
 *   - 添加事件监听器（load, error）
 *   - 删除 data-* 属性
 */
function _loadImage() {
  var _classPrivateFieldGet12,
    _classPrivateFieldGet13,
    _classPrivateFieldGet14,
    _classPrivateFieldGet15,
    _classPrivateFieldGet16,
    _classPrivateFieldGet17,
    _classPrivateFieldGet18,
    _classPrivateFieldGet19,
    _this4 = this;
  if (_classPrivateFieldGet(_state, this).loadingState === LOADING_STATE.LOADING) return;
  _classPrivateFieldGet(_state, this).loadingState = LOADING_STATE.LOADING;
  var mobileImageSrcset = ((_classPrivateFieldGet12 = _classPrivateFieldGet(_mobileImage, this)) === null || _classPrivateFieldGet12 === void 0 || (_classPrivateFieldGet12 = _classPrivateFieldGet12.dataset) === null || _classPrivateFieldGet12 === void 0 ? void 0 : _classPrivateFieldGet12.srcset) || ((_classPrivateFieldGet13 = _classPrivateFieldGet(_mobileImage, this)) === null || _classPrivateFieldGet13 === void 0 ? void 0 : _classPrivateFieldGet13.getAttribute('srcset'));
  var mobileImageSource = ((_classPrivateFieldGet14 = _classPrivateFieldGet(_mobileImage, this)) === null || _classPrivateFieldGet14 === void 0 || (_classPrivateFieldGet14 = _classPrivateFieldGet14.dataset) === null || _classPrivateFieldGet14 === void 0 ? void 0 : _classPrivateFieldGet14.src) || ((_classPrivateFieldGet15 = _classPrivateFieldGet(_mobileImage, this)) === null || _classPrivateFieldGet15 === void 0 ? void 0 : _classPrivateFieldGet15.getAttribute('src'));
  var srcset = ((_classPrivateFieldGet16 = _classPrivateFieldGet(_image, this)) === null || _classPrivateFieldGet16 === void 0 || (_classPrivateFieldGet16 = _classPrivateFieldGet16.dataset) === null || _classPrivateFieldGet16 === void 0 ? void 0 : _classPrivateFieldGet16.srcset) || ((_classPrivateFieldGet17 = _classPrivateFieldGet(_image, this)) === null || _classPrivateFieldGet17 === void 0 ? void 0 : _classPrivateFieldGet17.getAttribute('srcset'));
  var source = ((_classPrivateFieldGet18 = _classPrivateFieldGet(_image, this)) === null || _classPrivateFieldGet18 === void 0 || (_classPrivateFieldGet18 = _classPrivateFieldGet18.dataset) === null || _classPrivateFieldGet18 === void 0 ? void 0 : _classPrivateFieldGet18.src) || ((_classPrivateFieldGet19 = _classPrivateFieldGet(_image, this)) === null || _classPrivateFieldGet19 === void 0 ? void 0 : _classPrivateFieldGet19.getAttribute('src'));

  // 性能优化：使用 RAF 批量更新 DOM，减少 layout thrashing
  batchDOMUpdate(function () {
    var _classPrivateFieldGet22, _classPrivateFieldGet23, _classPrivateFieldGet24, _classPrivateFieldGet25;
    // 优化：移除 isMobile 判断，浏览器根据 <source media> 自动选择
    // 同时设置 mobile 和 PC 图片源，浏览器会自动选择合适的
    if (mobileImageSrcset) {
      var _classPrivateFieldGet20;
      (_classPrivateFieldGet20 = _classPrivateFieldGet(_mobileImage, _this4)) === null || _classPrivateFieldGet20 === void 0 || _classPrivateFieldGet20.setAttribute('srcset', mobileImageSrcset);
    }
    if (mobileImageSource) {
      var _classPrivateFieldGet21;
      (_classPrivateFieldGet21 = _classPrivateFieldGet(_mobileImage, _this4)) === null || _classPrivateFieldGet21 === void 0 || _classPrivateFieldGet21.setAttribute('src', mobileImageSource);
    }
    if (srcset) {
      _classPrivateFieldGet(_image, _this4).setAttribute('srcset', srcset);
    }
    if (source) {
      _classPrivateFieldGet(_image, _this4).setAttribute('src', source);
    }

    // 优化：使用 removeAttribute 代替 delete dataset，更高效
    (_classPrivateFieldGet22 = _classPrivateFieldGet(_mobileImage, _this4)) === null || _classPrivateFieldGet22 === void 0 || _classPrivateFieldGet22.removeAttribute('data-srcset');
    (_classPrivateFieldGet23 = _classPrivateFieldGet(_mobileImage, _this4)) === null || _classPrivateFieldGet23 === void 0 || _classPrivateFieldGet23.removeAttribute('data-src');
    (_classPrivateFieldGet24 = _classPrivateFieldGet(_image, _this4)) === null || _classPrivateFieldGet24 === void 0 || _classPrivateFieldGet24.removeAttribute('data-srcset');
    (_classPrivateFieldGet25 = _classPrivateFieldGet(_image, _this4)) === null || _classPrivateFieldGet25 === void 0 || _classPrivateFieldGet25.removeAttribute('data-src');

    // 监听真实图片的加载状态
    _classPrivateFieldGet(_image, _this4).addEventListener('load', _classPrivateFieldGet(_handleLoad, _this4), {
      once: true
    });
    _classPrivateFieldGet(_image, _this4).addEventListener('error', _classPrivateFieldGet(_handleLoad, _this4), {
      once: true
    });
  });
}
_defineProperty(LazyPicture, "observedAttributes", ['src', 'alt', 'mobile-src', 'mobile-alt']);
/* harmony default export */ var core = (LazyPicture);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(81597);
;// CONCATENATED MODULE: ./snippets/lazy-picture/src/create.js




var createLazyPicture = function createLazyPicture(properties) {
  var _mobileImage$source, _image$source, _image$alt;
  var _properties$mode = properties.mode,
    mode = _properties$mode === void 0 ? 'lazy' : _properties$mode,
    _properties$emptyImag = properties.emptyImageVisible,
    emptyImageVisible = _properties$emptyImag === void 0 ? true : _properties$emptyImag,
    mobileImage = properties.mobileImage,
    image = properties.image,
    _properties$fetchprio = properties.fetchpriority,
    fetchpriority = _properties$fetchprio === void 0 ? 'auto' : _properties$fetchprio,
    _properties$loading = properties.loading,
    loading = _properties$loading === void 0 ? 'eager' : _properties$loading,
    _properties$mobileSiz = properties.mobileSizes,
    mobileSizes = _properties$mobileSiz === void 0 ? '100vw' : _properties$mobileSiz,
    _properties$sizes = properties.sizes,
    sizes = _properties$sizes === void 0 ? '100vw' : _properties$sizes,
    title = properties.title,
    _properties$aspectRat = properties.aspectRatio,
    aspectRatio = _properties$aspectRat === void 0 ? false : _properties$aspectRat,
    _properties$errorImag = properties.errorImage,
    errorImage = _properties$errorImag === void 0 ? '' : _properties$errorImag;
  var mobileImageAttribute = filterObject({
    decoding: 'async',
    fetchpriority: fetchpriority,
    loading: loading,
    sizes: mobileSizes,
    alt: mobileImage === null || mobileImage === void 0 || (_mobileImage$source = mobileImage.source) === null || _mobileImage$source === void 0 || (_mobileImage$source = _mobileImage$source.match(/([^/\\]+)(?=\.\w+$)/)) === null || _mobileImage$source === void 0 ? void 0 : _mobileImage$source[1],
    width: mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.width,
    height: mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.height,
    'data-original-alt': mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.alt,
    title: title
  });
  var imageAttribute = filterObject({
    decoding: 'async',
    fetchpriority: fetchpriority,
    loading: loading,
    sizes: sizes,
    alt: image === null || image === void 0 || (_image$source = image.source) === null || _image$source === void 0 || (_image$source = _image$source.match(/([^/\\]+)(?=\.\w+$)/)) === null || _image$source === void 0 ? void 0 : _image$source[1],
    width: image === null || image === void 0 ? void 0 : image.width,
    height: image === null || image === void 0 ? void 0 : image.height,
    'data-original-alt': image === null || image === void 0 ? void 0 : image.alt,
    title: title
  });
  var emptyAttribute = filterObject({
    width: image === null || image === void 0 ? void 0 : image.width,
    height: image === null || image === void 0 ? void 0 : image.height,
    title: title,
    src: 'https://shop.luvmehair.com/cdn/shop/files/LUVME_FOR_YOU.svg',
    alt: (image === null || image === void 0 || (_image$alt = image.alt) === null || _image$alt === void 0 || (_image$alt = _image$alt.match(/([^/\\]+)(?=\.\w+$)/)) === null || _image$alt === void 0 ? void 0 : _image$alt[1]) || 'Luvme for you'
  });
  var source = image === null || image === void 0 ? void 0 : image.source;
  var mobileSource = mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.source;
  var srcset = getSrcset({
    url: source,
    width: image === null || image === void 0 ? void 0 : image.width,
    mobile: false
  });
  var mobileSrcset = getSrcset({
    url: mobileSource,
    width: mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.width,
    mobile: true
  });
  var aspectRatioStyle = aspectRatio ? "\n      ".concat(image !== null && image !== void 0 && image.width && image !== null && image !== void 0 && image.height ? "--pc-aspect-ratio: ".concat(image.width, "/").concat(image.height, ";") : '', "\n      ").concat(mobileImage !== null && mobileImage !== void 0 && mobileImage.width && mobileImage !== null && mobileImage !== void 0 && mobileImage.height ? "--mobile-aspect-ratio: ".concat(mobileImage.width, "/").concat(mobileImage.height, ";") : '', "\n    ") : '';
  return /* html */"\n    <lazy-picture \n      class=\"lazy-picture\"\n      mode=\"".concat(mode, "\"\n      style=\"").concat(aspectRatioStyle, "\"\n      error-image=\"").concat(errorImage, "\"\n    >\n      <picture>\n        ").concat(mobileImage ? /* html */"\n              <source\n                media=\"(max-width: 768px)\"\n                ".concat(mode === 'eager' ? "\n                      srcset=\"".concat(mobileSrcset, "\"\n                    ") : "\n                      data-srcset=\"".concat(mobileSrcset, "\"\n                      data-src=\"").concat(mobileSource, "\"\n                    "), "\n                ").concat(mobileImageAttribute, "\n              >\n            ") : '', "\n        <img\n          ").concat(mode === 'eager' ? "\n                srcset=\"".concat(srcset, "\"\n                src=\"").concat(source, "\"\n              ") : "\n                data-srcset=\"".concat(srcset, "\"\n                data-src=\"").concat(source, "\"\n              "), "\n          ").concat(imageAttribute, "\n        >\n      </picture>\n      <div\n        class=\"mec-lazy-picture__mask ").concat(mode === 'eager' ? 'mec-lazy-picture__mask--hidden' : '', "\"\n      >\n        ").concat(emptyImageVisible ? /* html */"\n              <img\n                ".concat(emptyAttribute, "\n              >\n            ") : '', "\n      </div>\n    </lazy-picture>\n  ");
};

;// CONCATENATED MODULE: ./snippets/lazy-picture/index.js


var init = function init() {
  if (customElements.get('lazy-picture')) {
    return;
  }
  customElements.define('lazy-picture', core);
};
init();


/***/ }),

/***/ 60436:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(56187);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(38690);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(89228);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(26031);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(84159);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__(35659);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__(84050);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91270);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(66066);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(13227);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(96626);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(88646);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(95822);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(48949);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(11908);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(39574);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(3127);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(43908);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(81414);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(36763);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(59139);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(54134);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(33370);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(14011);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.weak-map.js
var es_weak_map = __webpack_require__(84750);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.weak-set.js
var es_weak_set = __webpack_require__(77991);
// EXTERNAL MODULE: ../node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(11431);
// EXTERNAL MODULE: ./utils/lodash.js
var lodash = __webpack_require__(31955);
// EXTERNAL MODULE: ../node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(97329);
// EXTERNAL MODULE: ./snippets/_/utils/base-custom-elements.js
var base_custom_elements = __webpack_require__(18335);
// EXTERNAL MODULE: ./ui/image-preview/index.js + 4 modules
var image_preview = __webpack_require__(34720);
// EXTERNAL MODULE: ./utils/event-emitter.js
var event_emitter = __webpack_require__(81228);
// EXTERNAL MODULE: ./utils/event-handler.js
var event_handler = __webpack_require__(25675);
// EXTERNAL MODULE: ./utils/misc.js
var misc = __webpack_require__(36792);
// EXTERNAL MODULE: ./utils/rIC.js
var rIC = __webpack_require__(24681);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(2663);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(89034);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__(19131);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(37666);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__(33373);
// EXTERNAL MODULE: ./utils/impression-tracking.js
var impression_tracking = __webpack_require__(85097);
;// CONCATENATED MODULE: ./snippets/original-main-product/gallery/src/tracking-point.js
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }


























/**
 * 设置图片预览的曝光追踪
 * @param {Object} modal - showImagePreview 返回的 modal 对象
 * @param {Array<string>} images - 图片 URL 数组
 * @param {Object} componentInstance - 组件实例，用于获取 productId 和 productTitle
 */
var setupImagePreviewTracking = function setupImagePreviewTracking(modal, images, componentInstance) {
  var _componentInstance$st, _componentInstance$st2, _componentInstance$st3, _componentInstance$st4;
  if (!modal) {
    return;
  }
  var modalNode = modal === null || modal === void 0 ? void 0 : modal.node;
  if (!modalNode) {
    return;
  }

  // 判断是 PC 端还是移动端
  var logoElement = modalNode.querySelector('.image-preview__logo');
  var carouselElement = modalNode.querySelector('mec-carousel');

  // 记录已曝光的图片 URL，用于去重
  var trackedImageUrls = new Set();

  // 获取 productId 和 productTitle
  var productId = (_componentInstance$st = componentInstance === null || componentInstance === void 0 || (_componentInstance$st2 = componentInstance.state) === null || _componentInstance$st2 === void 0 ? void 0 : _componentInstance$st2.productID) !== null && _componentInstance$st !== void 0 ? _componentInstance$st : '';
  var productTitle = (_componentInstance$st3 = componentInstance === null || componentInstance === void 0 || (_componentInstance$st4 = componentInstance.state) === null || _componentInstance$st4 === void 0 ? void 0 : _componentInstance$st4.productTitle) !== null && _componentInstance$st3 !== void 0 ? _componentInstance$st3 : '';

  // 发送曝光埋点的函数
  var sendImpressionTracking = function sendImpressionTracking(index, imageUrl) {
    var _window$dataLayer, _window$dataLayer$pus, _window$dataLayer2, _window$dataLayer2$pu;
    // 如果图片 URL 已曝光过，跳过
    if (!imageUrl || trackedImageUrls.has(imageUrl)) {
      return;
    }
    var eventLabel = imageUrl ? "".concat(index, "_").concat(imageUrl) : index;
    (_window$dataLayer = window.dataLayer) === null || _window$dataLayer === void 0 || (_window$dataLayer$pus = _window$dataLayer.push) === null || _window$dataLayer$pus === void 0 || _window$dataLayer$pus.call(_window$dataLayer, {
      ecommerce: undefined
    });
    (_window$dataLayer2 = window.dataLayer) === null || _window$dataLayer2 === void 0 || (_window$dataLayer2$pu = _window$dataLayer2.push) === null || _window$dataLayer2$pu === void 0 || _window$dataLayer2$pu.call(_window$dataLayer2, {
      event: 'uaEvent',
      event_type: 'detail_picture_view',
      position: String(index),
      event_label: eventLabel,
      product_id: productId,
      product_title: productTitle
    });
    trackedImageUrls.add(imageUrl);
  };

  // PC 端处理
  if (logoElement) {
    // 获取当前图片 URL 的辅助函数
    var getCurrentImageUrl = function getCurrentImageUrl() {
      var imgElement = logoElement.querySelector('.mec-figure');
      if (imgElement) {
        return imgElement.src || imgElement.srcset || '';
      }
      return '';
    };

    // 发送曝光埋点的函数（PC 端）
    var sendPCImpressionTracking = function sendPCImpressionTracking() {
      var _activeItem$dataset$i, _activeItem$dataset;
      var imageUrl = getCurrentImageUrl();
      // 获取当前图片索引
      var activeItem = modalNode.querySelector('.image-preview__slide__item--active');
      var index = (_activeItem$dataset$i = activeItem === null || activeItem === void 0 || (_activeItem$dataset = activeItem.dataset) === null || _activeItem$dataset === void 0 ? void 0 : _activeItem$dataset.index) !== null && _activeItem$dataset$i !== void 0 ? _activeItem$dataset$i : '';
      sendImpressionTracking(index, imageUrl);
    };

    // 使用 MutationObserver 监听 img 的 src 属性变化
    var mutationObserver = new MutationObserver(function (mutations) {
      var _iterator = _createForOfIteratorHelper(mutations),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutation = _step.value;
          if (mutation.type === 'attributes' && (mutation.attributeName === 'src' || mutation.attributeName === 'srcset')) {
            // 当图片 src 改变时，发送曝光埋点
            sendPCImpressionTracking();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });

    // 观察 logo 内的 img 元素的 src 属性变化
    var imgElement = logoElement.querySelector('.mec-figure');
    if (imgElement) {
      mutationObserver.observe(imgElement, {
        attributes: true,
        attributeFilter: ['src', 'srcset']
      });
    }

    // 初始触发：发送当前图片的曝光埋点
    sendPCImpressionTracking();

    // 箭头点击埋点追踪（仅 PC 端）
    var handleArrowClick = function handleArrowClick(isLeft) {
      var direction = isLeft ? 'Left' : 'Right';

      // 等待图片切换完成
      setTimeout(function () {
        var _activeItem$dataset$i2, _images$Number, _window$dataLayer3, _window$dataLayer3$pu, _window$dataLayer4, _window$dataLayer4$pu;
        // 获取当前 active 的 slide item
        var activeItem = modalNode.querySelector('.image-preview__slide__item--active');
        if (!activeItem) {
          return;
        }
        var index = (_activeItem$dataset$i2 = activeItem.dataset.index) !== null && _activeItem$dataset$i2 !== void 0 ? _activeItem$dataset$i2 : '';
        var imageUrl = (_images$Number = images === null || images === void 0 ? void 0 : images[Number(index)]) !== null && _images$Number !== void 0 ? _images$Number : '';
        var eventLabel = imageUrl ? "detail_".concat(direction, "_").concat(imageUrl) : "detail_".concat(direction, "_");
        (_window$dataLayer3 = window.dataLayer) === null || _window$dataLayer3 === void 0 || (_window$dataLayer3$pu = _window$dataLayer3.push) === null || _window$dataLayer3$pu === void 0 || _window$dataLayer3$pu.call(_window$dataLayer3, {
          ecommerce: undefined
        });
        (_window$dataLayer4 = window.dataLayer) === null || _window$dataLayer4 === void 0 || (_window$dataLayer4$pu = _window$dataLayer4.push) === null || _window$dataLayer4$pu === void 0 || _window$dataLayer4$pu.call(_window$dataLayer4, {
          event: 'uaEvent',
          event_type: 'window_map_arrow',
          position: index,
          event_label: eventLabel,
          product_id: productId,
          product_title: productTitle
        });
      }, 400);
    };

    // 监听左右箭头点击事件
    var leftArrow = modalNode.querySelector('.image-preview__arrow--left');
    var rightArrow = modalNode.querySelector('.image-preview__arrow--right');
    var leftArrowHandler = function leftArrowHandler() {
      handleArrowClick(true);
    };
    var rightArrowHandler = function rightArrowHandler() {
      handleArrowClick(false);
    };
    if (leftArrow) {
      leftArrow.addEventListener('click', leftArrowHandler);
    }
    if (rightArrow) {
      rightArrow.addEventListener('click', rightArrowHandler);
    }

    // 当 modal 关闭时，断开 MutationObserver
    var originalClose = modal.close;
    modal.close = function () {
      mutationObserver.disconnect();
      // 移除箭头点击事件监听器
      if (leftArrow) {
        leftArrow.removeEventListener('click', leftArrowHandler);
      }
      if (rightArrow) {
        rightArrow.removeEventListener('click', rightArrowHandler);
      }
      for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
        arguments_[_key] = arguments[_key];
      }
      return originalClose.apply(this, arguments_);
    };
  }

  // 移动端处理
  if (carouselElement) {
    var _carouselElement$getA;
    // 记录上一次的 active-index，用于判断滑动方向
    var previousActiveIndex = Number((_carouselElement$getA = carouselElement.getAttribute('active-index')) !== null && _carouselElement$getA !== void 0 ? _carouselElement$getA : 0);

    // 发送曝光埋点的函数（移动端）
    var sendMobileImpressionTracking = function sendMobileImpressionTracking() {
      var _carouselElement$getA2, _images$activeIndex;
      var activeIndex = Number((_carouselElement$getA2 = carouselElement.getAttribute('active-index')) !== null && _carouselElement$getA2 !== void 0 ? _carouselElement$getA2 : 0);
      var imageUrl = (_images$activeIndex = images === null || images === void 0 ? void 0 : images[activeIndex]) !== null && _images$activeIndex !== void 0 ? _images$activeIndex : '';
      sendImpressionTracking(activeIndex, imageUrl);
    };

    // 使用 MutationObserver 监听 mec-carousel 的 active-index 属性变化
    var carouselMutationObserver = new MutationObserver(function (mutations) {
      var _iterator2 = _createForOfIteratorHelper(mutations),
        _step2;
      try {
        var _loop = function _loop() {
          var mutation = _step2.value;
          if (mutation.type === 'attributes' && mutation.attributeName === 'active-index') {
            var _carouselElement$getA3;
            var currentActiveIndex = Number((_carouselElement$getA3 = carouselElement.getAttribute('active-index')) !== null && _carouselElement$getA3 !== void 0 ? _carouselElement$getA3 : 0);

            // 当 active-index 改变时，发送曝光埋点
            sendMobileImpressionTracking();

            // 判断滑动方向并上报 window_map_arrow 事件
            if (currentActiveIndex !== previousActiveIndex) {
              var isLeft = currentActiveIndex < previousActiveIndex;
              var direction = isLeft ? 'Left' : 'Right';

              // 等待图片切换完成
              setTimeout(function () {
                var _images$currentActive, _window$dataLayer5, _window$dataLayer5$pu, _window$dataLayer6, _window$dataLayer6$pu;
                var index = String(currentActiveIndex);
                var imageUrl = (_images$currentActive = images === null || images === void 0 ? void 0 : images[currentActiveIndex]) !== null && _images$currentActive !== void 0 ? _images$currentActive : '';
                var eventLabel = imageUrl ? "detail_".concat(direction, "_").concat(imageUrl) : "detail_".concat(direction, "_");
                (_window$dataLayer5 = window.dataLayer) === null || _window$dataLayer5 === void 0 || (_window$dataLayer5$pu = _window$dataLayer5.push) === null || _window$dataLayer5$pu === void 0 || _window$dataLayer5$pu.call(_window$dataLayer5, {
                  ecommerce: undefined
                });
                (_window$dataLayer6 = window.dataLayer) === null || _window$dataLayer6 === void 0 || (_window$dataLayer6$pu = _window$dataLayer6.push) === null || _window$dataLayer6$pu === void 0 || _window$dataLayer6$pu.call(_window$dataLayer6, {
                  event: 'uaEvent',
                  event_type: 'window_map_arrow',
                  position: index,
                  event_label: eventLabel,
                  product_id: productId,
                  product_title: productTitle
                });
              }, 400);

              // 更新 previousActiveIndex
              previousActiveIndex = currentActiveIndex;
            }
          }
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    });

    // 观察 mec-carousel 的 active-index 属性变化
    carouselMutationObserver.observe(carouselElement, {
      attributes: true,
      attributeFilter: ['active-index']
    });

    // 初始触发：发送当前图片的曝光埋点
    sendMobileImpressionTracking();

    // 当 modal 关闭时，断开 MutationObserver
    var _originalClose = modal.close;
    modal.close = function () {
      carouselMutationObserver.disconnect();
      for (var _len2 = arguments.length, arguments_ = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        arguments_[_key2] = arguments[_key2];
      }
      return _originalClose.apply(this, arguments_);
    };
  }
};
var trackingPoint = function trackingPoint(componentInstance) {
  var _componentInstance$st5, _componentInstance$st6;
  var productId = (_componentInstance$st5 = componentInstance.state.productID) !== null && _componentInstance$st5 !== void 0 ? _componentInstance$st5 : '';
  var productTitle = (_componentInstance$st6 = componentInstance.state.productTitle) !== null && _componentInstance$st6 !== void 0 ? _componentInstance$st6 : '';
  // 标志位：标记是否是点击缩略图导致的切换
  var isThumbnailClick = false;
  var thumbnailClickTimeout = null;
  // 小图
  (0,impression_tracking/* default */.Z)('.product-gallery__thumbnail__item', /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(targetList) {
      var _window$dataLayer7, _window$dataLayer7$pu, _window$dataLayer8, _window$dataLayer8$pu;
      var indexes, eventLabel;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!(!targetList || targetList.length === 0)) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            indexes = targetList.map(function (element) {
              var _element$dataset;
              var index = element === null || element === void 0 || (_element$dataset = element.dataset) === null || _element$dataset === void 0 ? void 0 : _element$dataset.index;
              return index !== undefined && index !== '' ? Number(index) : undefined;
            }).filter(function (index) {
              return index !== undefined;
            }).sort(function (a, b) {
              return a - b;
            });
            eventLabel = indexes.length > 0 ? "".concat(indexes.join('_')) : '';
            (_window$dataLayer7 = window.dataLayer) === null || _window$dataLayer7 === void 0 || (_window$dataLayer7$pu = _window$dataLayer7.push) === null || _window$dataLayer7$pu === void 0 || _window$dataLayer7$pu.call(_window$dataLayer7, {
              ecommerce: undefined
            });
            (_window$dataLayer8 = window.dataLayer) === null || _window$dataLayer8 === void 0 || (_window$dataLayer8$pu = _window$dataLayer8.push) === null || _window$dataLayer8$pu === void 0 || _window$dataLayer8$pu.call(_window$dataLayer8, {
              event: 'uaEvent',
              event_type: 'small_picture_view',
              event_label: eventLabel,
              product_id: productId,
              product_title: productTitle
            });
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), false, true);
  (0,event_handler.on)('click', '.product-gallery__thumbnail__item', function (event) {
    var _window$dataLayer9, _window$dataLayer9$pu, _window$dataLayer0, _window$dataLayer0$pu;
    var position = event.currentTarget.dataset.index;
    var imageUrl = event.currentTarget.querySelector('picture img').src;
    var eventLabel = imageUrl ? "".concat(position, "_").concat(imageUrl) : position;
    (_window$dataLayer9 = window.dataLayer) === null || _window$dataLayer9 === void 0 || (_window$dataLayer9$pu = _window$dataLayer9.push) === null || _window$dataLayer9$pu === void 0 || _window$dataLayer9$pu.call(_window$dataLayer9, {
      ecommerce: null
    });
    (_window$dataLayer0 = window.dataLayer) === null || _window$dataLayer0 === void 0 || (_window$dataLayer0$pu = _window$dataLayer0.push) === null || _window$dataLayer0$pu === void 0 || _window$dataLayer0$pu.call(_window$dataLayer0, {
      event: 'uaEvent',
      event_type: 'small_picture_click',
      position: position,
      event_label: eventLabel,
      product_id: productId,
      product_title: productTitle
    });

    // 设置标志位，标记是点击缩略图导致的切换
    isThumbnailClick = true;
    // 清除之前的延迟清除
    if (thumbnailClickTimeout) {
      clearTimeout(thumbnailClickTimeout);
      thumbnailClickTimeout = null;
    }
    // 延迟清除标志位，确保 MutationObserver 有时间触发
    thumbnailClickTimeout = setTimeout(function () {
      isThumbnailClick = false;
      thumbnailClickTimeout = null;
    }, 500);
  }, {}, componentInstance);
  // 大图
  (0,impression_tracking/* default */.Z)('.product-gallery__item', function (element) {
    var _element$dataset$inde, _element$dataset2, _clickedImage$src, _window$dataLayer1, _window$dataLayer1$pu, _window$dataLayer10, _window$dataLayer10$p;
    if (!element) {
      return;
    }
    var index = (_element$dataset$inde = element === null || element === void 0 || (_element$dataset2 = element.dataset) === null || _element$dataset2 === void 0 ? void 0 : _element$dataset2.index) !== null && _element$dataset$inde !== void 0 ? _element$dataset$inde : '';
    var clickedImage = element.querySelector('picture img') || element.querySelector('img');
    var imageUrl = (_clickedImage$src = clickedImage === null || clickedImage === void 0 ? void 0 : clickedImage.src) !== null && _clickedImage$src !== void 0 ? _clickedImage$src : '';
    var eventLabel = imageUrl ? "".concat(index, "_").concat(imageUrl) : index;
    (_window$dataLayer1 = window.dataLayer) === null || _window$dataLayer1 === void 0 || (_window$dataLayer1$pu = _window$dataLayer1.push) === null || _window$dataLayer1$pu === void 0 || _window$dataLayer1$pu.call(_window$dataLayer1, {
      ecommerce: null
    });
    (_window$dataLayer10 = window.dataLayer) === null || _window$dataLayer10 === void 0 || (_window$dataLayer10$p = _window$dataLayer10.push) === null || _window$dataLayer10$p === void 0 || _window$dataLayer10$p.call(_window$dataLayer10, {
      event: 'uaEvent',
      event_type: 'big_picture_view',
      position: index,
      event_label: eventLabel,
      product_id: productId,
      product_title: productTitle
    });
  });
  (0,event_handler.on)('click', '.product-gallery__item', function (event) {
    var _window$dataLayer11, _window$dataLayer11$p, _window$dataLayer12, _window$dataLayer12$p;
    var index = event.currentTarget.dataset.index;
    var imageUrl = event.currentTarget.querySelector('picture img').src;
    var eventLabel = imageUrl ? "".concat(index, "_").concat(imageUrl) : index;
    (_window$dataLayer11 = window.dataLayer) === null || _window$dataLayer11 === void 0 || (_window$dataLayer11$p = _window$dataLayer11.push) === null || _window$dataLayer11$p === void 0 || _window$dataLayer11$p.call(_window$dataLayer11, {
      ecommerce: null
    });
    (_window$dataLayer12 = window.dataLayer) === null || _window$dataLayer12 === void 0 || (_window$dataLayer12$p = _window$dataLayer12.push) === null || _window$dataLayer12$p === void 0 || _window$dataLayer12$p.call(_window$dataLayer12, {
      event: 'uaEvent',
      event_type: 'big_picture_click',
      position: index,
      event_label: eventLabel,
      product_id: productId,
      product_title: productTitle
    });
  });
  (0,event_handler.on)('click', '.mec-scroller__arrow', function (event) {
    var isLeft = event.currentTarget.classList.contains('mec-scroller__arrow--left');
    var direction = isLeft ? 'Left' : 'Right';
    var carouselElement = componentInstance.querySelector('.product-gallery__carousel');
    var currentIndexNumber = 0;
    var nextIndex = 0;
    if (carouselElement) {
      var currentIndex = carouselElement.getAttribute('current-index');
      if (currentIndex !== null) {
        currentIndexNumber = Number(currentIndex);
      }
      var allItems = carouselElement.querySelectorAll('.product-gallery__item');
      if (allItems.length > 0) {
        nextIndex = isLeft ? Math.max(0, currentIndexNumber - 1) : Math.min(allItems.length - 1, currentIndexNumber + 1);
      }
    }
    setTimeout(function () {
      var _window$dataLayer13, _window$dataLayer13$p, _window$dataLayer14, _window$dataLayer14$p;
      var index = String(nextIndex);
      var imageUrl = '';
      if (carouselElement) {
        var targetItem = carouselElement.querySelectorAll('.product-gallery__item')[nextIndex];
        if (targetItem) {
          var _clickedImage$src2;
          var clickedImage = targetItem.querySelector('picture img') || targetItem.querySelector('img');
          imageUrl = (_clickedImage$src2 = clickedImage === null || clickedImage === void 0 ? void 0 : clickedImage.src) !== null && _clickedImage$src2 !== void 0 ? _clickedImage$src2 : '';
        }
      }
      var eventLabel = imageUrl ? "big_".concat(direction, "_").concat(imageUrl) : "big_".concat(direction, "_");
      (_window$dataLayer13 = window.dataLayer) === null || _window$dataLayer13 === void 0 || (_window$dataLayer13$p = _window$dataLayer13.push) === null || _window$dataLayer13$p === void 0 || _window$dataLayer13$p.call(_window$dataLayer13, {
        ecommerce: null
      });
      (_window$dataLayer14 = window.dataLayer) === null || _window$dataLayer14 === void 0 || (_window$dataLayer14$p = _window$dataLayer14.push) === null || _window$dataLayer14$p === void 0 || _window$dataLayer14$p.call(_window$dataLayer14, {
        event: 'uaEvent',
        event_type: 'window_map_arrow',
        position: index,
        event_label: eventLabel,
        product_id: productId,
        product_title: productTitle
      });
    }, 400);
  });

  // 移动端滑动监听
  if (misc/* isMobile */.tq) {
    var carouselElement = componentInstance.querySelector('.product-gallery__carousel');
    if (carouselElement) {
      var previousIndex = 0;
      var currentIndexAttribute = carouselElement.getAttribute('current-index');
      if (currentIndexAttribute !== null) {
        previousIndex = Number(currentIndexAttribute);
      }
      var mutationObserver = new MutationObserver(function (mutations) {
        var _iterator3 = _createForOfIteratorHelper(mutations),
          _step3;
        try {
          var _loop2 = function _loop2() {
              var mutation = _step3.value;
              if (mutation.type === 'attributes' && mutation.attributeName === 'current-index') {
                var newIndexAttribute = carouselElement.getAttribute('current-index');
                if (newIndexAttribute === null) {
                  return {
                    v: void 0
                  };
                }
                var newIndex = Number(newIndexAttribute);

                // 仅在索引实际变化时触发
                if (newIndex === previousIndex) {
                  return {
                    v: void 0
                  };
                }

                // 如果是点击缩略图导致的切换，不触发埋点
                if (isThumbnailClick) {
                  previousIndex = newIndex;
                  return {
                    v: void 0
                  };
                }

                // 判断滑动方向
                var isLeft = newIndex < previousIndex;
                var direction = isLeft ? 'Left' : 'Right';

                // 更新 previousIndex
                previousIndex = newIndex;
                setTimeout(function () {
                  var _window$dataLayer15, _window$dataLayer15$p, _window$dataLayer16, _window$dataLayer16$p;
                  var index = String(newIndex);
                  var imageUrl = '';
                  var allItems = carouselElement.querySelectorAll('.product-gallery__item');
                  if (allItems.length > 0 && allItems[newIndex]) {
                    var _clickedImage$src3;
                    var targetItem = allItems[newIndex];
                    var clickedImage = targetItem.querySelector('picture img') || targetItem.querySelector('img');
                    imageUrl = (_clickedImage$src3 = clickedImage === null || clickedImage === void 0 ? void 0 : clickedImage.src) !== null && _clickedImage$src3 !== void 0 ? _clickedImage$src3 : '';
                  }
                  var eventLabel = imageUrl ? "big_".concat(direction, "_").concat(imageUrl) : "big_".concat(direction, "_");
                  (_window$dataLayer15 = window.dataLayer) === null || _window$dataLayer15 === void 0 || (_window$dataLayer15$p = _window$dataLayer15.push) === null || _window$dataLayer15$p === void 0 || _window$dataLayer15$p.call(_window$dataLayer15, {
                    ecommerce: null
                  });
                  (_window$dataLayer16 = window.dataLayer) === null || _window$dataLayer16 === void 0 || (_window$dataLayer16$p = _window$dataLayer16.push) === null || _window$dataLayer16$p === void 0 || _window$dataLayer16$p.call(_window$dataLayer16, {
                    event: 'uaEvent',
                    event_type: 'window_map_arrow',
                    position: index,
                    event_label: eventLabel,
                    product_id: productId,
                    product_title: productTitle
                  });
                }, 400);
              }
            },
            _ret;
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            _ret = _loop2();
            if (_ret) return _ret.v;
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      });
      mutationObserver.observe(carouselElement, {
        attributes: true,
        attributeFilter: ['current-index']
      });
    }
  }
};
;// CONCATENATED MODULE: ./snippets/original-main-product/gallery/src/custom-elements.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function custom_elements_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = custom_elements_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function custom_elements_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return custom_elements_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? custom_elements_arrayLikeToArray(r, a) : void 0; } }
function custom_elements_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }



























function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }









var _productGalleryCarouselElement = /*#__PURE__*/new WeakMap();
var _productGalleryThumbnailCarouselElement = /*#__PURE__*/new WeakMap();
var _productGalleryMagnifierMaskElement = /*#__PURE__*/new WeakMap();
var _productGalleryListElement = /*#__PURE__*/new WeakMap();
var _productGalleryStageElement = /*#__PURE__*/new WeakMap();
var _productGalleryMagnifierOverlayElement = /*#__PURE__*/new WeakMap();
var _resizeObserver = /*#__PURE__*/new WeakMap();
var _ProductGallery_brand = /*#__PURE__*/new WeakSet();
var ProductGallery = /*#__PURE__*/function (_BaseCustomElements) {
  function ProductGallery() {
    var _this;
    _classCallCheck(this, ProductGallery);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ProductGallery, [].concat(args));
    _classPrivateMethodInitSpec(_this, _ProductGallery_brand);
    _classPrivateFieldInitSpec(_this, _productGalleryCarouselElement, void 0);
    _classPrivateFieldInitSpec(_this, _productGalleryThumbnailCarouselElement, void 0);
    _classPrivateFieldInitSpec(_this, _productGalleryMagnifierMaskElement, void 0);
    _classPrivateFieldInitSpec(_this, _productGalleryListElement, void 0);
    _classPrivateFieldInitSpec(_this, _productGalleryStageElement, void 0);
    _classPrivateFieldInitSpec(_this, _productGalleryMagnifierOverlayElement, void 0);
    _classPrivateFieldInitSpec(_this, _resizeObserver, void 0);
    return _this;
  }
  _inherits(ProductGallery, _BaseCustomElements);
  return _createClass(ProductGallery, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _assertClassBrand(_ProductGallery_brand, this, _setup).call(this);
      _assertClassBrand(_ProductGallery_brand, this, _bindEvents).call(this);
      trackingPoint(this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _classPrivateFieldGet2;
      (0,event_handler/* offByContainer */.g4)(this);
      (_classPrivateFieldGet2 = _classPrivateFieldGet(_resizeObserver, this)) === null || _classPrivateFieldGet2 === void 0 || _classPrivateFieldGet2.disconnect();
    }
  }]);
}(base_custom_elements/* default */.Z);
function _setup() {
  var _this2 = this;
  _classPrivateFieldSet(_productGalleryCarouselElement, this, this.querySelector('.product-gallery__carousel'));
  _classPrivateFieldSet(_productGalleryThumbnailCarouselElement, this, _classPrivateFieldGet(_productGalleryCarouselElement, this).querySelector('.product-gallery__thumbnail__carousel'));
  _classPrivateFieldSet(_productGalleryListElement, this, _classPrivateFieldGet(_productGalleryCarouselElement, this).querySelector('.product-gallery__list'));
  _classPrivateFieldSet(_productGalleryStageElement, this, _classPrivateFieldGet(_productGalleryCarouselElement, this).querySelector('.product-gallery__stage'));
  _classPrivateFieldSet(_productGalleryMagnifierMaskElement, this, _classPrivateFieldGet(_productGalleryCarouselElement, this).querySelector('.product-gallery__magnifier-mask'));
  _classPrivateFieldSet(_productGalleryMagnifierOverlayElement, this, _classPrivateFieldGet(_productGalleryCarouselElement, this).querySelector('.product-gallery__magnifier-overlay'));
  if (!misc/* isMobile */.tq) {
    _classPrivateFieldGet(_productGalleryThumbnailCarouselElement, this).setAttribute('direction', 'vertical');
  }
  var spuImages = [];
  var skuWithImage = [];
  try {
    spuImages = JSON.parse(this.querySelector('.product-gallery__config').textContent).spuImages;
    skuWithImage = JSON.parse(this.querySelector('.product-gallery__config').textContent).skuWithImage;
  } catch (_unused) {}
  this.setState(function (draft) {
    var _spuImages$map, _spuImages;
    draft.spuImages = spuImages;
    draft.skuWithImage = skuWithImage;
    draft.zoom = 3.33;
    draft.productID = _this2.closest('original-product-info').getAttribute('product-id');
    draft.productTitle = _this2.closest('original-product-info').getAttribute('product-title');
    draft.variantID = _this2.closest('original-product-info').getAttribute('variant-id');
    draft.imageList = (_spuImages$map = (_spuImages = spuImages) === null || _spuImages === void 0 ? void 0 : _spuImages.map(function (item) {
      return item.src;
    })) !== null && _spuImages$map !== void 0 ? _spuImages$map : [];
  });
  _assertClassBrand(_ProductGallery_brand, this, _resetMagnifierOverlayStyle).call(this);
  (0,rIC/* rIC */.$)(function () {
    _assertClassBrand(_ProductGallery_brand, _this2, _focusSkuImage).call(_this2);
  });
}
function _getDrawAreaElement() {
  return _classPrivateFieldGet(_productGalleryStageElement, this) || _classPrivateFieldGet(_productGalleryListElement, this);
}
function _resetMagnifierOverlayStyle() {
  var _this3 = this;
  var drawAreaElement = _assertClassBrand(_ProductGallery_brand, this, _getDrawAreaElement).call(this);
  if (!drawAreaElement || !_classPrivateFieldGet(_productGalleryMagnifierOverlayElement, this) || misc/* isMobile */.tq) {
    return;
  }

  /**
   * ResizeObserver 用于计算图片在 contain 模式下的实际显示尺寸（非 natural 尺寸）。
   * 容器取 stage（与图片外框同宽），勿用 list（含缩略图区域外的全宽）。
   */
  _classPrivateFieldSet(_resizeObserver, this, new ResizeObserver_es/* default */.Z((0,lodash/* debounce */.Ds)(function () {
    var zoom = _this3.state.zoom;
    var containerRect = drawAreaElement.getBoundingClientRect();
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var firstImageElement = drawAreaElement.querySelector('.product-gallery__item:first-child picture img');
    if (!firstImageElement) {
      return;
    }
    var naturalW = Number(firstImageElement.getAttribute('width'));
    var naturalH = Number(firstImageElement.getAttribute('height'));
    var containerRatio = containerWidth / containerHeight;
    var imageRatio = naturalW / naturalH;
    var drawWidth, drawHeight;
    if (imageRatio > containerRatio) {
      drawWidth = containerWidth;
      drawHeight = containerWidth * naturalH / naturalW;
    } else {
      drawHeight = containerHeight;
      drawWidth = containerHeight * naturalW / naturalH;
    }
    _this3.setState(function (draft) {
      draft.drawWidth = drawWidth;
      draft.drawHeight = drawHeight;
      draft.imageRatio = imageRatio;
      draft.containerRatio = containerRatio;
    });
    _classPrivateFieldGet(_productGalleryMagnifierOverlayElement, _this3).style.backgroundSize = "".concat(drawWidth * zoom, "px ").concat(drawHeight * zoom, "px");
  }, 100)));
  _classPrivateFieldGet(_resizeObserver, this).observe(drawAreaElement);
}
function _focusSkuImage() {
  var _skuWithImage$find,
    _classPrivateFieldGet3,
    _this4 = this;
  var _this$state = this.state,
    imageList = _this$state.imageList,
    variantID = _this$state.variantID,
    skuWithImage = _this$state.skuWithImage;
  var matchSource = (_skuWithImage$find = skuWithImage.find(function (item) {
    return item.sku === variantID;
  })) === null || _skuWithImage$find === void 0 ? void 0 : _skuWithImage$find.src;
  var index = imageList.findIndex(function (item) {
    return item.includes(matchSource);
  });
  if (!~index) {
    return;
  }
  if (this.closest('.quick-buy-modal-content') && misc/* isMobile */.tq) {
    return;
  }
  this.setState(function (draft) {
    draft.stopThumbnailTransition = true;
  });
  (_classPrivateFieldGet3 = _classPrivateFieldGet(_productGalleryThumbnailCarouselElement, this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.setIndex(index, {
    align: 'center',
    behavior: 'auto'
  });
  (0,rIC/* rIC */.$)(function () {
    _classPrivateFieldGet(_productGalleryCarouselElement, _this4).setIndex(index, {
      behavior: 'instant'
    });
  });
  setTimeout(function () {
    _this4.setState(function (draft) {
      draft.stopThumbnailTransition = false;
    });
  }, 1000);
}
function _handleThumbnailItemClick(event) {
  var _this5 = this;
  var currentTarget = event.currentTarget;
  if (currentTarget.closest('.quick-buy-modal-content') && misc/* isMobile */.tq) {
    var startPosition = Number(currentTarget.dataset.index);
    var images = this.state.spuImages.map(function (item) {
      return item.src;
    });
    (0,image_preview/* showImagePreview */.V)({
      images: images,
      startPosition: startPosition
    });
  } else {
    var _classPrivateFieldGet4;
    this.setState(function (draft) {
      draft.stopThumbnailTransition = true;
    });
    var index = Number(currentTarget.dataset.index);
    (_classPrivateFieldGet4 = _classPrivateFieldGet(_productGalleryThumbnailCarouselElement, this)) === null || _classPrivateFieldGet4 === void 0 || _classPrivateFieldGet4.setIndex(index, {
      align: 'center',
      behavior: 'auto'
    });
    (0,rIC/* rIC */.$)(function () {
      _classPrivateFieldGet(_productGalleryCarouselElement, _this5).setIndex(index, {
        behavior: 'instant'
      });
    });
    setTimeout(function () {
      _this5.setState(function (draft) {
        draft.stopThumbnailTransition = false;
      });
    }, 1000);
  }
}
function _bindEvents() {
  var _this6 = this;
  if (!misc/* isMobile */.tq && !this.closest('.quick-buy-modal-content')) {
    (0,event_handler.on)('mouseover', '.product-gallery__scroll-content', function () {
      _classPrivateFieldGet(_productGalleryMagnifierMaskElement, _this6).classList.add('product-gallery__magnifier-mask--visible');
      _classPrivateFieldGet(_productGalleryMagnifierOverlayElement, _this6).classList.add('product-gallery__magnifier-overlay--visible');
    }, {}, this);
    (0,event_handler.on)('mousemove', '.product-gallery__scroll-content', function (event) {
      var touches = event.touches,
        clientX = event.clientX,
        clientY = event.clientY;
      var mask = _classPrivateFieldGet(_productGalleryMagnifierMaskElement, _this6);
      var drawAreaElement = _assertClassBrand(_ProductGallery_brand, _this6, _getDrawAreaElement).call(_this6);
      if (!drawAreaElement) {
        return;
      }
      var stageRect = drawAreaElement.getBoundingClientRect();
      var _this6$state = _this6.state,
        zoom = _this6$state.zoom,
        drawWidth = _this6$state.drawWidth,
        drawHeight = _this6$state.drawHeight;
      var areaWidth = drawWidth || stageRect.width;
      var areaHeight = drawHeight || stageRect.height;

      // 获取触点坐标（移动端用 touches，桌面端用 clientX/Y）
      var x, y;
      if (touches && touches.length > 0) {
        x = touches[0].clientX;
        y = touches[0].clientY;
      } else {
        x = clientX;
        y = clientY;
      }

      // Mask尺寸
      var maskRect = mask.getBoundingClientRect();
      var maskWidth = maskRect.width;
      var maskHeight = maskRect.height;
      var offsetX = x - stageRect.left;
      var offsetY = y - stageRect.top;
      var left = offsetX - maskWidth / 2;
      var top = offsetY - maskHeight / 2;
      left = Math.max(0, Math.min(left, areaWidth - maskWidth));
      top = Math.max(0, Math.min(top, areaHeight - maskHeight));
      mask.style.left = "".concat(left, "px");
      mask.style.top = "".concat(top, "px");
      _classPrivateFieldGet(_productGalleryMagnifierOverlayElement, _this6).style.backgroundPosition = "".concat(-left * zoom, "px ").concat(-top * zoom, "px");
    }, {}, this);
    (0,event_handler.on)('mouseout', '.product-gallery__scroll-content', function (event) {
      _classPrivateFieldGet(_productGalleryMagnifierMaskElement, _this6).classList.remove('product-gallery__magnifier-mask--visible');
      _classPrivateFieldGet(_productGalleryMagnifierOverlayElement, _this6).classList.remove('product-gallery__magnifier-overlay--visible');
    }, {}, this);
  }
  event_emitter/* default */.Z.on("".concat(this.state.productID, "_VARIANT_ID_CHANGE"), function (id) {
    _this6.setState(function (draft) {
      draft.variantID = id;
    });
    _assertClassBrand(_ProductGallery_brand, _this6, _focusSkuImage).call(_this6);
  });
  (0,event_handler.on)('click', '.product-gallery__item', function (event) {
    var _this6$state$spuImage;
    if (((_this6$state$spuImage = _this6.state.spuImages) === null || _this6$state$spuImage === void 0 ? void 0 : _this6$state$spuImage.length) === 0) {
      return;
    }
    var currentTarget = event.currentTarget;
    var startPosition = Number(currentTarget.dataset.index);
    var images = _this6.state.spuImages.map(function (item) {
      return item.src;
    });
    var modal = (0,image_preview/* showImagePreview */.V)({
      images: images,
      startPosition: startPosition
    });
    setupImagePreviewTracking(modal, images, _this6);
  }, {}, this);
  (0,event_handler.on)('click', '.product-gallery__thumbnail__item', function (event) {
    return _assertClassBrand(_ProductGallery_brand, _this6, _handleThumbnailItemClick).call(_this6, event);
  }, {}, this);
  var subscribeKey = _classPrivateFieldGet(_productGalleryCarouselElement, this).getAttribute('subscribe-key');
  event_emitter/* default */.Z.on("".concat(subscribeKey, "-change"), (0,lodash/* debounce */.Ds)(function (index) {
    if (!_this6.state.stopThumbnailTransition) {
      var _classPrivateFieldGet5;
      (_classPrivateFieldGet5 = _classPrivateFieldGet(_productGalleryThumbnailCarouselElement, _this6)) === null || _classPrivateFieldGet5 === void 0 || _classPrivateFieldGet5.setIndex(Number(index), {
        align: 'center'
      });
    }
    var _iterator = custom_elements_createForOfIteratorHelper(_this6.querySelectorAll('.product-gallery__thumbnail__item')),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var element = _step.value;
        if (Number(index) === Number(element.dataset.index)) {
          element.classList.add('product-gallery__thumbnail__item--active');
        } else {
          element.classList.remove('product-gallery__thumbnail__item--active');
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    try {
      var carousel = _classPrivateFieldGet(_productGalleryCarouselElement, _this6);
      var matchItem = carousel.querySelectorAll('.product-gallery__item')[Number(index)].querySelector('picture img');
      if (matchItem) {
        _classPrivateFieldGet(_productGalleryMagnifierOverlayElement, _this6).style.backgroundImage = "url(".concat(matchItem.src, ")");
      }
    } catch (_unused2) {}
  }, 33));
}
/* harmony default export */ var custom_elements = (ProductGallery);
;// CONCATENATED MODULE: ./snippets/original-main-product/gallery/index.js

var init = function init() {
  if (customElements.get('product-gallery')) {
    return;
  }
  customElements.define('product-gallery', custom_elements);
};
init();

/***/ }),

/***/ 98120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  G: function() { return /* binding */ quickAddToCart; }
});

// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(56187);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(38690);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(89228);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(2663);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__(35659);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__(84050);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91270);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(66066);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(13227);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(88646);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(48949);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(11908);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(62659);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(39574);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(3127);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(43908);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(81414);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(37666);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(59139);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(54134);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(33370);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(14011);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__(48349);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(86651);
// EXTERNAL MODULE: ../node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(47134);
// EXTERNAL MODULE: ../node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(11431);
// EXTERNAL MODULE: ./snippets/original-main-product/variants/index.js
var variants = __webpack_require__(29761);
// EXTERNAL MODULE: ./ui/modal/index.js + 5 modules
var ui_modal = __webpack_require__(49968);
// EXTERNAL MODULE: ./utils/event-emitter.js
var event_emitter = __webpack_require__(81228);
// EXTERNAL MODULE: ./utils/event-handler.js
var event_handler = __webpack_require__(25675);
;// CONCATENATED MODULE: ./snippets/original-main-product/quick-add-to-cart/event-tracking.js

/**
 * 快捷加购入口（商品卡）数据
 *
 * GA `eeEvent` 埋点取值：商品、变体、价格、列表信息都读入口卡片的 data 属性
 * （列表页商品卡 / 视频带货卡 / 试戴结果卡 / 旧版 product-block），
 * 与商详 `view_item`（`sections/main-product.liquid`）口径一致。
 *
 * @param {Element} target - 快捷加购按钮
 * @returns {object|undefined} 商品数据；命中排除范围（购物车行项目、试戴其它款按钮）时返回 undefined
 */
var getQuickAddToCartData = function getQuickAddToCartData(target) {
  if (!target || target !== null && target !== void 0 && target.closest('.cart_product-product-content') || target !== null && target !== void 0 && target.closest('.ai-try-on-result-card__btn--other')) {
    return undefined;
  }
  var price, productType, listId, listName, productId, productTitle, variantSku, variantTitle, variantId, index;
  if (target !== null && target !== void 0 && target.closest('.video-merchant')) {
    var _target$closest;
    var wrapper = target.closest('.video-merchant__item');
    var currentDataSet = ((_target$closest = target.closest('.video-merchant__item__info')) === null || _target$closest === void 0 ? void 0 : _target$closest.dataset) || {};
    price = currentDataSet.price;
    productType = currentDataSet.productType;
    productId = currentDataSet.productId;
    productTitle = currentDataSet.productTitle;
    variantSku = currentDataSet.variantSku;
    variantTitle = currentDataSet.variantTitle;
    listId = wrapper.dataset.listId;
    listName = wrapper.dataset.listName;
    variantId = currentDataSet.variantId;
    index = currentDataSet.index;
  } else if (target !== null && target !== void 0 && target.closest('.product-card-group__item')) {
    var _wrapper = target.closest('.product-card-group__item');
    var _currentDataSet = (_wrapper === null || _wrapper === void 0 ? void 0 : _wrapper.dataset) || {};
    price = _currentDataSet.price;
    listId = _currentDataSet.listId;
    listName = _currentDataSet.listName;
    productType = _currentDataSet.productType;
    productId = _currentDataSet.productId;
    productTitle = _currentDataSet.productTitle;
    variantSku = _currentDataSet.variantSku;
    variantTitle = _currentDataSet.variantTitle;
    variantId = _currentDataSet.variantId;
    index = _currentDataSet.index;
  } else if (target !== null && target !== void 0 && target.closest('.ai-try-on__result-product-card') || target !== null && target !== void 0 && target.closest('.ai-try-on__preview-product')) {
    // 试戴结果页工具栏 / 大图预览：字段对齐商品卡 product-card-group
    var _wrapper2 = target.closest('.ai-try-on__result-product-card') || target.closest('.ai-try-on__preview-product');
    var _currentDataSet2 = (_wrapper2 === null || _wrapper2 === void 0 ? void 0 : _wrapper2.dataset) || {};
    price = _currentDataSet2.price;
    listId = _currentDataSet2.listId;
    listName = _currentDataSet2.listName;
    productType = _currentDataSet2.productType;
    productId = _currentDataSet2.productId;
    productTitle = _currentDataSet2.productTitle;
    variantSku = _currentDataSet2.variantSku;
    variantTitle = _currentDataSet2.variantTitle;
    variantId = _currentDataSet2.variantId;
    index = _currentDataSet2.index;
  } else if (target !== null && target !== void 0 && target.closest('.ai-try-on-retention-sheet__product')) {
    var _wrapper3 = target.closest('.ai-try-on-retention-sheet__product');
    var _currentDataSet3 = (_wrapper3 === null || _wrapper3 === void 0 ? void 0 : _wrapper3.dataset) || {};
    price = _currentDataSet3.price;
    listId = _currentDataSet3.listId || 'none';
    listName = _currentDataSet3.listName || 'try_on_retention_popup';
    productType = _currentDataSet3.productType;
    productId = _currentDataSet3.productId;
    productTitle = _currentDataSet3.productTitle;
    variantSku = _currentDataSet3.variantSku;
    variantTitle = _currentDataSet3.variantTitle;
    variantId = _currentDataSet3.variantId;
    index = _currentDataSet3.index;
  } else {
    // 旧版 product-block（如 coupon-products、bogo 等）使用 .snippets-product-block，data-value 为分
    var _wrapper4 = (target === null || target === void 0 ? void 0 : target.closest('.snippets-product-block')) || (target === null || target === void 0 ? void 0 : target.closest('.product-block'));
    var _currentDataSet4 = (_wrapper4 === null || _wrapper4 === void 0 ? void 0 : _wrapper4.dataset) || {};
    var valueCents = _currentDataSet4.value;
    price = valueCents !== undefined && valueCents !== '' ? Number(valueCents) / 100 : undefined;
    listId = _currentDataSet4.listId;
    listName = _currentDataSet4.listName;
    productType = _currentDataSet4.productType;
    productId = _currentDataSet4.productId;
    productTitle = _currentDataSet4.productTitle;
    variantSku = _currentDataSet4.variantSku;
    variantTitle = _currentDataSet4.variantTitle;
    variantId = _currentDataSet4.variantId;
    index = _currentDataSet4.index;
  }
  return {
    index: index,
    listId: listId,
    listName: listName,
    price: price,
    productId: productId,
    productTitle: productTitle,
    productType: productType,
    variantId: variantId,
    variantSku: variantSku,
    variantTitle: variantTitle
  };
};

/**
 * 快捷加购点击埋点（GA `eeEvent`）
 *
 * @param {Element} target - 快捷加购按钮
 */
var quickAddToCartTracking = function quickAddToCartTracking(target) {
  var trackingData = getQuickAddToCartData(target);
  if (!trackingData) {
    return undefined;
  }
  var index = trackingData.index,
    listId = trackingData.listId,
    listName = trackingData.listName,
    price = trackingData.price,
    productId = trackingData.productId,
    productTitle = trackingData.productTitle,
    productType = trackingData.productType,
    variantId = trackingData.variantId,
    variantSku = trackingData.variantSku,
    variantTitle = trackingData.variantTitle;
  var data = {
    event: 'eeEvent',
    event_type: 'view_item',
    flow_group: 'none',
    ecommerce: {
      value: price,
      currency: 'USD',
      event_label: 'QuickAdd',
      items: [{
        item_list_id: listId,
        item_list_name: listName,
        item_category: productType,
        item_id: productId,
        item_name: productTitle,
        item_variant: variantSku,
        item_category5: variantSku,
        item_category4: variantId,
        item_brand: variantTitle,
        currency: 'USD',
        price: price,
        index: index,
        quantity: 1
      }]
    }
  };
  window.dataLayer.push({
    ecommerce: null
  }, data);
};
var quickAddToCartProductTracking = function quickAddToCartProductTracking(productData, variantIndex) {
  var data = {
    event: 'eeEvent',
    event_type: 'add_to_cart',
    event_label: productData.title,
    product_id: productData.id,
    ecommerce: {
      value: productData.variants[variantIndex].price / 100,
      currency: 'USD',
      position: variantIndex + 1,
      order_promotion_id: 'none',
      order_promotion_name: 'none',
      items: [{
        item_category: productData.type,
        item_id: productData.id,
        item_name: productData.title,
        item_variant: productData.variants[variantIndex].sku,
        item_category5: productData.variants[variantIndex].sku,
        item_brand: productData.variants[variantIndex].public_title,
        currency: 'USD',
        price: productData.variants[variantIndex].price / 100,
        quantity: 1,
        promotion_id: 'none',
        promotion_name: 'none'
      }]
    }
  };
  window.dataLayer.push({
    ecommerce: null
  }, data);
};
;// CONCATENATED MODULE: ./snippets/original-main-product/quick-add-to-cart/index.js
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }


























function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }






// 单例 Modal 实例
var modalInstance;
// 当前请求的 AbortController
var currentAbortController;
// 存储需要清理的事件监听器引用
var eventCleanupFunctions = [];
// 关闭按钮处理器
var closeButtonHandler;
// 快捷加购内单独打开的尺码表弹窗
var sizeGuideModalInstance;

/**
 * 获取弹窗内真正的购买表单。
 * 商详在没有 buy_buttons 区块时会额外渲染一个隐藏备用表单，不能直接取第一个。
 * @param {Element} root
 * @returns {HTMLFormElement|null}
 */
var getPurchaseForm = function getPurchaseForm(root) {
  var forms = _toConsumableArray(root.querySelectorAll('.product-purchase-form'));
  return forms.find(function (form) {
    return form.querySelector('[name="id"]') && form.querySelector('button[type="submit"], .hete-button-large, .hete-purchase-addCart');
  }) || forms[0] || null;
};
var closeSizeGuideModal = function closeSizeGuideModal() {
  if (!sizeGuideModalInstance) {
    return;
  }
  var modal = sizeGuideModalInstance;
  sizeGuideModalInstance = undefined;
  modal.close({
    isDestory: 'true'
  });
};

/**
 * 快捷加购内容为异步克隆，原页面初始化过的 cc-modal 不会作用于新节点。
 * 这里直接复用克隆内容中的尺码表，在站内打开弹窗，避免 target="_blank" 新开页面。
 * @param {HTMLElement} root
 * @param {AbortSignal} signal
 */
var bindSizeGuideModal = function bindSizeGuideModal(root, signal) {
  root.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) {
      return;
    }
    var sizeChartLink = target.closest('.size-chart-link');
    if (!sizeChartLink || !root.contains(sizeChartLink)) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    var contentSelector = sizeChartLink.dataset.ccModalContentelement;
    var contentContainer = contentSelector ? root.querySelector(contentSelector) : null;
    var sizeChartContent = (contentContainer === null || contentContainer === void 0 ? void 0 : contentContainer.querySelector('.size-chart')) || (contentContainer === null || contentContainer === void 0 ? void 0 : contentContainer.querySelector('.size-chart__inner')) || contentContainer;
    if (!sizeChartContent) {
      new ui_modal/* default */.Z().info('Size guide is unavailable');
      return;
    }
    closeSizeGuideModal();
    var modalContent = sizeChartContent.cloneNode(true);
    Object.assign(modalContent.style, {
      maxHeight: 'min(70vh, 640px)',
      overflow: 'auto',
      overscrollBehavior: 'contain'
    });
    sizeGuideModalInstance = new ui_modal/* default */.Z({
      duration: 0,
      template: modalContent,
      mask: 'true',
      'mobile-placement': 'bottom',
      'pc-placement': 'center'
    });
    sizeGuideModalInstance.create({
      useDefaultTemplate: true,
      title: sizeChartLink.textContent.trim() || 'Size Guide',
      className: 'quick-buy-size-guide-modal'
    });
  }, {
    capture: true,
    signal: signal
  });
};

/**
 * 清理 modal 内容和所有事件监听器
 * 防止内存泄漏
 */
var cleanupModalContent = function cleanupModalContent() {
  var _modalInstance;
  if (!((_modalInstance = modalInstance) !== null && _modalInstance !== void 0 && _modalInstance.node)) {
    return;
  }
  closeSizeGuideModal();

  // 移除调用方挂载的附加节点（如 AI 试戴折扣码横幅）
  var _iterator = _createForOfIteratorHelper(modalInstance.node.querySelectorAll('[data-quick-buy-extra]')),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var extraNode = _step.value;
      extraNode.remove();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var modalInnerElement = modalInstance.node.querySelector('.quick-buy-modal-inner');
  if (!modalInnerElement) {
    return;
  }

  // 1. 清理所有注册的事件监听器
  for (var _i = 0, _eventCleanupFunction = eventCleanupFunctions; _i < _eventCleanupFunction.length; _i++) {
    var cleanup = _eventCleanupFunction[_i];
    try {
      cleanup();
    } catch (error) {
      console.error('Error during event cleanup:', error);
    }
  }
  eventCleanupFunctions = [];

  // 2. 移除内联事件处理器（避免闭包泄漏）
  var elementsWithEvents = modalInnerElement.querySelectorAll('*');
  var _iterator2 = _createForOfIteratorHelper(elementsWithEvents),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var element = _step2.value;
      // 移除所有可能的内联事件处理器
      var eventProperties = Object.keys(element).filter(function (key) {
        return key.startsWith('on');
      });
      var _iterator3 = _createForOfIteratorHelper(eventProperties),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var property = _step3.value;
          element[property] = undefined;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    // 3. 移除所有子节点（比 innerHTML = '' 更彻底）
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  while (modalInnerElement.firstChild) {
    // 直接移除子节点
    modalInnerElement.firstChild.remove();
  }

  // 4. 取消正在进行的请求
  if (currentAbortController) {
    currentAbortController.abort();
    currentAbortController = undefined;
  }
};

/**
 * 完全销毁 modal 实例
 */
var destroyModal = function destroyModal() {
  if (!modalInstance) {
    return;
  }

  // 清理内容
  cleanupModalContent();

  // 清理关闭按钮事件
  if (closeButtonHandler && modalInstance.node) {
    (0,event_handler/* off */.S1)('click', '.quick-buy-modal-clear', closeButtonHandler, {}, modalInstance.node);
    closeButtonHandler = undefined;
  }

  // 关闭并销毁 modal
  modalInstance.close({
    isDestory: 'true'
  });
  modalInstance = undefined;
};

/**
 * 设置关闭按钮事件
 */
var setupCloseButton = function setupCloseButton(modal) {
  closeButtonHandler = function closeButtonHandler() {
    destroyModal();
  };
  (0,event_handler.on)('click', '.quick-buy-modal-clear', closeButtonHandler, {}, modal.node);
};

/**
 * 快捷加购主函数
 * @returns {Promise<StaticModal>} 弹窗实例，供调用方挂载附加内容（带 data-quick-buy-extra 的节点会在清理时移除）
 */
var quickAddToCart = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var _modalInstance2, _modalInstance$node;
    var productUrl, _ref$dataType, dataType, _ref$dataProductKey, dataProductKey, event, onConfirm, onAddSuccess, _handleModalClose;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          productUrl = _ref.productUrl, _ref$dataType = _ref.dataType, dataType = _ref$dataType === void 0 ? '' : _ref$dataType, _ref$dataProductKey = _ref.dataProductKey, dataProductKey = _ref$dataProductKey === void 0 ? '' : _ref$dataProductKey, event = _ref.event, onConfirm = _ref.onConfirm, onAddSuccess = _ref.onAddSuccess;
          // 如果 modal 已存在且正在显示，先清理内容
          if ((_modalInstance2 = modalInstance) !== null && _modalInstance2 !== void 0 && _modalInstance2.node && document.body.contains(modalInstance.node)) {
            cleanupModalContent();
          } else {
            // 创建新的 modal 实例
            modalInstance = new ui_modal/* default */.Z({
              subscribeKey: 'quick-add-to-cart-modal',
              duration: 0,
              template: "<div class=\"quick-buy-modal-content\">\n          <svg class=\"mec-icon quick-buy-modal-clear\" aria-hidden=\"true\">\n            <use xlink:href=\"#mec-guanbi\"></use>\n          </svg>\n          <div class=\"quick-buy-modal-inner\">\n            <mec-spin class=\"quick-buy-modal-spinner\"></mec-spin>\n          </div>\n        </div>",
              mask: 'true',
              'mobile-placement': 'bottom',
              'pc-placement': 'center',
              overlayClassName: dataType === 'cart' ? 'quick-buy-modal modified-variants' : 'quick-buy-modal'
            });
            modalInstance.create();
            setupCloseButton(modalInstance);
          }

          // 监听 modal 关闭事件，清理资源
          _handleModalClose = function handleModalClose(isOpen) {
            if (!isOpen) {
              cleanupModalContent();
              // 移除此监听器
              event_emitter/* default */.Z.off('quick-add-to-cart-modal-open-change', _handleModalClose);
            }
          };
          event_emitter/* default */.Z.on('quick-add-to-cart-modal-open-change', _handleModalClose);

          // 将清理函数也加入队列
          eventCleanupFunctions.push(function () {
            event_emitter/* default */.Z.off('quick-add-to-cart-modal-open-change', _handleModalClose);
          });
          quickAddToCartTracking(event === null || event === void 0 ? void 0 : event.currentTarget);

          // 显示 modal（如果已创建）
          if (modalInstance.uuid && !((_modalInstance$node = modalInstance.node) !== null && _modalInstance$node !== void 0 && _modalInstance$node.querySelector('.mec-modal-container--show'))) {
            modalInstance.show();
          }

          // 创建新的 AbortController
          currentAbortController = new AbortController();
          _context.n = 1;
          return getProductDetailsHtml({
            productUrl: productUrl,
            modal: modalInstance,
            dataType: dataType,
            dataProductKey: dataProductKey,
            onConfirm: onConfirm,
            onAddSuccess: onAddSuccess,
            signal: currentAbortController.signal
          });
        case 1:
          return _context.a(2, modalInstance);
      }
    }, _callee);
  }));
  return function quickAddToCart(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * 获取并渲染产品详情 HTML
 * @param {Object} params - 参数对象
 * @param {string} params.productUrl - 产品 URL
 * @param {StaticModal} params.modal - Modal 实例
 * @param {string} params.dataType - 数据类型
 * @param {string} params.dataProductKey - 产品键
 * @param {Function} [params.onAddSuccess] - 加购成功回调（cart/add.js 返回后触发）
 * @param {AbortSignal} params.signal - 取消信号
 */
var getProductDetailsHtml = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref3) {
    var productUrl, modal, dataType, dataProductKey, onConfirm, onAddSuccess, signal, response, htmlContent, parser, document_, productDetailsElement, productColumnRight, productProgressWrapper, nextSibling, currentSibling, productDetailsClone, _iterator4, _step4, excludedElement, modalInnerElement, _iterator5, _step5, sizeChartLink, quickBuyInteractionController, _iterator6, _step6, animatedElement, productForm, submitButtons, _iterator7, _step7, _button$parentNode, button, cleanButton, productInfoElement, purchaseForm, submitAbortController, variantIdInput, _addCartButton$datase, _productForm$dataset, addCartButton, largeButton, pcButton, disabledContent, paymentButton, isCartType, isAiTryResult, originalAddCartText, applyConfirmButtonStyle, soldOutWarning, updateSoldOutState, productId, productDataElement, _productData$variants, productData, currentVariant, getVariantInput, getProductData, isSubmitting, handleSubmit, purchaseButtonSelector, keepPurchaseButtonsEnabled, handlePurchaseButtonClick, purchaseButtonObserver, _purchaseForm, submitButton, paintConfirmButton, _purchaseForm2, _paymentButton, _modalInnerElement, _t4;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          productUrl = _ref3.productUrl, modal = _ref3.modal, dataType = _ref3.dataType, dataProductKey = _ref3.dataProductKey, onConfirm = _ref3.onConfirm, onAddSuccess = _ref3.onAddSuccess, signal = _ref3.signal;
          if (!(!(modal !== null && modal !== void 0 && modal.node) || !document.body.contains(modal.node))) {
            _context5.n = 1;
            break;
          }
          return _context5.a(2);
        case 1:
          _context5.p = 1;
          _context5.n = 2;
          return fetch(productUrl, {
            signal: signal
          });
        case 2:
          response = _context5.v;
          if (!(!(modal !== null && modal !== void 0 && modal.node) || !document.body.contains(modal.node))) {
            _context5.n = 3;
            break;
          }
          return _context5.a(2);
        case 3:
          if (response.ok) {
            _context5.n = 4;
            break;
          }
          throw new Error("HTTP error! Status: ".concat(response.status));
        case 4:
          _context5.n = 5;
          return response.text();
        case 5:
          htmlContent = _context5.v;
          if (!(!(modal !== null && modal !== void 0 && modal.node) || !document.body.contains(modal.node))) {
            _context5.n = 6;
            break;
          }
          // 立即释放大字符串
          htmlContent = undefined;
          return _context5.a(2);
        case 6:
          parser = new DOMParser();
          document_ = parser.parseFromString(htmlContent, 'text/html'); // 立即释放 htmlContent 大字符串，让 GC 尽早回收
          htmlContent = undefined;
          productDetailsElement = document_.querySelector('original-product-info');
          if (productDetailsElement) {
            _context5.n = 7;
            break;
          }
          // 释放 document_
          document_ = undefined;
          throw new Error('Product details not found');
        case 7:
          // 在 document_ 中完成所有 DOM 清理操作
          productColumnRight = productDetailsElement.querySelector('.product-column-right');
          if (productColumnRight) {
            productProgressWrapper = productColumnRight.querySelector('.product-progress-wrapper');
            if (productProgressWrapper) {
              nextSibling = productProgressWrapper.nextElementSibling;
              while (nextSibling) {
                currentSibling = nextSibling;
                nextSibling = nextSibling.nextElementSibling;
                currentSibling.remove();
              }
              productProgressWrapper.remove();
            }
          }

          // 克隆节点（深拷贝），避免字符串序列化
          productDetailsClone = productDetailsElement.cloneNode(true); // 快捷加购只保留商品购买信息，直接移除物流时效、购物保障、推荐商品等
          // 仅属于商详正文的节点，避免旧站样式重新显示 not-in-quickbuy 内容。
          _iterator4 = _createForOfIteratorHelper(productDetailsClone.querySelectorAll('.not-in-quickbuy, .hete-recommend, .hete-Related-products-title'));
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              excludedElement = _step4.value;
              excludedElement.remove();
            }

            // 立即释放 document_ 和原始节点，让 GC 回收完整的 DOM 树
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          document_ = undefined;
          modalInnerElement = modal.node.querySelector('.quick-buy-modal-inner'); // 最后一次检查 modal 是否仍然有效
          if (!(!modalInnerElement || !(modal !== null && modal !== void 0 && modal.node) || !document.body.contains(modal.node))) {
            _context5.n = 8;
            break;
          }
          return _context5.a(2);
        case 8:
          // 在插入新内容前，先清理旧内容（关键：防止内存泄漏）
          cleanupModalContent();

          // 直接覆盖内容，避免 innerHTML 的字符串操作
          modalInnerElement.replaceChildren(productDetailsClone);

          // 快捷加购克隆出的尺码表链接没有原页面的弹窗事件，统一在站内弹窗展示。
          _iterator5 = _createForOfIteratorHelper(productDetailsClone.querySelectorAll('.size-chart-link'));
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              sizeChartLink = _step5.value;
              sizeChartLink.removeAttribute('target');
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
          quickBuyInteractionController = new AbortController();
          bindSizeGuideModal(modalInnerElement, quickBuyInteractionController.signal);
          eventCleanupFunctions.push(function () {
            quickBuyInteractionController.abort();
          });

          // 弹窗内容是从商品详情页克隆而来，会带上 data-cc-animate / data-cc-animate-delay，
          // 旧站 styles.css 里 .cc-animate-enabled [data-cc-animate]{opacity:0} 会让弹窗内容
          // 一直保持透明（打开空白）。这里移除动画标记并直接标记为已显示。
          _iterator6 = _createForOfIteratorHelper(modalInnerElement.querySelectorAll('[data-cc-animate], [data-cc-animate-delay]'));
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              animatedElement = _step6.value;
              animatedElement.removeAttribute('data-cc-animate');
              animatedElement.removeAttribute('data-cc-animate-delay');
              animatedElement.classList.add('-in');
            }

            // 禁用弹窗中的 history state 功能，避免切换变体时更新 URL
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
          productForm = modalInnerElement.querySelector('.product-form');
          if (productForm) {
            productForm.dataset.enableHistoryState = 'false';
          }

          // 移除弹窗中按钮的 onclick 属性，避免触发 saveSelectedGiveaway 或 detailsPlusGifts
          submitButtons = modalInnerElement.querySelectorAll('button[type="submit"], .hete-button-large, .hete-purchase-addCart');
          _iterator7 = _createForOfIteratorHelper(submitButtons);
          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              button = _step7.value;
              // 移除内联 onclick 属性
              button.removeAttribute('onclick');
              // 清理通过 JavaScript 设置的事件处理器（使用 cloneNode 替换，彻底清除所有事件）
              cleanButton = button.cloneNode(true);
              (_button$parentNode = button.parentNode) === null || _button$parentNode === void 0 || _button$parentNode.replaceChild(cleanButton, button);
            }

            // 在 cloneNode 替换按钮之后初始化变体逻辑，确保首次同步操作的是最终 DOM 节点
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
          if (productForm) {
            try {
              (0,variants/* initFormForModal */.W)(productForm);
            } catch (error) {
              // 变量初始化失败不能阻断下方 form submit 监听，否则快捷加购会表现为点击无反应。
              console.error('Failed to initialize quick add form:', error);
            }
            productInfoElement = modalInnerElement.querySelector('original-product-info');
            if (typeof (productInfoElement === null || productInfoElement === void 0 ? void 0 : productInfoElement.handleResetPrice) === 'function') {
              void productInfoElement.handleResetPrice();
            }
          }

          // 阻止弹窗中表单的默认提交行为，使用 AJAX 方式添加商品
          purchaseForm = getPurchaseForm(modalInnerElement);
          if (purchaseForm) {
            // 使用 AbortController 管理事件监听器
            submitAbortController = new AbortController(); // 监听变体切换，更新弹窗内售罄按钮状态（与 main-product.liquid 原逻辑一致）
            variantIdInput = purchaseForm.querySelector('[name="id"]');
            if (variantIdInput) {
              addCartButton = modalInnerElement.querySelector('.hete-purchase-addCart');
              largeButton = modalInnerElement.querySelector('.hete-button-large');
              pcButton = modalInnerElement.querySelector('.pc_button');
              disabledContent = modalInnerElement.querySelector('.disabled-content');
              paymentButton = modalInnerElement.querySelector('.hete-payment-button');
              isCartType = dataType === 'cart';
              isAiTryResult = dataType === 'aiTryResult';
              originalAddCartText = isCartType ? 'UPDATE' : isAiTryResult ? 'Confirm' : (addCartButton === null || addCartButton === void 0 || (_addCartButton$datase = addCartButton.dataset) === null || _addCartButton$datase === void 0 ? void 0 : _addCartButton$datase.addToCartText) || 'Add to Cart';
              /**
               * Confirm 文案时固定主色背景（!important，压过商详 .button 黑底）
               * @param {HTMLElement | null | undefined} button
               * @returns {void}
               */
              applyConfirmButtonStyle = function applyConfirmButtonStyle(button) {
                var _button$textContent;
                if (!button) return;
                if (String((_button$textContent = button.textContent) !== null && _button$textContent !== void 0 ? _button$textContent : '').trim() !== 'Confirm') return;
                button.classList.add('ai-try-confirm-btn');
                button.style.setProperty('background', '#442F50', 'important');
                button.style.setProperty('background-color', '#442F50', 'important');
                button.style.setProperty('border-color', '#442F50', 'important');
                button.style.setProperty('color', '#FFFFFF', 'important');
              };
              soldOutWarning = function soldOutWarning() {
                new ui_modal/* default */.Z().info('Sorry, this product is sold out and cannot be added to cart');
              };
              updateSoldOutState = function updateSoldOutState(variant) {
                // AI 试戴换款：售罄也不改 Confirm 文案 / 可点状态（不改 display，避免按钮消失）
                if (isAiTryResult) {
                  if (addCartButton) {
                    addCartButton.classList.remove('hete-disabled');
                    addCartButton.textContent = originalAddCartText;
                    applyConfirmButtonStyle(addCartButton);
                  }
                  if (largeButton) {
                    largeButton.classList.remove('variants-disabled');
                    largeButton.textContent = originalAddCartText;
                    applyConfirmButtonStyle(largeButton);
                  }
                  if (pcButton) {
                    pcButton.classList.remove('hete-sold-out');
                  }
                  modalInnerElement.querySelectorAll('.sold-out-button').forEach(function (btn) {
                    btn.classList.remove('variants-disabled', 'hete-disabled');
                    btn.removeAttribute('disabled');
                    btn.textContent = 'Confirm';
                    applyConfirmButtonStyle(btn);
                  });
                  if (disabledContent) {
                    disabledContent.removeEventListener('click', soldOutWarning);
                    disabledContent.style.pointerEvents = 'none';
                  }
                  if (paymentButton) {
                    paymentButton.style.display = 'none';
                  }
                  return;
                }
                var isSoldOut = !variant || !variant.available;
                if (isSoldOut) {
                  if (addCartButton) {
                    addCartButton.classList.add('hete-disabled');
                    addCartButton.classList.remove('ai-try-confirm-btn');
                    addCartButton.textContent = 'SOLD OUT';
                  }
                  if (largeButton) {
                    largeButton.classList.add('variants-disabled');
                    largeButton.classList.remove('ai-try-confirm-btn');
                    largeButton.textContent = 'SOLD OUT';
                  }
                  if (pcButton) {
                    pcButton.classList.add('hete-sold-out');
                  }
                  if (disabledContent) {
                    disabledContent.removeEventListener('click', soldOutWarning);
                    disabledContent.addEventListener('click', soldOutWarning, {
                      signal: submitAbortController.signal
                    });
                  }
                  if (paymentButton) {
                    paymentButton.style.display = 'none';
                  }
                } else {
                  if (addCartButton) {
                    addCartButton.classList.remove('hete-disabled');
                    addCartButton.textContent = originalAddCartText;
                    applyConfirmButtonStyle(addCartButton);
                  }
                  if (largeButton) {
                    largeButton.classList.remove('variants-disabled');
                    largeButton.textContent = originalAddCartText;
                    applyConfirmButtonStyle(largeButton);
                  }
                  if (pcButton) {
                    pcButton.classList.remove('hete-sold-out');
                  }
                  if (disabledContent) {
                    disabledContent.removeEventListener('click', soldOutWarning);
                  }
                  if (paymentButton) {
                    paymentButton.style.display = '';
                  }
                }
              };
              variantIdInput.addEventListener('change', function (event) {
                var _event$detail;
                var variant = (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.variant;
                // 无匹配组合时 variant 为空，也要进入 SOLD OUT 状态并隐藏
                // Dynamic Payment Button，避免仍显示 Buy with Shop。
                updateSoldOutState(variant);
              }, {
                signal: submitAbortController.signal
              });

              // 首次初始化：根据当前选中变体立即更新售罄状态
              productId = productForm === null || productForm === void 0 || (_productForm$dataset = productForm.dataset) === null || _productForm$dataset === void 0 ? void 0 : _productForm$dataset.productId;
              if (productId) {
                try {
                  productDataElement = modalInnerElement.querySelector("#ProductJson-".concat(CSS.escape(String(productId))));
                  if (productDataElement) {
                    productData = JSON.parse(productDataElement.textContent);
                    currentVariant = (_productData$variants = productData.variants) === null || _productData$variants === void 0 ? void 0 : _productData$variants.find(function (v) {
                      return String(v.id) === String(variantIdInput.value);
                    });
                    updateSoldOutState(currentVariant);
                  }
                } catch (error) {
                  console.error('Failed to check initial variant state:', error);
                }
              }
            }
            getVariantInput = function getVariantInput() {
              return purchaseForm.querySelector('[name="id"]') || modalInnerElement.querySelector('.original-selector') || modalInnerElement.querySelector('select[name="id"]');
            };
            getProductData = function getProductData() {
              var _productForm$dataset2;
              var productForm = modalInnerElement.querySelector('.product-form');
              var productId = productForm === null || productForm === void 0 || (_productForm$dataset2 = productForm.dataset) === null || _productForm$dataset2 === void 0 ? void 0 : _productForm$dataset2.productId;
              if (!productId) return undefined;
              try {
                var _productDataElement = modalInnerElement.querySelector("#ProductJson-".concat(CSS.escape(String(productId))));
                if (!(_productDataElement !== null && _productDataElement !== void 0 && _productDataElement.textContent)) return undefined;
                return JSON.parse(_productDataElement.textContent);
              } catch (error) {
                console.error('Failed to check variant availability:', error);
                return undefined;
              }
            };
            isSubmitting = false;
            handleSubmit = function handleSubmit(event) {
              var _variantInput$value, _productData$variants2;
              event === null || event === void 0 || event.preventDefault();
              event === null || event === void 0 || event.stopPropagation();
              event === null || event === void 0 || event.stopImmediatePropagation();
              if (isSubmitting) return;
              var variantInput = getVariantInput();
              var variantId = String((_variantInput$value = variantInput === null || variantInput === void 0 ? void 0 : variantInput.value) !== null && _variantInput$value !== void 0 ? _variantInput$value : '').trim();
              if (!variantId) {
                new ui_modal/* default */.Z().info('Please select product options');
                return;
              }
              var productData = getProductData();
              var currentVariant = productData === null || productData === void 0 || (_productData$variants2 = productData.variants) === null || _productData$variants2 === void 0 ? void 0 : _productData$variants2.find(function (variant) {
                return String(variant.id) === variantId;
              });

              // ProductJson 缺失时仍继续加购，避免集合页快捷加购因埋点数据缺失而静默失效。
              if (dataType !== 'aiTryResult' && productData !== null && productData !== void 0 && productData.variants && (!currentVariant || currentVariant.available === false)) {
                new ui_modal/* default */.Z().info('Sorry, this product is sold out and cannot be added to cart');
                return;
              }

              // AI 试戴换变体：Confirm → onConfirm，不加购（对齐 App buyViewType=aiTryResult）
              if (dataType === 'aiTryResult') {
                if (!currentVariant) {
                  new ui_modal/* default */.Z().info('Please select a style');
                  return;
                }
                try {
                  onConfirm === null || onConfirm === void 0 || onConfirm({
                    selectedVariant: currentVariant,
                    productData: productData,
                    variantId: variantId
                  });
                } finally {
                  modal.close();
                }
                return;
              }
              var formData = new FormData(purchaseForm);
              if (!formData.get('id')) formData.set('id', variantId);
              var submitButton = purchaseForm.querySelector('button[type="submit"]') || modalInnerElement.querySelector('.hete-button-large, .hete-purchase-addCart');
              var originalButtonText = submitButton === null || submitButton === void 0 ? void 0 : submitButton.textContent;
              var resetSubmitButton = function resetSubmitButton() {
                isSubmitting = false;
                if (!submitButton) return;
                submitButton.textContent = dataType === 'cart' ? 'UPDATE' : originalButtonText || 'Add to Cart';
              };
              isSubmitting = true;
              if (submitButton) {
                submitButton.textContent = dataType === 'cart' ? 'UPDATE...' : 'Adding to cart...';
              }
              var readJson = /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(response) {
                  var _t;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.p = _context2.n) {
                      case 0:
                        _context2.p = 0;
                        _context2.n = 1;
                        return response.json();
                      case 1:
                        return _context2.a(2, _context2.v);
                      case 2:
                        _context2.p = 2;
                        _t = _context2.v;
                        return _context2.a(2, {});
                    }
                  }, _callee2, null, [[0, 2]]);
                }));
                return function readJson(_x3) {
                  return _ref5.apply(this, arguments);
                };
              }();
              var addToCart = /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                  var _window$Shopify, _productData$variants3;
                  var cartRoot, response, data, variantIndex, result, cartCount, _t2;
                  return _regenerator().w(function (_context3) {
                    while (1) switch (_context3.p = _context3.n) {
                      case 0:
                        cartRoot = ((_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 || (_window$Shopify = _window$Shopify.routes) === null || _window$Shopify === void 0 ? void 0 : _window$Shopify.root) || '/';
                        _context3.n = 1;
                        return fetch(cartRoot + 'cart/add.js', {
                          method: 'POST',
                          body: formData
                        });
                      case 1:
                        response = _context3.v;
                        _context3.n = 2;
                        return readJson(response);
                      case 2:
                        data = _context3.v;
                        if (response.ok) {
                          _context3.n = 3;
                          break;
                        }
                        throw new Error((data === null || data === void 0 ? void 0 : data.description) || (data === null || data === void 0 ? void 0 : data.message) || 'Network connection failed, please try again');
                      case 3:
                        resetSubmitButton();

                        // 获取当前选中变体的索引
                        variantIndex = -1;
                        if (productData !== null && productData !== void 0 && productData.variants) {
                          variantIndex = productData.variants.findIndex(function (variant) {
                            return String(variant.id) === variantId;
                          });
                        }

                        // 集合页快捷加购弹窗没有 ProductJson 时 productData 为空，
                        // 埋点不能阻断成功提示和弹窗关闭。
                        if (productData !== null && productData !== void 0 && (_productData$variants3 = productData.variants) !== null && _productData$variants3 !== void 0 && _productData$variants3[variantIndex]) {
                          try {
                            quickAddToCartProductTracking(productData, variantIndex);
                          } catch (error) {
                            console.error('Quick add product tracking error:', error);
                          }
                        }
                        try {
                          onAddSuccess === null || onAddSuccess === void 0 || onAddSuccess(data);
                        } catch (error) {
                          console.error('onAddSuccess callback error:', error);
                        }
                        new ui_modal/* default */.Z().info('Successfully added to cart');
                        modal.close();

                        // 如果是 cart 类型或在购物车页面，刷新页面
                        if (!(dataType === 'cart' || window.location.pathname.includes('/cart'))) {
                          _context3.n = 4;
                          break;
                        }
                        window.location.reload();
                        return _context3.a(2, data);
                      case 4:
                        _context3.p = 4;
                        _context3.n = 5;
                        return window.globalFn.getShoppingCartData();
                      case 5:
                        result = _context3.v;
                        cartCount = document.querySelector('.header-index__cart-link__count');
                        if (cartCount) {
                          cartCount.textContent = String(Number(result.item_count));
                        }
                        _context3.n = 7;
                        break;
                      case 6:
                        _context3.p = 6;
                        _t2 = _context3.v;
                        console.error('Failed to update cart count:', _t2);
                      case 7:
                        return _context3.a(2, data);
                    }
                  }, _callee3, null, [[4, 6]]);
                }));
                return function addToCart() {
                  return _ref6.apply(this, arguments);
                };
              }();
              var submit = /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                  var _window$Shopify2, cartRoot, response, data, _t3;
                  return _regenerator().w(function (_context4) {
                    while (1) switch (_context4.p = _context4.n) {
                      case 0:
                        _context4.p = 0;
                        if (!(dataType === 'cart' && dataProductKey)) {
                          _context4.n = 3;
                          break;
                        }
                        cartRoot = ((_window$Shopify2 = window.Shopify) === null || _window$Shopify2 === void 0 || (_window$Shopify2 = _window$Shopify2.routes) === null || _window$Shopify2 === void 0 ? void 0 : _window$Shopify2.root) || '/';
                        _context4.n = 1;
                        return fetch(cartRoot + 'cart/change.js', {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json'
                          },
                          body: JSON.stringify({
                            id: dataProductKey,
                            quantity: 0
                          })
                        });
                      case 1:
                        response = _context4.v;
                        _context4.n = 2;
                        return readJson(response);
                      case 2:
                        data = _context4.v;
                        if (response.ok) {
                          _context4.n = 3;
                          break;
                        }
                        throw new Error((data === null || data === void 0 ? void 0 : data.description) || (data === null || data === void 0 ? void 0 : data.message) || 'Failed to modify the product. Please try again.');
                      case 3:
                        _context4.n = 4;
                        return addToCart();
                      case 4:
                        _context4.n = 6;
                        break;
                      case 5:
                        _context4.p = 5;
                        _t3 = _context4.v;
                        resetSubmitButton();
                        new ui_modal/* default */.Z().info((_t3 === null || _t3 === void 0 ? void 0 : _t3.message) || 'Network connection failed, please try again');
                        console.error('Add to cart error:', _t3);
                      case 6:
                        return _context4.a(2);
                    }
                  }, _callee4, null, [[0, 5]]);
                }));
                return function submit() {
                  return _ref7.apply(this, arguments);
                };
              }();
              void submit();
            }; // 快捷加购不依赖主题 drawer，也不能走按钮原有的 form.submit() 分支。
            // 旧按钮带有 onclick="saveSelectedGiveaway(...)"，原生 form.submit() 不会触发
            // submit 事件，因此这里用原生捕获监听先拦截点击，直接进入本地 cart/add.js 逻辑。
            purchaseForm.noValidate = true;
            purchaseButtonSelector = 'button[type="submit"], .hete-button-large, .hete-purchase-addCart, .hete-main-product-detail';
            keepPurchaseButtonsEnabled = function keepPurchaseButtonsEnabled() {
              if (!document.body.contains(purchaseForm)) return;
              var _iterator8 = _createForOfIteratorHelper(purchaseForm.querySelectorAll(purchaseButtonSelector)),
                _step8;
              try {
                for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                  var button = _step8.value;
                  button.disabled = false;
                  button.removeAttribute('disabled');
                }
              } catch (err) {
                _iterator8.e(err);
              } finally {
                _iterator8.f();
              }
            };
            keepPurchaseButtonsEnabled();
            handlePurchaseButtonClick = function handlePurchaseButtonClick(event) {
              var target = event.target;
              if (!(target instanceof Element)) return;
              var button = target.closest(purchaseButtonSelector);
              if (!button || !purchaseForm.contains(button)) return;
              handleSubmit(event);
            };
            modalInnerElement.addEventListener('click', handlePurchaseButtonClick, {
              capture: true,
              signal: submitAbortController.signal
            });
            purchaseForm.addEventListener('submit', handleSubmit, {
              capture: true,
              signal: submitAbortController.signal
            });
            purchaseButtonObserver = new MutationObserver(keepPurchaseButtonsEnabled);
            purchaseButtonObserver.observe(purchaseForm, {
              childList: true,
              attributes: true,
              attributeFilter: ['disabled'],
              subtree: true
            });
            eventCleanupFunctions.push(function () {
              purchaseButtonObserver.disconnect();
            });

            // 注册清理函数
            eventCleanupFunctions.push(function () {
              submitAbortController.abort();
            });
          }
          // 如果是 cart 类型，将按钮文案改为 UPDATE
          if (dataType === 'cart') {
            _purchaseForm = getPurchaseForm(modalInnerElement);
            if (_purchaseForm) {
              submitButton = _purchaseForm.querySelector('button[type="submit"]');
              if (submitButton) {
                submitButton.textContent = 'UPDATE';
              }
            }
          }

          // AI 试戴换变体：底栏 Confirm，隐藏支付钮（不改动快捷加购样式表）
          if (dataType === 'aiTryResult') {
            /**
             * @param {HTMLElement | null | undefined} button
             * @returns {void}
             */
            paintConfirmButton = function paintConfirmButton(button) {
              if (!button) return;
              button.classList.remove('hete-disabled', 'variants-disabled');
              button.removeAttribute('disabled');
              button.textContent = 'Confirm';
              button.classList.add('ai-try-confirm-btn');
              button.style.setProperty('background', '#442F50', 'important');
              button.style.setProperty('background-color', '#442F50', 'important');
              button.style.setProperty('border-color', '#442F50', 'important');
              button.style.setProperty('color', '#FFFFFF', 'important');
            };
            _purchaseForm2 = getPurchaseForm(modalInnerElement);
            if (_purchaseForm2) {
              paintConfirmButton(_purchaseForm2.querySelector('button[type="submit"]'));
            }
            _paymentButton = modalInnerElement.querySelector('.hete-payment-button');
            if (_paymentButton) {
              _paymentButton.style.display = 'none';
            }
            paintConfirmButton(modalInnerElement.querySelector('.hete-button-large'));
            paintConfirmButton(modalInnerElement.querySelector('.hete-purchase-addCart'));
            // 也覆盖带 hete-main-product-detail 的主按钮
            modalInnerElement.querySelectorAll('.hete-button-large, .hete-main-product-detail, button[type="submit"].button--large').forEach(function (button) {
              paintConfirmButton(button);
            });
            // 售罄专用按钮也刷成 Confirm（不隐藏，避免底栏空白）
            modalInnerElement.querySelectorAll('.sold-out-button').forEach(function (button) {
              paintConfirmButton(button);
            });
            modalInnerElement.querySelectorAll('.disabled-content').forEach(function (el) {
              el.style.pointerEvents = 'none';
              el.onclick = null;
            });
            // sold-out-button 非 submit：点击时走同一套 Confirm → onConfirm
            modalInnerElement.querySelectorAll('.sold-out-button').forEach(function (button) {
              button.addEventListener('click', function (event) {
                event.preventDefault();
                event.stopPropagation();
                var form = getPurchaseForm(modalInnerElement);
                if (form !== null && form !== void 0 && form.requestSubmit) {
                  form.requestSubmit();
                  return;
                }
                form === null || form === void 0 || form.dispatchEvent(new Event('submit', {
                  bubbles: true,
                  cancelable: true
                }));
              }, {
                once: false
              });
            });
          }
          _context5.n = 11;
          break;
        case 9:
          _context5.p = 9;
          _t4 = _context5.v;
          if (!(_t4.name === 'AbortError')) {
            _context5.n = 10;
            break;
          }
          return _context5.a(2);
        case 10:
          console.error('Error fetching product details:', _t4);

          // 发生错误时显示提示并清理
          if (modal !== null && modal !== void 0 && modal.node && document.body.contains(modal.node)) {
            _modalInnerElement = modal.node.querySelector('.quick-buy-modal-inner');
            if (_modalInnerElement) {
              _modalInnerElement.innerHTML = '<mec-empty type="error"></mec-empty>';
            }
          }
        case 11:
          return _context5.a(2);
      }
    }, _callee5, null, [[1, 9]]);
  }));
  return function getProductDetailsHtml(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

/***/ }),

/***/ 29761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   W: function() { return /* binding */ initFormForModal; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56187);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38690);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89228);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84159);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35659);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91270);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13227);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96626);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88646);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48949);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21413);
/* harmony import */ var core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3127);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(59139);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(54134);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(14011);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(86651);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_weak_map_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(84750);
/* harmony import */ var core_js_modules_es_weak_map_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_weak_map_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(11431);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(5735);
/* harmony import */ var core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_web_url_to_json_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(41365);
/* harmony import */ var core_js_modules_web_url_to_json_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_to_json_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_web_url_search_params_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(32904);
/* harmony import */ var core_js_modules_web_url_search_params_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_js__WEBPACK_IMPORTED_MODULE_21__);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }






















/**
 * 商详变体与 URL 同步（独立实现，不依赖 theme.js）。
 *
 * 背景：theme.liquid 中 vendor.min.js / theme.js 已被注释掉，
 * theme.OptionManager.initProductOptions 不会执行，select.original-selector 的值
 * 和所有 [name="id"] 不会在选项切换时被更新。
 *
 * 本文件需完整实现：
 * 1. 监听 .option-selectors 内 radio 的 change → 收集选中项 → 匹配 variant → 更新所有 [name="id"] → 更新 URL。
 * 2. 页面加载/刷新时根据 URL ?variant= 回填 radio 选中态并触发上述流程。
 *
 * 依赖 DOM：
 *   ProductJson-{productId}、.product-form[data-product-id]、
 *   .option-selectors > .option-selector[data-selector-type="listed"] > .opt-btn.js-option（radio）、
 *   select.original-selector、[name="id"]。
 */

var QUERY_KEY_VARIANT = 'variant';

/**
 * 将 variant.id 写入地址栏。
 * @param {number|string} variantId
 */
function updateUrlWithVariantId(variantId) {
  if (!variantId && variantId !== 0) return;
  var url = new URL(window.location.href);
  url.searchParams.set(QUERY_KEY_VARIANT, String(variantId));
  window.history.replaceState({}, '', url.toString());
}

/**
 * 当前选项不存在对应变体时移除地址栏中的旧 variant，避免库存逻辑继续读取上一个变体。
 */
function removeVariantIdFromUrl() {
  var url = new URL(window.location.href);
  if (!url.searchParams.has(QUERY_KEY_VARIANT)) return;
  url.searchParams.delete(QUERY_KEY_VARIANT);
  window.history.replaceState({}, '', url.toString());
}

/**
 * 从 DOM 中 <script id="ProductJson-xxx"> 解析产品 JSON。
 * @param {string} productId
 * @returns {Object|undefined}
 */
function getProductData(productId) {
  var element = document.querySelector('#ProductJson-' + CSS.escape(String(productId)));
  if (!(element !== null && element !== void 0 && element.textContent)) return undefined;
  try {
    return JSON.parse(element.textContent);
  } catch (_unused) {
    return undefined;
  }
}

/**
 * 从 .option-selectors 收集当前所有选中选项值（与 theme initProductOptions 一致）。
 * @param {Element} form - .product-form
 * @returns {string[]}
 */
function collectSelectedOptions(form) {
  var result = [];
  var optionSelectors = form.querySelectorAll('.option-selectors .option-selector');
  var _iterator = _createForOfIteratorHelper(optionSelectors),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var selector = _step.value;
      var selectorType = selector.dataset.selectorType;
      if (selectorType === 'listed') {
        var checked = selector.querySelector('.js-option:checked');
        result.push(checked ? checked.value : '');
      } else {
        var selected = selector.querySelector('.js-option[aria-selected="true"]');
        result.push(selected ? selected.dataset.value || '' : '');
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
}

/**
 * 根据选中选项匹配 variant（与 theme findVariant 一致）。
 * @param {Object[]} variants - product.variants
 * @param {string[]} selectedOptions
 * @returns {Object|undefined}
 */
function matchVariant(variants, selectedOptions) {
  if (!(variants !== null && variants !== void 0 && variants.length) || selectedOptions.length === 0) return undefined;
  var _iterator2 = _createForOfIteratorHelper(variants),
    _step2;
  try {
    var _loop = function _loop() {
        var variant = _step2.value;
        var allMatch = selectedOptions.every(function (opt, index) {
          return variant.options[index] === opt;
        });
        if (allMatch) return {
          v: variant
        };
      },
      _ret;
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _ret = _loop();
      if (_ret) return _ret.v;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return undefined;
}

/**
 * 单变体商品可能不渲染 .option-selectors，此时根据原始 variant select 或唯一变体兜底，
 * 避免把有库存商品误判为无匹配变体并显示 SOLD OUT。
 * @param {Element} form - .product-form
 * @param {Object} productData - 产品 JSON
 * @returns {Object|undefined}
 */
function getVariantWithoutOptionSelectors(form, productData) {
  var _form$querySelector;
  var variants = (productData === null || productData === void 0 ? void 0 : productData.variants) || [];
  var selectedId = (_form$querySelector = form.querySelector('select[name="id"]')) === null || _form$querySelector === void 0 ? void 0 : _form$querySelector.value;
  var selectedVariant = variants.find(function (variant) {
    return String(variant.id) === String(selectedId);
  });
  if (selectedVariant) return selectedVariant;
  if (variants.length === 1) return variants[0];
  return undefined;
}

/**
 * 构建选项可用性状态表：对每个 option index，判断每个 option value 是否存在至少一个可用的 variant。
 * 判断规则：固定当前 option 之前所有已选 option 的值，遍历所有 variants，
 * 若 variant 的前面几个 option 与已选一致且 variant.available === true，则该 option value 可用。
 * 与 theme.js 7335-7419 行逻辑一致。
 *
 * @param {Object} productData - 产品 JSON（含 options、variants）
 * @param {string[]} currentSelectedValues - 当前各 option 的已选值
 * @returns {Array<{name: string, values: Record<string, boolean>}>} 每个 option 的可用性 map
 */
function buildOptionAvailabilityMap(productData, currentSelectedValues) {
  var options = productData.options,
    variants = productData.variants;
  var statusMap = options.map(function (optionName, optionIndex) {
    var values = {};
    var _iterator3 = _createForOfIteratorHelper(variants),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var variant = _step3.value;
        var optValue = variant.options[optionIndex];
        if (values[optValue] === undefined) values[optValue] = false;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    return {
      name: optionName,
      values: values
    };
  });
  var _iterator4 = _createForOfIteratorHelper(statusMap.entries()),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _step4$value = _slicedToArray(_step4.value, 2),
        optionIndex = _step4$value[0],
        entry = _step4$value[1];
      var fixedOptions = currentSelectedValues.slice(0, optionIndex);
      for (var _i = 0, _Object$keys = Object.keys(entry.values); _i < _Object$keys.length; _i++) {
        var optionValue = _Object$keys[_i];
        var fixedWithCurrent = [].concat(_toConsumableArray(fixedOptions), [optionValue]);
        var availableExists = false;
        var _iterator5 = _createForOfIteratorHelper(variants),
          _step5;
        try {
          var _loop2 = function _loop2() {
            var variant = _step5.value;
            var complies = fixedWithCurrent.every(
            // theme 原始逻辑用无类型比较处理 (16 == '16') 的情况
            function (fixed, fixedIndex) {
              return !fixed || String(fixed) === String(variant.options[fixedIndex]);
            });
            if (complies && variant.available) {
              availableExists = true;
              return 1; // break
            }
          };
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            if (_loop2()) break;
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        entry.values[optionValue] = availableExists;
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return statusMap;
}

/**
 * 根据可用性 map，给 .opt-btn 添加/移除 is-unavailable 类名。
 * @param {Element} form - .product-form
 * @param {Array<{name: string, values: Record<string, boolean>}>} statusMap
 */
function applyUnavailableClasses(form, statusMap) {
  var _iterator6 = _createForOfIteratorHelper(statusMap.entries()),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var _step6$value = _slicedToArray(_step6.value, 2),
        optionIndex = _step6$value[0],
        entry = _step6$value[1];
      var optionSelector = form.querySelector(".option-selector[data-option-index=\"".concat(optionIndex, "\"]"));
      if (!optionSelector) continue;
      var values = entry.values;
      for (var _i2 = 0, _Object$entries = Object.entries(values); _i2 < _Object$entries.length; _i2++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
          optionValue = _Object$entries$_i[0],
          isAvailable = _Object$entries$_i[1];
        // listed 类型：.opt-btn
        var radios = optionSelector.querySelectorAll('.opt-btn');
        var _iterator7 = _createForOfIteratorHelper(radios),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var radio = _step7.value;
            if (radio.value === optionValue) {
              radio.classList.toggle('is-unavailable', !isAvailable);
            }
          }

          // dropdown 类型：.cc-select__option
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
        var dropdownOptions = optionSelector.querySelectorAll('.cc-select__option');
        var _iterator8 = _createForOfIteratorHelper(dropdownOptions),
          _step8;
        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var option = _step8.value;
            if (option.dataset.value === optionValue) {
              option.classList.toggle('is-unavailable', !isAvailable);
            }
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
}

/**
 * 激活 Dynamic Payment Button（Buy It Now）。
 * 将 <script class="dynamic-payment-button-template" type="text/template"> 的内容插入 DOM 并调用 Shopify.PaymentButton.init()。
 * 与 theme.js 7297-7311 行逻辑一致，只在第一次有模板标签时执行，之后模板被 remove 不会重复。
 * @param {Element} form - .product-form
 */
function activateDynamicPaymentButton(form) {
  var productDetail = form.closest('.product-detail');
  if (!productDetail) return;
  var templates = productDetail.querySelectorAll('.dynamic-payment-button-template');
  var _iterator9 = _createForOfIteratorHelper(templates),
    _step9;
  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var _window$Shopify;
      var tpl = _step9.value;
      var content = tpl.innerHTML;
      tpl.insertAdjacentHTML('afterend', content);
      tpl.remove();
      if ((_window$Shopify = window.Shopify) !== null && _window$Shopify !== void 0 && _window$Shopify.PaymentButton) {
        window.Shopify.PaymentButton.init();
      }
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }
}

/**
 * 同步 legacy 购买按钮状态。
 *
 * main-product.liquid 同时渲染了 .hete-purchase-addCart 和
 * .hete-button-large，且两者历史上共用了 #hete-button-text。不能再通过
 * ID 更新，否则只会命中第一个隐藏按钮，导致可见按钮一直停留在 SOLD OUT，
 * 随后被 legacy soldOut() 隐藏。
 *
 * @param {Element} form - .product-form
 * @param {Object|null|undefined} variant - 当前匹配变体；无匹配时为空
 */
function updatePurchaseButtonState(form, variant) {
  var isUnavailable = !(variant !== null && variant !== void 0 && variant.available);
  var isInModal = form.dataset.inModal === 'true';
  var shouldShowPurchaseButton = !variant || variant.available || isInModal;
  var buttons = form.querySelectorAll('.hete-purchase-addCart, .hete-button-large');
  var _iterator0 = _createForOfIteratorHelper(buttons),
    _step0;
  try {
    for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
      var button = _step0.value;
      var addToCartText = String(button.dataset.addToCartText || '').trim() || 'ADD TO CART';
      button.textContent = isUnavailable ? 'SOLD OUT' : addToCartText;
      button.classList.toggle('hete-disabled', isUnavailable);
      button.setAttribute('aria-disabled', String(isUnavailable));

      // 快捷加购需要保留可点击状态，以便点击 SOLD OUT 时弹出提示；
      // 商详仍使用原生 disabled 保持原有行为。
      if ('disabled' in button && !isInModal) {
        button.disabled = isUnavailable;
      }
    }
  } catch (err) {
    _iterator0.e(err);
  } finally {
    _iterator0.f();
  }
  var pcButton = form.querySelector('.pc_button');
  if (pcButton) {
    pcButton.classList.toggle('hete-sold-out', isUnavailable);
    if (shouldShowPurchaseButton) {
      // 清理 legacy soldOut() 写入的 display:none。无匹配组合和弹窗售罄
      // 都需要保留 SOLD OUT 按钮，不能让购买区域直接消失。
      pcButton.style.removeProperty('display');
    }
  }
  if (shouldShowPurchaseButton) {
    var submitRow = form.querySelector('.quantity-submit-row__submit');
    submitRow === null || submitRow === void 0 || submitRow.style.removeProperty('display');
  }
  if (isUnavailable) {
    // 无匹配组合没有 variant change 的可售状态，需主动隐藏动态支付，
    // 避免 SOLD OUT 下方仍出现 Buy with Shop / More payment options。
    var paymentButton = form.querySelector('.hete-payment-button');
    var amazonBuyNow = form.querySelector('#amzn-buy-now-wrapper');
    if (paymentButton) paymentButton.style.display = 'none';
    if (amazonBuyNow) amazonBuyNow.style.display = 'none';
  } else if (form.dataset.inModal !== 'true') {
    // 商详恢复有效变体时同步恢复动态支付；快捷加购由自身逻辑区分
    // 普通加购与 AI Try Result，不在这里统一显示。
    var _paymentButton = form.querySelector('.hete-payment-button');
    var _amazonBuyNow = form.querySelector('#amzn-buy-now-wrapper');
    if (_paymentButton) _paymentButton.style.removeProperty('display');
    if (_amazonBuyNow) _amazonBuyNow.style.removeProperty('display');
  }
}
var soldOutLiveChatObservers = new WeakMap();

/**
 * 将客服入口与 #SI_trigger 组合到同一个售罄操作栏。
 * @param {Element} form - .product-form
 * @param {Element} productDetail - .product-detail
 */
function syncSoldOutLiveChat(form, productDetail) {
  var _actionRow;
  if (!form || !productDetail || form.dataset.inModal === 'true') return;
  var soldOutTrigger = productDetail.querySelector('#SI_trigger, .mamba-notify-button');
  var regularButtonRow = form.querySelector('.pc_button:not(.pc_button--sold-out)');
  var liveChatButton = (regularButtonRow === null || regularButtonRow === void 0 ? void 0 : regularButtonRow.querySelector('.pc_button__livechat')) || productDetail.querySelector('.pc_button__livechat');
  var buyButtonsRow = form.querySelector('.buy-buttons-row') || form.closest('.buy-buttons-row');
  var shouldShow = form.dataset.variantSoldOut === 'true' || (buyButtonsRow === null || buyButtonsRow === void 0 ? void 0 : buyButtonsRow.dataset.productAvailable) === 'false';
  var canShowActions = Boolean(soldOutTrigger) && shouldShow;
  if (buyButtonsRow) {
    buyButtonsRow.style.display = canShowActions ? 'none' : '';
  }
  if (soldOutTrigger) {
    soldOutTrigger.style.display = canShowActions ? '' : 'none';
  }
  if (!liveChatButton) return;

  // 清理热更新或旧版本逻辑遗留的重复客服按钮，确保页面最多只有一个。
  var _iterator1 = _createForOfIteratorHelper(productDetail.querySelectorAll('.pc_button__livechat')),
    _step1;
  try {
    for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
      var button = _step1.value;
      if (button !== liveChatButton) button.remove();
    }
  } catch (err) {
    _iterator1.e(err);
  } finally {
    _iterator1.f();
  }
  liveChatButton.classList.remove('pc_button__livechat--soldout-source');
  var actionRow = productDetail.querySelector('[data-sold-out-actions]');
  if (canShowActions && !actionRow) {
    var anchor = (soldOutTrigger === null || soldOutTrigger === void 0 ? void 0 : soldOutTrigger.parentNode) || (buyButtonsRow === null || buyButtonsRow === void 0 ? void 0 : buyButtonsRow.parentNode);
    if (!anchor) return;
    actionRow = document.createElement('div');
    actionRow.className = 'pc_button pc_button--sold-out';
    actionRow.dataset.soldOutActions = '';
    anchor.insertBefore(actionRow, soldOutTrigger || (buyButtonsRow === null || buyButtonsRow === void 0 ? void 0 : buyButtonsRow.nextSibling));
  }
  if (canShowActions) {
    // 复用原始按钮，避免“源按钮 + 克隆按钮”同时进入 DOM。
    if (liveChatButton.parentElement !== actionRow) {
      actionRow.prepend(liveChatButton);
    }
    if (soldOutTrigger && soldOutTrigger.parentElement !== actionRow) {
      actionRow.append(soldOutTrigger);
    }
  } else if (regularButtonRow && liveChatButton.parentElement !== regularButtonRow) {
    // 切回有库存变体时，将客服按钮放回常规购买按钮区域。
    regularButtonRow.prepend(liveChatButton);
  }
  (_actionRow = actionRow) === null || _actionRow === void 0 || _actionRow.classList.toggle('pc_button--sold-out-hidden', !canShowActions);
}

/**
 * #SI_trigger 由第三方脚本延迟插入，插入后同步售罄客服操作栏。
 * @param {Element} form - .product-form
 */
function observeSoldOutLiveChat(form) {
  if (!form || form.dataset.inModal === 'true') return;
  var productDetail = form.closest('.product-detail');
  if (!productDetail || soldOutLiveChatObservers.has(productDetail)) return;
  var sync = function sync() {
    if (!productDetail.querySelector('#SI_trigger, .mamba-notify-button')) return;
    syncSoldOutLiveChat(form, productDetail);
    observer.disconnect();
    soldOutLiveChatObservers.delete(productDetail);
  };
  var observer = new MutationObserver(sync);
  observer.observe(productDetail, {
    childList: true,
    subtree: true
  });
  soldOutLiveChatObservers.set(productDetail, observer);
  sync();
}

/**
 * 根据当前 variant 的库存状态切换购买按钮区域与缺货通知按钮的显示。
 * 已匹配但售罄时：隐藏 .buy-buttons-row，显示 #SI_trigger。
 * 有库存或当前组合无匹配时：显示 .buy-buttons-row，隐藏 #SI_trigger。
 * 无匹配组合由 updatePurchaseButtonState 展示禁用按钮，避免购买区域直接消失。
 * @param {Element} form - .product-form
 * @param {Object} variant - 当前匹配的变体对象
 */
function updateBuyButtonsVisibility(form, variant) {
  if (form.dataset.inModal === 'true') return;
  var productDetail = form.closest('.product-detail');
  if (!productDetail) return;
  var isSoldOut = Boolean(variant && !variant.available);
  form.dataset.variantSoldOut = String(isSoldOut);
  syncSoldOutLiveChat(form, productDetail);
}

/**
 * 根据当前变体将 .variant-visibility-area 内预渲染的模板替换为对应变体的 HTML（与 theme.js updateVariantDeterminedVisibilityAreas 一致）。
 * @param {Element} container - .product-detail 容器
 * @param {Object|null|undefined} variant - 当前匹配的变体对象，无匹配时传 null/undefined 则使用 data-variant-id="" 的模板
 */
function updateVariantDeterminedVisibilityAreas(container, variant) {
  if (!container) return;
  var areas = container.querySelectorAll('.variant-visibility-area');
  var _iterator10 = _createForOfIteratorHelper(areas),
    _step10;
  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var area = _step10.value;
      var children = _toConsumableArray(area.children);
      var _iterator11 = _createForOfIteratorHelper(children),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var child = _step11.value;
          if (child.tagName !== 'SCRIPT') {
            child.remove();
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      var template = variant ? area.querySelector('script[data-variant-id="' + String(variant.id) + '"]') : area.querySelector('script[data-variant-id=""]');
      if (template !== null && template !== void 0 && template.innerHTML) {
        area.insertAdjacentHTML('beforeend', template.innerHTML);
      }
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }
}

/**
 * 核心：收集选中项 → 匹配 variant → 更新所有 [name="id"] → 派发 change → 更新 URL → 更新售罄状态。
 * @param {Element} form - .product-form
 * @param {Object} productData - 产品 JSON
 */
function syncVariantFromOptions(form, productData) {
  var _multiOption$dataset;
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$updateUrl = _ref.updateUrl,
    updateUrl = _ref$updateUrl === void 0 ? true : _ref$updateUrl;
  var selectedOptions = collectSelectedOptions(form);
  var variant = selectedOptions.length > 0 ? matchVariant(productData.variants, selectedOptions) : getVariantWithoutOptionSelectors(form, productData);
  var variantIdString = variant ? String(variant.id) : '';

  // 更新所有 [name="id"]（含 select.original-selector 和 hidden inputs）
  var idInputs = form.querySelectorAll('[name="id"]');
  var _iterator12 = _createForOfIteratorHelper(idInputs),
    _step12;
  try {
    for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
      var input = _step12.value;
      if (String(input.value) !== variantIdString) {
        input.value = variantIdString;
      }
      input.dispatchEvent(new CustomEvent('change', {
        bubbles: true,
        cancelable: false,
        detail: {
          variant: variant,
          selectedOptions: selectedOptions
        }
      }));
    }

    // 更新 URL（仅用户手动切换变体时）
  } catch (err) {
    _iterator12.e(err);
  } finally {
    _iterator12.f();
  }
  if (updateUrl && form.dataset.enableHistoryState === 'true') {
    if (variant) {
      updateUrlWithVariantId(variant.id);
    } else {
      removeVariantIdFromUrl();
    }
  }

  // 更新选项售罄状态（is-unavailable）
  var multiOption = form.querySelector('.option-selectors');
  if ((multiOption === null || multiOption === void 0 || (_multiOption$dataset = multiOption.dataset) === null || _multiOption$dataset === void 0 ? void 0 : _multiOption$dataset.disableUnavailable) === 'true') {
    var statusMap = buildOptionAvailabilityMap(productData, selectedOptions);
    applyUnavailableClasses(form, statusMap);
  }

  // 更新容器状态类名（与 theme updateContainerStatusClasses 一致）
  var container = form.closest('.product-detail');
  if (container) {
    container.classList.toggle('variant-status--unavailable', !(variant !== null && variant !== void 0 && variant.available));
    container.classList.toggle('variant-status--on-sale', Boolean((variant === null || variant === void 0 ? void 0 : variant.available) && variant.compare_at_price > variant.price));
    updateVariantDeterminedVisibilityAreas(container, variant);
  }

  // 激活 Dynamic Payment Button（首次有模板标签时执行）
  activateDynamicPaymentButton(form);

  // 同时更新两个 legacy 购买按钮，避免重复 ID 导致可见按钮状态无法恢复。
  updatePurchaseButtonState(form, variant);

  // 售罄时隐藏购买按钮区域，显示缺货通知按钮；有库存时反之
  updateBuyButtonsVisibility(form, variant);
}

/**
 * 根据 URL ?variant= 回填 radio 选中态 → 触发 syncVariantFromOptions。
 * @param {Element} form - .product-form
 * @param {Object} productData - 产品 JSON
 */
function applyVariantFromUrl(form, productData) {
  var variantId = new URL(window.location.href).searchParams.get(QUERY_KEY_VARIANT);
  if (!variantId) return;
  var variant = (productData.variants || []).find(function (v) {
    return String(v.id) === String(variantId);
  });
  if (!(variant !== null && variant !== void 0 && variant.options)) return;
  var optionSelectors = form.querySelectorAll('.option-selectors .option-selector[data-selector-type="listed"]');
  for (var index = 0; index < variant.options.length; index++) {
    var optionValue = variant.options[index];
    var optElement = optionSelectors[index];
    if (!optElement) continue;
    var radios = optElement.querySelectorAll('.js-option.opt-btn');
    var _iterator13 = _createForOfIteratorHelper(radios),
      _step13;
    try {
      for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
        var radio = _step13.value;
        if (radio.value === optionValue && !radio.checked) {
          radio.checked = true;
          break;
        }
      }
    } catch (err) {
      _iterator13.e(err);
    } finally {
      _iterator13.f();
    }
  }

  // 回填完毕后执行一次同步，保证 [name="id"]、URL 与选中态一致
  syncVariantFromOptions(form, productData);
}

/**
 * 为单个 .product-form 初始化变体逻辑。
 * @param {Element} form - .product-form
 */
function initForm(form) {
  var _form$dataset;
  var productId = (_form$dataset = form.dataset) === null || _form$dataset === void 0 ? void 0 : _form$dataset.productId;
  if (!productId) return;
  var productData = getProductData(productId);
  if (!(productData !== null && productData !== void 0 && productData.variants)) return;

  // 监听 .option-selectors 内任意 change（radio 选中时冒泡）
  var multiOption = form.querySelector('.option-selectors');
  if (multiOption) {
    multiOption.addEventListener('change', function () {
      syncVariantFromOptions(form, productData);
    });
  }

  // 页面加载时根据 URL 回填
  applyVariantFromUrl(form, productData);

  // #SI_trigger 由第三方脚本延迟插入，插入后同步客服入口
  observeSoldOutLiveChat(form);

  // 无论 URL 是否带 variant 参数，都基于当前选中态执行一次同步，
  // 确保 is-unavailable、Dynamic Payment Button、购买按钮状态正确初始化
  syncVariantFromOptions(form, productData, {
    updateUrl: false
  });
}

/**
 * 为弹窗（快捷加购）内的 .product-form 初始化变体逻辑。
 * 与 initForm 的区别：不从 URL 回填变体，直接基于当前 radio 选中态执行首次同步。
 * @param {Element} form - .product-form
 */
function initFormForModal(form) {
  var _form$dataset2;
  var productId = (_form$dataset2 = form.dataset) === null || _form$dataset2 === void 0 ? void 0 : _form$dataset2.productId;
  if (!productId) return;
  var productData = getProductData(productId);
  if (!(productData !== null && productData !== void 0 && productData.variants)) return;
  form.dataset.inModal = 'true';
  var multiOption = form.querySelector('.option-selectors');
  if (multiOption) {
    multiOption.addEventListener('change', function () {
      syncVariantFromOptions(form, productData);
    });
  }
  syncVariantFromOptions(form, productData);
}
function init() {
  function run() {
    var roots = document.querySelectorAll('original-product-info');
    var _iterator14 = _createForOfIteratorHelper(roots),
      _step14;
    try {
      for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
        var root = _step14.value;
        var form = root.querySelector('.product-form[data-product-id]');
        if (form && !form.dataset.variantSyncInited) {
          form.dataset.variantSyncInited = 'true';
          initForm(form);
        }
      }
    } catch (err) {
      _iterator14.e(err);
    } finally {
      _iterator14.f();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // 兼容延迟渲染
  setTimeout(run, 300);
}

init();

/***/ }),

/***/ 12811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56187);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38690);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89228);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84159);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2663);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44350);
/* harmony import */ var core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91270);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13227);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89034);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96626);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88646);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_unscopables_flat_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9815);
/* harmony import */ var core_js_modules_es_array_unscopables_flat_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_unscopables_flat_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48949);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3127);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(37666);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(59139);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(54134);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(14011);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(86651);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(11431);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_web_url_search_params_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(32904);
/* harmony import */ var core_js_modules_web_url_search_params_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(36792);
/* harmony import */ var _utils_type_check__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(41130);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
























/**
 * @param {Object} properties - 配置对象。
 * @param {string[]} properties.ids - 要查找的 DOM 元素的 ID 数组。
 * @param {"node"|"string"} [properties.returnType="string"] - 返回类型，
 *        "node" 表示返回 DOM 节点，"string" 表示返回 outerHTML 字符串。
 * @returns {(HTMLElement|string)[]} - 根据 returnType 返回对应的节点或 HTML 字符串数组。
 */
/**
 * 将 handles 数组按指定大小分割成多个数组
 * @param {string[]} handles - 要分割的 handles 数组
 * @param {number} chunkSize - 每个分块的大小，默认 20
 * @returns {string[][]} - 分割后的二维数组
 */
var chunkArray = function chunkArray(handles) {
  var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  var chunks = [];
  for (var index = 0; index < handles.length; index += chunkSize) {
    chunks.push(handles.slice(index, index + chunkSize));
  }
  return chunks;
};

/**
 * 执行单个 fetch 请求获取产品列表
 * @param {string[]} handlesChunk - 当前分块的 handles 数组
 * @param {Object} parameters - 额外的参数字典
 * @param {string} origin - 当前页面的 origin
 * @returns {Promise<HTMLElement[]>} - 返回产品元素节点数组
 */
var fetchProductChunk = function fetchProductChunk(handlesChunk, parameters, origin) {
  var fetchParameters = new URLSearchParams();
  var base64UrlSafe = (0,_utils_misc__WEBPACK_IMPORTED_MODULE_22__/* .base64UrlEncode */ .rS)(["handle_list===".concat(handlesChunk.join(','))].concat(_toConsumableArray(Object.keys(parameters).filter(function (key) {
    var value = parameters[key];
    return value !== '' && value !== null && value !== undefined;
  }).map(function (key) {
    var value = parameters[key];
    return (0,_utils_type_check__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(value, 'Array') ? "".concat(key, "===").concat(value.join(',')) : "".concat(key, "===").concat(value);
  }))).join('___'));
  fetchParameters.append('sort_by', base64UrlSafe);
  var searchUrl = "".concat(origin, "/collections/unsafe-bytemeta-productmodification-prohibited?").concat(fetchParameters.toString());
  return fetch(searchUrl).then(function (response) {
    return response.text();
  }).then(function (text) {
    var _targetContainer$inne;
    var html = document.createElement('div');
    html.innerHTML = text;
    var targetContainer = html.querySelector('silent-query-product');
    if (!(targetContainer !== null && targetContainer !== void 0 && (_targetContainer$inne = targetContainer.innerHTML) !== null && _targetContainer$inne !== void 0 && _targetContainer$inne.trim())) {
      return [];
    }
    return _toConsumableArray(targetContainer.querySelectorAll('product-card-group-item')).map(function (element) {
      return element.cloneNode(true);
    });
  }).catch(function (error) {
    console.warn('silent-query-product csr error:', error);
    return [];
  });
};
var getProductCardGroupItemList = function getProductCardGroupItemList(properties) {
  var _ref = properties !== null && properties !== void 0 ? properties : {},
    handles = _ref.handles,
    _ref$returnType = _ref.returnType,
    returnType = _ref$returnType === void 0 ? 'string' : _ref$returnType,
    _ref$parameters = _ref.parameters,
    parameters = _ref$parameters === void 0 ? {} : _ref$parameters;
  if (!(0,_utils_type_check__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(handles, 'Array')) {
    return Promise.reject(new Error('handles must be an array'));
  }

  // 如果 handles 为空，直接返回空数组
  if (handles.length === 0) {
    return Promise.resolve([]);
  }
  var origin = window.location.origin;

  // 将 handles 按每 20 个分割成多个数组
  var handlesChunks = chunkArray(handles, 20);

  // 并行执行所有 fetch 请求
  var fetchPromises = handlesChunks.map(function (chunk) {
    return fetchProductChunk(chunk, parameters, origin);
  });
  return Promise.all(fetchPromises).then(function (results) {
    // 将所有结果合并成一个数组
    var allProductBlockElements = results.flat();
    switch (returnType) {
      case 'node':
        {
          return allProductBlockElements;
        }
      default:
        {
          return allProductBlockElements.map(function (element) {
            return element.outerHTML;
          });
        }
    }
  }).catch(function (error) {
    console.warn('silent-query-product csr error:', error);
    return [];
  });
};
/* harmony default export */ __webpack_exports__.Z = (getProductCardGroupItemList);

/***/ }),

/***/ 83050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56187);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38690);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89228);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84159);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2663);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91270);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66066);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13227);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88646);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48949);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11908);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62659);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(59139);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(54134);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(33370);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14011);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(86028);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(86651);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_string_replace_all_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26956);
/* harmony import */ var core_js_modules_esnext_string_replace_all_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_string_replace_all_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(11431);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _definitions__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(64155);
/* harmony import */ var _utils_html__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(37750);
/* harmony import */ var _utils_number_precision__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(69784);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
























var divide = _utils_number_precision__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z.divide,
  minus = _utils_number_precision__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z.minus,
  round = _utils_number_precision__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z.round,
  times = _utils_number_precision__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z.times;
var createFlashSaleLabel = function createFlashSaleLabel(product, variantPrice, dealPrice) {
  var flashSaleLabel = (0,_utils_html__WEBPACK_IMPORTED_MODULE_21__/* .unescapeHtmlAttribute */ .T)("outlet2");
  flashSaleLabel = flashSaleLabel.trim();
  var enableFlashSaleLabelDiscount = "false";
  enableFlashSaleLabelDiscount = enableFlashSaleLabelDiscount.trim();
  if (enableFlashSaleLabelDiscount !== 'true' || !product.tags.includes(flashSaleLabel) || !Number(dealPrice) || !Number(variantPrice) || Number(dealPrice) === Number(variantPrice)) {
    return [];
  }
  var fallLabel = (0,_utils_html__WEBPACK_IMPORTED_MODULE_21__/* .unescapeHtmlAttribute */ .T)("");
  var hasConfiguredIcon = Number("200") > 0;
  var icon = hasConfiguredIcon ? "//za.luvmehair.com/cdn/shop/files/3_f1faa33c-801b-406a-9a69-57b6dcd46106.png?height=12&v=1787137015".trim() : '';
  var hasValidIcon = icon && !/liquid[_ ]error/i.test(icon);
  var iconContent = hasValidIcon ? "<img src=\"".concat(icon, "\" alt=\"flash-sale\" onerror=\"this.remove()\" />") : '';
  var flashSaleReduceAmount = minus(variantPrice, dealPrice);
  var flashSaleRatio = times(divide(flashSaleReduceAmount, variantPrice), 100);
  var flashSaleContent;
  if (fallLabel) {
    var fallLabelList = fallLabel.split(',');
    var _iterator = _createForOfIteratorHelper(fallLabelList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        if (product.tags.includes(item.trim())) {
          flashSaleContent = "-R".concat(Math.floor(flashSaleReduceAmount));
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  flashSaleContent = flashSaleContent || "-".concat(round(flashSaleRatio, 0), "%");
  return [flashSaleContent, iconContent];
};
var createCustomLabel = function createCustomLabel(product) {
  var customProductTagString = (0,_utils_html__WEBPACK_IMPORTED_MODULE_21__/* .unescapeHtmlAttribute */ .T)("cgbogo,SAVE---R900");
  var customProductTagList = customProductTagString.replaceAll('---', ' ').split('///').filter(Boolean);
  var _iterator2 = _createForOfIteratorHelper(customProductTagList),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var item = _step2.value;
      var _item$split = item.split(','),
        _item$split2 = _slicedToArray(_item$split, 2),
        tag = _item$split2[0],
        text = _item$split2[1];
      if (product.tags.includes(tag.trim())) {
        return text;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
};
var createNewLabel = function createNewLabel(product) {
  var showNewLabel = "true";
  showNewLabel = showNewLabel.trim();
  if (showNewLabel === 'true' && product.tags.includes('New')) return 'New';
};
var createProductLabel = function createProductLabel(product, variantPrice, dealPrice) {
  var tagPriority = 'high';
  var _createFlashSaleLabel = createFlashSaleLabel(product, variantPrice, dealPrice),
    _createFlashSaleLabel2 = _slicedToArray(_createFlashSaleLabel, 2),
    labelContent = _createFlashSaleLabel2[0],
    _createFlashSaleLabel3 = _createFlashSaleLabel2[1],
    icon = _createFlashSaleLabel3 === void 0 ? '' : _createFlashSaleLabel3;
  if (!labelContent) {
    labelContent = createCustomLabel(product);
    tagPriority = 'medium';
  }
  if (!labelContent) {
    labelContent = createNewLabel(product);
    tagPriority = 'low';
  }
  return labelContent ? "\n        <span class=\"snippet-product-label snippet-product-label--".concat(tagPriority, "\">\n        ").concat(icon, "\n        <span>").concat(labelContent, "</span>\n        </span>\n    ") : '';
};
window[_definitions__WEBPACK_IMPORTED_MODULE_23__/* .MISCELLANY_PREFIX */ .x7] = Object.assign({}, window[_definitions__WEBPACK_IMPORTED_MODULE_23__/* .MISCELLANY_PREFIX */ .x7] || {}, {
  createProductLabel: createProductLabel
});
/* harmony default export */ __webpack_exports__.Z = (createProductLabel);

/***/ }),

/***/ 45918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56187);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38690);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89228);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91270);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13227);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88646);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48949);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62659);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39574);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43908);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(37666);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59139);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(54134);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14011);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(86651);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(11431);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _definitions__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(64155);
/* harmony import */ var _ui_modal__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(49968);
/* harmony import */ var _utils_event_handler__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(25675);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(19650);
/* harmony import */ var _utils_storage__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(38440);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }

















function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* eslint-disable unicorn/prefer-ternary */





var dialog;
// 提交验证码接口
var _checkCaptcha = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(parameters, password) {
    var response, errorMessage, _window$publicCompone, inputs, _iterator, _step, input, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return (0,_utils_request__WEBPACK_IMPORTED_MODULE_19__/* .heteRequest */ .xC)('/crm/front/shopify/member/checkCaptcha', {
            data: parameters,
            retry: false
          });
        case 1:
          response = _context.v;
          window.__MISCELLANY__.eventEmitter.emit('VERIFICATION_CODE', response.accountActivationUrl, password);
          dialog.close();
          _context.n = 3;
          break;
        case 2:
          _context.p = 2;
          _t = _context.v;
          if (_t.code === 'OTP_EXPIRED' || _t.code === 'OTP_RETRY_LIMIT' || _t.code === 'OTP_ERROR') {
            errorMessage = document.querySelector('.snippets-verification-errorMessage');
            errorMessage.textContent = "".concat(_t.message);
          } else {
            (_window$publicCompone = window.publicComponents) === null || _window$publicCompone === void 0 || _window$publicCompone.openDialog({
              contentText: "\n          <img style=\"width: 60%;margin-top: 16px;\" src=\"https://cdn.shopify.com/s/files/1/2465/8681/files/2ff7a2ade3fdcfab95b0216d9a775d1f.svg?v=1701399848\">\n          <div class=\"error-text\" style=\"color: #000;\">An issue occurred. Please refresh the page or contact us at customercare@luvmehair.com</div>\n        ",
              buttomContentText: "\n          <div class=\"request\" style=\"color: #000;opacity: 0.1;\">request id: <span class=\"requestId\"></span></div>\n        ",
              leftButtonText: 'Cancel',
              rightButtonText: 'Try again',
              class: 'errorModel',
              leftButtonFu: function leftButtonFu(event) {
                document.querySelector('.dialog').style.display = 'none';
              },
              rightButtonFu: function rightButtonFu() {
                document.querySelector('.errorModel .right-button').innerHTML = "<img class=\"loagin-icon\" src=\"https://cdn.shopify.com/s/files/1/0606/8250/2378/files/loading.gif?v=1663901691\" />";
                _checkCaptcha(parameters, password);
              }
            });
            document.querySelector('.errorModel .requestId').textContent = _t.traceId;
            if (!_t.traceId) {
              document.querySelector('.errorModel .request').style.display = 'none';
            }
          }
          // 在验证码验证失败时，清空所有输入框
          inputs = dialog.node.querySelectorAll('.snippets-verification-form input[type="number"]');
          _iterator = _createForOfIteratorHelper(inputs);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              input = _step.value;
              input.value = '';
              input.style.setProperty('border-color', 'red', 'important');
            }

            // 重新检查按钮状态
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          checkButton();
        case 3:
          return _context.a(2);
      }
    }, _callee, null, [[0, 2]]);
  }));
  return function checkCaptcha(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
// 发送验证码接口
var resendCode = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(parame) {
    var spanElement, resCode, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          spanElement = document.querySelector('.snippets-verification-resend');
          _context2.p = 1;
          _context2.n = 2;
          return (0,_utils_request__WEBPACK_IMPORTED_MODULE_19__/* .heteRequest */ .xC)('/crm/front/shopify/member/getActivationUrl', {
            data: parame,
            retry: false
          });
        case 2:
          resCode = _context2.v;
          if (resCode.needCaptcha) {
            Countdown(spanElement);
          }
          _context2.n = 4;
          break;
        case 3:
          _context2.p = 3;
          _t2 = _context2.v;
          spanElement.style.color = 'rgba(174, 122, 181, 0.8)';
          spanElement.textContent = 'Resend code';
          if (_t2.code === 'OTP_RE_CREATE' || _t2.code === 'OTP_IP_LIMIT' || _t2.code === 'OTP_DEVICE_LIMIT') {
            window.publicComponents.messageOpen({
              showIcon: 'false',
              type: 'error',
              content: _t2.message
            });
          }
        case 4:
          return _context2.a(2);
      }
    }, _callee2, null, [[1, 3]]);
  }));
  return function resendCode(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
// 倒计时
var Countdown = function Countdown(spanElement) {
  spanElement.style.color = 'rgba(0, 0, 0, 0.40)';
  // 初始化倒计时
  var countdown = 60;
  spanElement.innerHTML = "Resend code (".concat(countdown, "s)");
  var _updateCountdown = function updateCountdown() {
    countdown--;
    if (countdown > 0) {
      spanElement.textContent = "Resend code (".concat(countdown, "s)");
      setTimeout(_updateCountdown, 1000);
    } else {
      spanElement.style.color = 'rgba(174, 122, 181, 0.8)';
      spanElement.textContent = 'Resend code';
    }
  };
  // 开始倒计时
  setTimeout(_updateCountdown, 1000);
};
var checkButton;
var verificationHtml = "<div class=\"snippets-verification\">\n      <div class=\"snippets-verification-back\">\n        <svg class=\"mec-icon snippets-verification-closure\" aria-hidden=\"true\">\n          <use xlink:href=\"#mec-guanbi1\"></use>\n        </svg>\n        <p class=\"snippets-verification-title\">\n          Fast and secure! Verify your identity with the code from your email.\n        </p>\n        <div class=\"snippets-verification-reacquisition\">\n          <span class=\"snippets-verification-recode\">Didn't get a code?</span>\n          <span class=\"snippets-verification-resend\">Resend code</span>\n        </div>\n        <div class=\"snippets-verification-form\">\n          <input type=\"number\" id=\"code1\" maxlength=\"1\" required>\n          <input type=\"number\" id=\"code2\" maxlength=\"1\" required>\n          <input type=\"number\" id=\"code3\" maxlength=\"1\" required>\n          <input type=\"number\" id=\"code4\" maxlength=\"1\" required>\n        </div>\n        <span class=\"snippets-verification-button\" type=\"button\">Verify</span>\n        <p class=\"snippets-verification-errorMessage\"></p>\n      </div>\n    </div>";
var verificationCode = function verificationCode(memberEmail, password, name) {
  if (name === 'pupop') {
    var _document$querySelect;
    (_document$querySelect = document.querySelector('.login-dialog')) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.closest('.mec-modal-root')) === null || _document$querySelect === void 0 || _document$querySelect.style.setProperty('display', 'none');
  }
  dialog = new _ui_modal__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z({
    duration: 0,
    template: verificationHtml,
    mask: 'true'
  });
  dialog['mask-closable'] = false;
  dialog.create();
  var spanElement = document.querySelector('.snippets-verification-resend');
  Countdown(spanElement);
  // 关闭弹窗
  (0,_utils_event_handler__WEBPACK_IMPORTED_MODULE_18__.on)('click', '.snippets-verification-closure', function () {
    dialog.close();
    if (name === 'pupop') {
      var _document$querySelect2;
      (_document$querySelect2 = document.querySelector('.login-dialog')) === null || _document$querySelect2 === void 0 || (_document$querySelect2 = _document$querySelect2.closest('.mec-modal-root')) === null || _document$querySelect2 === void 0 || _document$querySelect2.style.removeProperty('display');
    }
    window.__MISCELLANY__.eventEmitter.emit('VERIFICATION_CLOSURE');
  }, {}, dialog.node);
  // 重新发送验证码
  (0,_utils_event_handler__WEBPACK_IMPORTED_MODULE_18__.on)('click', '.snippets-verification-resend', function () {
    var spanElement = document.querySelector('.snippets-verification-resend');
    // 判断当前是否已经在请求中
    if (spanElement.textContent.trim() !== 'Resend code') {
      return; // 如果不是 'Resend code'，则直接返回，防止重复触发
    }
    // 添加转圈圈的加载动画
    spanElement.innerHTML = 'Resending...<div class="spinner"></div>';
    document.querySelector('.snippets-verification-errorMessage').textContent = '';
    resendCode({
      customerId: '',
      deviceId: (0,_utils_storage__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)('MAC_CODE').get(),
      memberEmail: sessionStorage.getItem('memberEmail')
    });
  }, {}, dialog.node);

  // 获取所有的输入框和验证按钮
  var inputs = dialog.node.querySelectorAll('.snippets-verification-form input[type="number"]');
  var verifyButton = dialog.node.querySelector('.snippets-verification-button');
  checkButton = function checkButton() {
    // 检查是否所有输入框都有值
    var allFilled = _toConsumableArray(inputs).every(function (input) {
      return input.value.length === 1;
    });
    if (allFilled) {
      // 如果所有输入框都有值，改变按钮背景颜色
      verifyButton.style.backgroundColor = '#473452';
    } else {
      // 如果有输入框为空，恢复按钮默认背景颜色
      verifyButton.style.backgroundColor = 'rgba(71,52,82,0.3)';
    }
  };
  var checkInputs = function checkInputs() {
    var allInput = true;
    var _iterator2 = _createForOfIteratorHelper(inputs),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var input = _step2.value;
        if (input.value.length !== 1) {
          allInput = false;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return allInput;
  };
  // 拼接验证码
  var getCaptchaCode = function getCaptchaCode() {
    var captcha = '';
    var _iterator3 = _createForOfIteratorHelper(inputs),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var input = _step3.value;
        captcha += input.value;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    return captcha;
  };
  // 提交验证码
  (0,_utils_event_handler__WEBPACK_IMPORTED_MODULE_18__.on)('click', '.snippets-verification-button', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
    var allInputsFilled, captcha, style, _t3;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          allInputsFilled = checkInputs();
          if (!allInputsFilled) {
            _context3.n = 5;
            break;
          }
          captcha = getCaptchaCode(); // 禁用按钮，防止重复点击
          verifyButton.disabled = true;
          // 替换按钮内容为加载动画
          verifyButton.innerHTML = '<span class="spinner"></span>';
          // 创建一个简单的 CSS 加载动画（转圈）
          style = document.createElement('style');
          style.innerHTML = "\n          .spinner {\n            border: 3px solid rgba(255, 255, 255, 0.3);\n            border-top: 3px solid white;\n            border-radius: 50%;\n            width: 24px;\n            height: 24px;\n            animation: spin 1s linear infinite;\n            margin: auto;\n            display:inline-block;\n          }\n\n          @keyframes spin {\n            0% { transform: rotate(0deg); }\n            100% { transform: rotate(360deg); }\n          }\n        ";
          document.head.append(style);
          _context3.p = 1;
          _context3.n = 2;
          return _checkCaptcha({
            captcha: captcha,
            customerId: '',
            memberEmail: memberEmail
          }, password);
        case 2:
          _context3.n = 4;
          break;
        case 3:
          _context3.p = 3;
          _t3 = _context3.v;
        case 4:
          _context3.p = 4;
          verifyButton.disabled = false;
          verifyButton.innerHTML = 'Verify';
          return _context3.f(4);
        case 5:
          return _context3.a(2);
      }
    }, _callee3, null, [[1, 3, 4, 5]]);
  })), {}, dialog.node);
  var _iterator4 = _createForOfIteratorHelper(inputs.entries()),
    _step4;
  try {
    var _loop = function _loop() {
      var _step4$value = _slicedToArray(_step4.value, 2),
        index = _step4$value[0],
        input = _step4$value[1];
      input.addEventListener('input', function () {
        if (input.value.length > 1) {
          input.value = input.value.slice(0, 1);
        }

        // 改变输入框的边框颜色
        if (input.value.length === 1) {
          input.style.setProperty('border-color', 'rgba(71,52,82,0.3)', 'important');
        } else {
          input.style.setProperty('border-color', '#473452', 'important');
        }

        // 自动跳转到下一个输入框
        if (input.value.length === 1 && index < inputs.length - 1) {
          inputs[index + 1].focus();
        }
        // 每次输入变化时检查所有输入框
        checkButton();
      });

      // 防止非数字字符的输入
      input.addEventListener('keydown', function (event) {
        if (event.key.length === 1 && !/\d/.test(event.key)) {
          event.preventDefault();
        }

        // 连续删除功能
        if (event.key === 'Backspace' && input.value.length === 0 && index > 0) {
          inputs[index - 1].focus();
          inputs[index - 1].value = ''; // 清空前一个输入框的值
          inputs[index - 1].style.setProperty('border-color', '#473452', 'important');
        }
      });
    };
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
};
window[_definitions__WEBPACK_IMPORTED_MODULE_21__/* .MISCELLANY_PREFIX */ .x7] = Object.assign({}, window[_definitions__WEBPACK_IMPORTED_MODULE_21__/* .MISCELLANY_PREFIX */ .x7] || {}, {
  verificationCode: verificationCode
});
/* harmony default export */ __webpack_exports__.Z = (verificationCode);

/***/ }),

/***/ 10434:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(56187);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(38690);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(89228);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(26031);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(84159);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(13227);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(95822);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(11908);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(39574);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(43908);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(81414);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(37666);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.promise.finally.js
var es_promise_finally = __webpack_require__(44231);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(36763);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(14011);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.weak-set.js
var es_weak_set = __webpack_require__(77991);
// EXTERNAL MODULE: ../node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(11431);
// EXTERNAL MODULE: ./snippets/_/utils/base-custom-elements.js
var base_custom_elements = __webpack_require__(18335);
// EXTERNAL MODULE: ./utils/rIC.js
var rIC = __webpack_require__(24681);
// EXTERNAL MODULE: ./snippets/visible-audience/src/check-customer-status.js + 1 modules
var check_customer_status = __webpack_require__(3323);
;// CONCATENATED MODULE: ./snippets/visible-audience/src/custom-elements.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

















function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }



var _VisibleAudience_brand = /*#__PURE__*/new WeakSet();
var VisibleAudience = /*#__PURE__*/function (_BaseCustomElements) {
  function VisibleAudience() {
    var _this;
    _classCallCheck(this, VisibleAudience);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, VisibleAudience, [].concat(args));
    _classPrivateMethodInitSpec(_this, _VisibleAudience_brand);
    return _this;
  }
  _inherits(VisibleAudience, _BaseCustomElements);
  return _createClass(VisibleAudience, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // eslint-disable-next-line promise/catch-or-return
      _assertClassBrand(_VisibleAudience_brand, this, _setup).call(this).finally(function () {
        (0,rIC/* rIC */.$)(function () {
          if (!_this2.hasAttribute('bypass')) {
            _this2.setAttribute('spin', 'false');
          }
        });
      });
      _assertClassBrand(_VisibleAudience_brand, this, _bindEvents).call(this);
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'bypass' && newValue !== 'true') {
        this.setAttribute('spin', 'false');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['bypass'];
    }
  }]);
}(base_custom_elements/* default */.Z);
function _setup() {
  return _setup2.apply(this, arguments);
}
function _setup2() {
  _setup2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var configStatus, status, parent;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          configStatus = this.getAttribute('status');
          if (configStatus) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          _context.n = 2;
          return (0,check_customer_status/* checkCustomerStatus */.J)();
        case 2:
          status = _context.v;
          if (!(status === configStatus)) {
            _context.n = 3;
            break;
          }
          return _context.a(2);
        case 3:
          if (this.hasAttribute('stylehidden')) {
            parent = this.parentElement;
            if (parent && parent.children.length === 1) {
              parent.remove();
            }
          }
          this.remove();
        case 4:
          return _context.a(2);
      }
    }, _callee, this);
  }));
  return _setup2.apply(this, arguments);
}
function _bindEvents() {}
/* harmony default export */ var custom_elements = (VisibleAudience);
;// CONCATENATED MODULE: ./snippets/visible-audience/index.js

var init = function init() {
  if (customElements.get('visible-audience')) {
    return;
  }
  customElements.define('visible-audience', custom_elements);
};
init();

/***/ }),

/***/ 3323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  J: function() { return /* binding */ checkCustomerStatus; }
});

// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(56187);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(38690);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(39574);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(43908);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(81414);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(37666);
// EXTERNAL MODULE: ./utils/misc.js
var misc = __webpack_require__(36792);
// EXTERNAL MODULE: ./utils/storage.js
var storage = __webpack_require__(38440);
// EXTERNAL MODULE: ./utils/store.js
var store = __webpack_require__(45837);
// EXTERNAL MODULE: ./utils/request/index.js + 4 modules
var request = __webpack_require__(19650);
;// CONCATENATED MODULE: ./snippets/visible-audience/src/api.js






function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

var orderExists = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
    var result, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return (0,request/* heteRequest */.xC)('/oms/front/orderExists', {
            data: data,
            retry: false,
            maxAge: 5 * 60 * 1000
          });
        case 1:
          result = _context.v;
          return _context.a(2, result);
        case 2:
          _context.p = 2;
          _t = _context.v;
          return _context.a(2, {
            traceId: _t.traceId,
            code: _t.code,
            message: _t.message,
            axiosStatus: 'error'
          });
      }
    }, _callee, null, [[0, 2]]);
  }));
  return function orderExists(_x) {
    return _ref.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./snippets/visible-audience/src/check-customer-status.js






function check_customer_status_regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return check_customer_status_regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (check_customer_status_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, check_customer_status_regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, check_customer_status_regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), check_customer_status_regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", check_customer_status_regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), check_customer_status_regeneratorDefine2(u), check_customer_status_regeneratorDefine2(u, o, "Generator"), check_customer_status_regeneratorDefine2(u, n, function () { return this; }), check_customer_status_regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (check_customer_status_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function check_customer_status_regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } check_customer_status_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { check_customer_status_regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, check_customer_status_regeneratorDefine2(e, r, n, t); }
function check_customer_status_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function check_customer_status_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { check_customer_status_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { check_customer_status_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }




var checkCustomerStatus = /*#__PURE__*/function () {
  var _ref = check_customer_status_asyncToGenerator(/*#__PURE__*/check_customer_status_regenerator().m(function _callee() {
    var _storage$get;
    var _ref2, customerEmail, purchasedEmailList, subscribedEmail, result, _result;
    return check_customer_status_regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _ref2 = store/* default */.Z.getState('userInfo') || {}, customerEmail = _ref2.customerEmail;
          purchasedEmailList = ((_storage$get = (0,storage/* default */.Z)('PURCHASED_EMAIL').get()) === null || _storage$get === void 0 ? void 0 : _storage$get.data) || [];
          subscribedEmail = localStorage.getItem('loginEmail');
          if (subscribedEmail) {
            subscribedEmail = (0,misc/* decrypt */.pe)(subscribedEmail, 'ABCD1234');
          }
          if (!customerEmail) {
            _context.n = 3;
            break;
          }
          _context.n = 1;
          return orderExists({
            email: customerEmail
          });
        case 1:
          result = _context.v;
          if (!(result.orderExists === 'TRUE')) {
            _context.n = 2;
            break;
          }
          return _context.a(2, 'RETURNING_CUSTOMERS');
        case 2:
          return _context.a(2, 'NEW_CUSTOMERS');
        case 3:
          if (!(purchasedEmailList.length > 0)) {
            _context.n = 4;
            break;
          }
          return _context.a(2, 'RETURNING_CUSTOMERS');
        case 4:
          if (subscribedEmail) {
            _context.n = 5;
            break;
          }
          return _context.a(2, 'NEW_CUSTOMERS');
        case 5:
          _context.n = 6;
          return orderExists({
            email: subscribedEmail
          });
        case 6:
          _result = _context.v;
          if (!(_result.orderExists === 'TRUE')) {
            _context.n = 7;
            break;
          }
          return _context.a(2, 'RETURNING_CUSTOMERS');
        case 7:
          return _context.a(2, 'NEW_CUSTOMERS');
        case 8:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function checkCustomerStatus() {
    return _ref.apply(this, arguments);
  };
}();

/***/ })

}]);